//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// OrderPage Cleaned - Line Count: 3063 - Remove Count: 2, State Vars Count: 79  - Date: 2023-03-31-10:02 AM
// OrderPage - InteractMenu Order Items - Select Menu Items from a list
//             Created: November 17, 2021
//             Version 1.022 - May 30, 2022 - Horizontal Scroller Added for Categories
//             Version 1.32 - October 24, 2022
//             Version 1.59 - March 31, 2023 - Alternate Item Layouts, Loaded Background Image, Configuration capabilities
//             Version 1.72 - June 12, 2023 - Item Detail - Options and Related Items Popup
//             Version 1.981 - September 17, 2023 - Reformatted Menu with Fixed Header and Footer and Fixed (Single) Detail Popup with Scrolling Options and Related
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React,{ Component,useRef,useState,useEffect } from 'react';
//import { isMobile } from 'react-device-detect'; // test - if isMobile ? true : false;
import './App.css';
import { Popup } from '@progress/kendo-react-popup';
import { Window } from '@progress/kendo-react-dialogs';
import { TreeView } from '@progress/kendo-react-treeview';
import { Grid,GridColumn} from '@progress/kendo-react-grid';
import { ListView,ListViewHeader,ListViewFooter } from '@progress/kendo-react-listview';
import { QRCode } from "@progress/kendo-react-barcodes";
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { Rating } from "@progress/kendo-react-inputs";
import { Avatar } from '@progress/kendo-react-layout';
import { Hint } from "@progress/kendo-react-labels";
import { TextArea } from "@progress/kendo-react-inputs";
import { Input } from '@progress/kendo-react-inputs';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Button } from "@progress/kendo-react-buttons";
import { Switch,MaskedTextBox } from "@progress/kendo-react-inputs";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { BrowserMultiFormatReader } from '@zxing/library'; // Barcode Scanner  
//import { Expand, Slide } from "@progress/kendo-react-animation";
import ScrollMenu from "react-horizontal-scrolling-menu"; // https://github.com/asmyshlyaev177/react-horizontal-scrolling-menu
// https://github.com/asmyshlyaev177/react-horizontal-scrolling-menu/tree/v1 Properties and Callbacks
import PropTypes from "prop-types";
import { withRouter } from './withRouter';
import { ShoppingCart } from './shoppingCart.js';
import { SessionInfo } from './App';
import { CallOM,CallOMT,CTYP,TYP,OMTrace,trace,displayMessage,displayWarning,displayError,CreateKeys,LogOffResetMsg,getImageFileFromServer,imagePrep,NOTIFY,SetNotify,GetTableSearch,GetDropdownData,MaskString,UnmaskString,PingApp } from './CommonCode.js';
import { ENAppCnfg } from './CommonInfo.js';
import { MoneyCell,OrderNumCell,SeatCell,ImageCell } from './CommonFormat.js';
//
import { ReactComponent as MenuBar } from "./images/bars.svg";
//import { ReactComponent as CartAdd } from "./images/cart-plus.svg";
import { ReactComponent as CartAdd } from "./images/purchase.svg";
import { ReactComponent as CartEdit } from "./images/edit.svg";
import { ReactComponent as Favorite } from "./images/star.svg";
import { ReactComponent as FavoriteSelect } from "./images/menu-favorite.svg";
import { ReactComponent as ButtonSearch } from "./images/search.svg";
import { ReactComponent as ButtonClear } from "./images/button-clear.svg";
import { ReactComponent as Promotion } from "./images/menu-promotions.svg";
import { ReactComponent as CirclePlus } from "./images/circle-plus.svg";
import { ReactComponent as DietFlag } from "./images/dietflag.svg";

import { ReactComponent as CartDisplay } from "./images/cart.svg";

const codeReader = new BrowserMultiFormatReader();

//------ Object Definition For StoreItems -- Date: 2024-04-04-1:59 PM ------
const StoreItemsOID = 544619; // NOTE ADDTIONAL COLUMNS; HasOptions , HasRelated  --- NOTE The Values for HasOptions and HasRelated provided in call to GetStoreItem ----
const StoreItemsO = [{ n: 'StoreItemID',t: 195,p: 100 },{ n: 'StoreLocationID',t: 195,p: 100 },{ n: 'ReferenceItemID',t: 195,p: 100 },{ n: 'AssociatedItemID',t: 195,p: 100 },{ n: 'ItemName',t: 21,p: 0 },{ n: 'ItemDescription',t: 21,p: 0 },{ n: 'ItemFullDescription',t: 29,p: 0 },{ n: 'ItemNote',t: 21,p: 0 },{ n: 'ProductItemCategoryID',t: 195,p: 100 },{ n: 'ProductItemGroupID',t: 195,p: 100 },{ n: 'ProductItemTypeID',t: 195,p: 100 },{ n: 'BrandID',t: 195,p: 100 },{ n: 'UPCNumber',t: 21,p: 0 },{ n: 'BarcodeNumber',t: 21,p: 0 },{ n: 'ItemStatusID',t: 195,p: 100 },{ n: 'PackagingTypeID',t: 195,p: 100 },{ n: 'ItemSizeCodeID',t: 195,p: 100 },{ n: 'TotalQuantity',t: 16,p: 0 },{ n: 'TotalNetWeight',t: 16,p: 0 },{ n: 'ReservedQuantity',t: 16,p: 0 },{ n: 'LockedQuantity',t: 16,p: 0 },{ n: 'AvailableQuantity',t: 16,p: 0 },{ n: 'DocumentID',t: 41,p: 0 },{ n: 'ImageID',t: 41,p: 0 },{ n: 'ItemPrice',t: 28,p: 0 },{ n: 'OverridePrice',t: 28,p: 0 },{ n: 'PromotionPrice',t: 28,p: 0 },{ n: 'Promotion2Price',t: 28,p: 0 },{ n: 'PromotionType',t: 201,p: 0 },{ n: 'StorePromotionID',t: 195,p: 100 },{ n: 'ShelfLifeDays',t: 24,p: 0 },{ n: 'ItemNetWeight',t: 16,p: 0 },{ n: 'PricingTypeID',t: 195,p: 100 },{ n: 'TaxableTypeID',t: 195,p: 100 },{ n: 'RateTypeID',t: 195,p: 100 },{ n: 'SeasonCodeID',t: 195,p: 100 },{ n: 'DayOfWeek',t: 201,p: 0 },{ n: 'DaysOfWeek',t: 15,p: 0 },{ n: 'TimeOfDayID',t: 195,p: 100 },{ n: 'WeightUnitsCodeID',t: 195,p: 100 },{ n: 'InventoryControlTypeID',t: 201,p: 0 },{ n: 'StorageControlID',t: 195,p: 100 },{ n: 'ItemControl',t: 15,p: 0 },{ n: 'IngredientsText',t: 21,p: 0 },{ n: 'UsageInstructions',t: 21,p: 0 },{ n: 'Calories',t: 16,p: 0 },{ n: 'StoreInventoryLocationID',t: 195,p: 100 },{ n: 'TotalReceivedQuantity',t: 16,p: 0 },{ n: 'TotalSoldQuantity',t: 16,p: 0 },{ n: 'TotalDisposedQuantity',t: 16,p: 0 },{ n: 'TotalLostQuantity',t: 16,p: 0 },{ n: 'AssociatedItemCount',t: 24,p: 0 },{ n: 'IsRecordActive',t: 22,p: 0 },{ n: 'HasOptions',t: 22,p: 0 },{ n: 'HasRelated',t: 22,p: 0 }];
//       Object Value Definition For StoreItems
const SIV = { 'StoreItemID': 0,'StoreLocationID': 0,'ReferenceItemID': 0,'AssociatedItemID': 0,'ItemName': '','ItemDescription': '','ItemFullDescription': '','ItemNote': '','ProductItemCategoryID': 0,'ProductItemGroupID': 0,'ProductItemTypeID': 0,'BrandID': 0,'UPCNumber': '','BarcodeNumber': '','ItemStatusID': 0,'PackagingTypeID': 0,'ItemSizeCodeID': 0,'TotalQuantity': 0,'TotalNetWeight': 0,'ReservedQuantity': 0,'LockedQuantity': 0,'AvailableQuantity': 0,'DocumentID': '','ImageID': '','ItemPrice': 0,'OverridePrice': 0,'PromotionPrice': 0,'Promotion2Price': 0,'PromotionType': 0,'StorePromotionID': 0,'ShelfLifeDays': 0,'ItemNetWeight': 0,'PricingTypeID': 0,'TaxableTypeID': 0,'RateTypeID': 0,'SeasonCodeID': 0,'DayOfWeek': 0,'DaysOfWeek': 0,'TimeOfDayID': 0,'WeightUnitsCodeID': 0,'InventoryControlTypeID': 0,'StorageControlID': 0,'ItemControl': 0,'IngredientsText': '','UsageInstructions': '','Calories': 0,'StoreInventoryLocationID': 0,'TotalReceivedQuantity': 0,'TotalSoldQuantity': 0,'TotalDisposedQuantity': 0,'TotalLostQuantity': 0,'AssociatedItemCount': 0,'IsRecordActive': false,'HasOptions': false,'HasRelated': false };
//------ Object Definition For CustomOrderItems -- Date: 2024-12-10-7:55 AM ------
const CustomOrderItemsOID = 545113;
const CustomOrderItemsO = [{ n: 'CustomOrderItemID',t: 195,p: 100 },{ n: 'CustomOrderID',t: 195,p: 100 },{ n: 'StoreItemID',t: 195,p: 100 },{ n: 'ReferenceID',t: 195,p: 100 },{ n: 'Quantity',t: 16,p: 0 },{ n: 'Weight',t: 16,p: 0 },{ n: 'Price',t: 28,p: 0 },{ n: 'OptionCount',t: 24,p: 0 },{ n: 'OptionsPrice',t: 28,p: 0 },{ n: 'TotalPrice',t: 28,p: 0 },{ n: 'TaxAmount',t: 28,p: 0 },{ n: 'Tax2Amount',t: 28,p: 0 },{ n: 'Tax3Amount',t: 28,p: 0 },{ n: 'DiscountAmount',t: 28,p: 0 },{ n: 'PromotionCount',t: 24,p: 0 },{ n: 'ReturnReason',t: 201,p: 0 },{ n: 'ReturnQuantity',t: 16,p: 0 },{ n: 'ReturnCycle',t: 24,p: 0 },{ n: 'OriginalQuantity',t: 16,p: 0 },{ n: 'OrderItemStatus',t: 201,p: 0 },{ n: 'SpecialInstruction',t: 21,p: 0 }];
//       Object Value Definition For CustomOrderItems
const COIV = { 'CustomOrderItemID': 0,'CustomOrderID': 0,'StoreItemID': 0,'ReferenceID': 0,'Quantity': 0,'Weight': 0,'Price': 0,'OptionCount': 0,'OptionsPrice': 0,'TotalPrice': 0,'TaxAmount': 0,'Tax2Amount': 0,'Tax3Amount': 0,'DiscountAmount': 0,'PromotionCount': 0,'ReturnReason': 0,'ReturnQuantity': 0,'ReturnCycle': 0,'OriginalQuantity': 0,'OrderItemStatus': 0,'SpecialInstruction': '' };
//       Object Index Definition For CustomOrderItems
const COIX = { 'CustomOrderItemID': 0,'CustomOrderID': 1,'StoreItemID': 2,'ReferenceID': 3,'Quantity': 4,'Weight': 5,'Price': 6,'OptionCount': 7,'OptionsPrice': 8,'TotalPrice': 9,'TaxAmount': 10,'Tax2Amount': 11,'Tax3Amount': 12,'DiscountAmount': 13,'PromotionCount': 14,'ReturnReason': 15,'ReturnQuantity': 16,'ReturnCycle': 17,'OriginalQuantity': 18,'OrderItemStatus': 19,'SpecialInstruction': 20 };

//------ Object Definition For StorePromotions ------  
const StorePromotionsOID = 544701;
const StorePromotionsO = [{ n: 'StorePromotionID',t: 24,p: 100 },{ n: 'StorePromotionName',t: 21,p: 0 },{ n: 'PromotionDescription',t: 21,p: 0 },{ n: 'StoreLocationID',t: 24,p: 100 },{ n: 'StoreGroupID',t: 24,p: 100 },{ n: 'StoreItemID',t: 24,p: 100 },{ n: 'ProductItemCategoryID',t: 24,p: 100 },{ n: 'ProductItemGroupID',t: 24,p: 100 },{ n: 'ProductItemTypeID',t: 24,p: 100 },{ n: 'PromoStoreItemID',t: 24,p: 100 },{ n: 'PromoItemCategoryID',t: 24,p: 0 },{ n: 'DaysForDiscount',t: 24,p: 0 },{ n: 'DiscountAmount',t: 28,p: 0 },{ n: 'DiscountPercentage',t: 23,p: 8 },{ n: 'PromotionPrice',t: 28,p: 0 },{ n: 'PromotionType',t: 201,p: 0 },{ n: 'StartDateTime',t: 35,p: 0 },{ n: 'EndDateTime',t: 35,p: 0 },{ n: 'ImageID',t: 41,p: 0 },{ n: 'PromotionIsActive',t: 22,p: 0 },{ n: 'MaxUseCount',t: 24,p: 0 },{ n: 'UsedCount',t: 24,p: 0 }];
//------ Object Value Definition For StorePromotions ------
let SPV = [{ 'StorePromotionID': 0 },{ 'StorePromotionName': '' },{ 'PromotionDescription': '' },{ 'StoreLocationID': 0 },{ 'StoreGroupID': 0 },{ 'StoreItemID': 0 },{ 'ProductItemCategoryID': 0 },{ 'ProductItemGroupID': 0 },{ 'ProductItemTypeID': 0 },{ 'PromoStoreItemID': 0 },{ 'PromoItemCategoryID': 0 },{ 'DaysForDiscount': 0 },{ 'DiscountAmount': 0 },{ 'DiscountPercentage': 0 },{ 'PromotionPrice': 0 },{ 'PromotionType': 0 },{ 'StartDateTime': 0 },{ 'EndDateTime': 0 },{ 'ImageID': '' },{ 'PromotionIsActive': false },{ 'MaxUseCount': 0 },{ 'UsedCount': 0 }];
//const percentFormat = (value) => new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
const moneyFormat = (value) => new Intl.NumberFormat('en-US',{ style: 'currency',currency: 'USD' }).format(value);
const dateFormat = (value) => new Intl.DateTimeFormat('en-CA',{ dateStyle: 'long',timeStyle: 'short' }).format(Date.parse(value));
//------ Object Definition For Addresses -- Date: 2023-11-28-7:00 PM ------
const AddressesOID = 110191;
const AddressesO = [{ n: 'AddressID',t: 195,p: 100 },{ n: 'CompanyID',t: 195,p: 100 },{ n: 'CustomerID',t: 195,p: 100 },{ n: 'UnitNumber',t: 21,p: 0 },{ n: 'Address',t: 21,p: 0 },{ n: 'Address2',t: 21,p: 0 },{ n: 'City',t: 21,p: 0 },{ n: 'CityID',t: 195,p: 100 },{ n: 'ProvinceStateID',t: 195,p: 100 },{ n: 'PostalCode',t: 21,p: 0 },{ n: 'CountryID',t: 195,p: 100 },{ n: 'PhoneNumber',t: 21,p: 0 },{ n: 'IsPrime',t: 22,p: 0 }];
//       Object Value Definition For Addresses
const AV = { 'AddressID': 0,'CompanyID': 0,'CustomerID': 0,'UnitNumber': '','Address': '','Address2': '','City': '','CityID': 0,'ProvinceStateID': 0,'PostalCode': '','CountryID': 0,'PhoneNumber': '','IsPrime': false };
//       Object Index Definition For Addresses
const AX = { 'AddressID': 0,'CompanyID': 1,'CustomerID': 2,'UnitNumber': 3,'Address': 4,'Address2': 5,'City': 6,'CityID': 7,'ProvinceStateID': 8,'PostalCode': 9,'CountryID': 10,'PhoneNumber': 11,'IsPrime': 12 };

async function asyncForEach(array,callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index],index,array);
  }
}
//
//------------------------------------------------------------------------------------------------------------------------------
// Horizontal Scroll - Don't erase
// https://codesandbox.io/s/v1qqx84o7y
// https://www.tutorialstuff.com/tutorials/horizontal-scrolling-menu-component-for-react-2020
// https://www.npmjs.com/package/react-horizontal-scroll-menu
var menuSelectedKey = 0;
var browserPageHasFocus = false;
var ItemDetailSecondLevel = false;
const MenuItem = ({ text,key,selected }) => {
  //trace(`MenuItem Select - Name: ${text}, selected: ${selected}, Key: ${key}`);
  let select = menuSelectedKey > 0 && selected;
  return <div className={`menu-item ${select ? "active" : ""}`}><div>{text}</div></div>;
};
export const MenuListItems = (list) =>
  list.map(el => {
    //trace(`el.name: ${el.name}, el.key: ${el.key}, el.selected: ${el.selected}`)
    //let obj = { text: el.name, key: el.key, selected: el.selected };
    return <MenuItem text={el.name} key={el.key} selected={el.selected} />;
  });

const Arrow = ({ text,className }) => {
  return (<div className={className}>{text}</div>);
};
Arrow.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

const ArrowLeft = Arrow({ text: '<',className: 'scroll-menu-arrow' });
const ArrowRight = Arrow({ text: '>',className: 'scroll-menu-arrow' });

const StateContext = React.createContext([
  {
    TotalPrice: 0,
    ItemCount: 0,
    SubTotalPrice: 0,
    TotalTaxAmount: 0,
  },
  () => { },
]);

//------------------------------------------------------------------------------------------------------
class OrderPage extends Component {
  constructor(props) {
    super(props);
    if (!SessionInfo || !SessionInfo.session) {
      trace(`no Session on construct`)
      this.props.navigate("/AppMain");
    } else {
      if (SessionInfo.OrderPage && (SessionInfo.CustomOrderID > 0 || SessionInfo.CopyOrderToCurrent == true)) { // Data saved for this session
        this.state = SessionInfo.OrderPage; // Note - this can ONLY be done in the constructor - or at least before any changes are made to state
        trace(`----> Load Existing OrderPage - ResetOrder: ${SessionInfo.ResetOrder}`);
        this.loadExistingPage = true;
      }
      else {
        this.loadExistingPage = false;
      }
      this.createKeys = CreateKeys.bind(this);
      SessionInfo.OrderPageRef = this;
    }
    //trace(`OrderPage construct complete`);
    let visibilityChange;
    if (typeof document.hidden !== "undefined") {
      visibilityChange = "visibilitychange";
    } else if (typeof document.mozHidden !== "undefined") {
      visibilityChange = "mozvisibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      visibilityChange = "webkitvisibilitychange";
    }
    // NOTE - These events continue to trigger even when on a different react page
    document.addEventListener(visibilityChange,this.checkFocus);
    if (!SessionInfo.VisibilityEvent) {
      SessionInfo.VisibilityEvent = true;
      trace(`Order Page - Set visibility event - Change: ${visibilityChange}`);
      window.addEventListener("focus",this.checkFocus);
      window.addEventListener("blur",this.checkFocus);
    } else {
      trace(`visibility Check already SET`);
    }
    //-------- OrderItem Setup --------
    // Create Refs
    this.op0 = React.createRef();
    this.op1 = React.createRef();
    this.op2 = React.createRef();
    this.op3 = React.createRef();
    this.op4 = React.createRef();
    this.op5 = React.createRef();
    this.op6 = React.createRef();
    this.op7 = React.createRef();
    this.op8 = React.createRef();
    this.op9 = React.createRef();
  }
  //------------------------------------------------------------------------------------------------------------------------------
  checkFocus = async () => { // NOTE - These events continue to trigger even when on a different react page
    browserPageHasFocus = document.hasFocus();
    //await OMTrace(0, `OrderPage Check Focus: ${browserPageHasFocus}`);
    //trace(`Check Focus: ${browserPageHasFocus}, MonitorProcess: ${this.runMonitorProcess}`);
    if (browserPageHasFocus === true) {
      this.showFocusTimer = 11;
      if (this.runMonitorProcess === false) {
        this.runMonitorProcess = true;
        this.monitorProcess();
      }
    } else {
      clearTimeout(this.timeout);
      this.runMonitorProcess = false;
    }
  }
  menuAnchor = React.createRef();
  detailAnchor = React.createRef();
  detailOptionAnchor = React.createRef();
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------  
  // State
  state = {
    cartCount: 12,
    ItemCount: 0,
    TotalQuantity: 0,
    //--------------------------------
    CustomOrderID: 0,
    TotalPrice: 0,
    DiscountAmount: 0,
    TotalTaxAmount: 0,
    TotalItemPrice: 0,
    //--------------------------------
    // CustomerAccounts
    SubTotalPrice: 0,
    //
    TableID: 0,
    TableName: '',
    SeatCount: 0,
    SeatName: '',
    SetSeatName: '',
    setName: false,
    QRSeatName: '',
    cancelAllowed: false,
    OrderType: 4, // 1-Delivery, 2-Pickup, 4-OrderInStore, 5-OrderAhead
    orderTypeError: false,
    //--------------------------------
    ItemsList: [],
    TotalBill: 0,
    TotalTip: 0,
    ServiceDescription: '',
    RatingValue: 0,
    StoreName: '',
    stateHasChanged: false,
    showSeatsPopup: false,
    showVerifyCancel: false,
    showBillSummary: false,
    showChangeItems: false,
    chooseItemName: '',
    //---------------------------------
    displayItemDetail: false,
    //---------------------------------
    showQRCode: false,
    showStoreInfo: false,
    showNotify: false,
    HoursForToday: '',
    //--------------------------------
    ItemPrice: 0,
    OptionsPrice: 0,
    Quantity: 1,
    Weight: 0,
    ItemName: '',
    ItemDescription: '',
    ItemFullDescription: '',
    OptionStatus: '',
    showMenu: false,
    SpecialInstruction: '',
    OrderNotes: '',
    ProductItemPhotoURL: undefined,
    DescHeight: 20,
    FullDescHeight: 100,
    //--------------------------------
    // StorePromotions
    PromotionPrice: 0,
    PromotionType: 0,
    // Promotion presentation
    showPromo: false,
    PromotionPhotoURL: undefined,
    //----------------------------------------
    BillCount: 0,
    PaidBills: 0,
    //----------------------------------------
    SeatOrders: [],
    StoreItems: [],
    scrollCatMenuItems: [],
    Categories: [], // Loaded from OM
    catNames: [],
    //CustomOrderTypes: [],
    selectedItems: [], // storeItemID, count, total 
    //----------------------------------------
    translate: false,
    slowdownFactor: false,
    showList: false,
    ItemSelect: 0,
    notifyMessage: '',
    orderMessage: 'Most Recent Item Added & Quantity',
    StoreLocationItemID: 0,
    //----------------------------------------
    OrderItems: [],
    MessagesValue: '',
    //----------------------------------------
    // Horizontal Scroll
    selected: 0,
    //----------------------------------------
    searchValue: '',
    lastSearchValue: '',
    clearSetAll: false,
    itemChanged: false,
    //---------------------------------------- OrderItems State ----------------------------------------  
    StoreItemID: 0,
    ProductItemCategoryID: 0,
    ProductItemGroupID: 0,
    ProductItemTypeID: 0,
    ShelfLifeDays: 0,
    OptionCount: 0,
    ItemStatusID: 0,
    PackagingTypeID: 0,
    PricingTypeID: 0,
    RateTypeID: 0,
    WeightUnitsCodeID: 0,
    StorageControlID: 0,
    ImageID: 0,

    UPCNumber: '',
    BarcodeNumber: '',
    Comments: '',
    scannedString: '',

    SpecialInstruction: '',
    instlength: 0,

    notifyTimer: 0,

    itemFilter: { logic: "and",filters: [] },
    itemSort: [],

    RelatedItems: [],

    SelectItemCategory: false,
    SelectItemGroup: false,
    SelectItemType: false,
    SelectItemStatus: false,
    SelectPackagingType: false,
    SelectPricingType: false,
    SelectRateType: false,
    //--------------------------------
    // StorePromotions
    StorePromotionID: 0,
    StoreLocationID: 0,
    StoreGroupID: 0,
    PromoStoreItemID: 0,
    PromoItemCategoryID: 0,
    DaysForDiscount: 0,
    DiscountPercentage: 0,
    StartDateTime: '',
    EndDateTime: '',
    PromotionIsActive: 0,
    MaxUseCount: 0,
    UsedCount: 0,
    StorePromotionName: '',
    PromotionDescription: '',
    HasOptions: false,
    HasRelated: false,
    //----------------------------------------
    ComboItems: [],
    ProductItemCategories: [],
    ProductItemTypes: [],
    ItemStatusSet: [],
    PackagingTypes: [],
    PricingTypes: [],
    RateTypes: [],
    PromotionTypes: [],
    UOMWeights: [],
    StorageControls: [],
    StoreLocations: [],
    SavedAddressDict: [],
    SavedAddressID: 0,
    //----------------------------------------
    FirstName: '',
    AdditionalName: '',
    LastName: '',
    Address: '',
    Address2: '',
    City: '',
    PostalCode: '',
    PhoneNumber: '',
    ProvinceStateID: 0,
    CountryID: 0,
    //------ Addresses ------
    AddressID: 0,
    CompanyID: 0,
    CustomerID: 0,
    CityID: 0,
    IsPrime: false,
    UnitNumber: '',
    Address: '',
    //------ Menu ------     
    useMenuLayout1: false, // Default
    useMenuLayout2: false,
    useMenuLayout3: false,
    useMenuLayout4: false,
    useMenuLayout5: false,
    useMenuLayout6: false,
    useMenuLayout7: false,
    useMenuLayout8: false,

    useCategoryImages: true,
    useCategoryDesc: true,

    //------ Dictionary Arrays - Addresses ------
    AddressesDict: [],
    CompaniesDict: [],
    CustomersDict: [],
    CitiesDict: [],
    ProvinceStateCodesDict: [],
    CountriesDict: [],

    showInfo: false,
    showInfoChange: false,
    showOption: [false,false,false,false,false,false,false,false,false,false],
    showOptionGrid: [true,true,true,true,true,true,true,true,true,true],
    optionNames: ['','','','','','','','','',''],
    optionStates: ['','','','','','','','','',''],
    optionMultiCnt: [0,0,0,0,0,0,0,0,0,0],
    allowMulti: [false,false,false,false,false,false,false,false,false,false],
    choiceRequired: [false,false,false,false,false,false,false,false,false,false],
    optionChoice: [0,0,0,0,0,0,0,0,0,0],
    optionChoiceCnt: [0,0,0,0,0,0,0,0,0,0],
    optionTotal: [0,0,0,0,0,0,0,0,0,0],
    Options: [[],[],[],[],[],[],[],[],[],[]], // Contains the Option Collections
    isItemChange: false,
    hideOptionImage: false,

    op0bgc: { backgroundColor: SessionInfo.barBack },
    op1bgc: { backgroundColor: SessionInfo.barBack },
    op2bgc: { backgroundColor: SessionInfo.barBack },
    op3bgc: { backgroundColor: SessionInfo.barBack },
    op4bgc: { backgroundColor: SessionInfo.barBack },
    op5bgc: { backgroundColor: SessionInfo.barBack },
    op6bgc: { backgroundColor: SessionInfo.barBack },
    op7bgc: { backgroundColor: SessionInfo.barBack },
    op8bgc: { backgroundColor: SessionInfo.barBack },
    op9bgc: { backgroundColor: SessionInfo.barBack },

    //----------------------------------------
    OrderAtTable: true,
    DeliveryOrder: false,
    OrderForPickup: false,
    OrderAhead: false,
    currentOrderTypeName: 'Order At Table',
    showOrderTypePopup: false,
    showSelectOrderTypePopup: false,
    files: [],
    UploadFile: undefined,
    ImageType: "",
    DocumentTypes: [{ ddName: "jpg",ddID: 1 },{ ddName: "jpeg",ddID: 2 },{ ddName: "png",ddID: 3 }],
    DocumentTypeID: 0,
    //---------------------------------------- OrderItems State ----------------------------------------
  };
  //------------- Local Functions ---------------------------
  percentFormat = (value) => new Intl.NumberFormat('en-US',{ style: 'percent',minimumFractionDigits: 2,maximumFractionDigits: 2 }).format(value);
  moneyFormat = (value) => new Intl.NumberFormat('en-US',{ style: 'currency',currency: 'USD' }).format(value);
  minDate = new Date(2018,9,9);
  //dateFormat = (value) => { Date.parse(this.props.dataItem[this.props.field]) < minDate ? "" : new Intl.DateTimeFormat('en-CA', { dateStyle: 'long', timeStyle: 'short' }).format(Date.parse(this.props.dataItem[this.props.field]))}
  //inputReference = React.createRef();
  StoreItemID = 0;
  CustomOrderItemID = 0;
  createKeys;
  loadExistingPage = false;
  lastSelectedPID = 0;
  barcodeReader = undefined;
  selectedDeviceId = undefined;
  barcode = '';
  fetchCount = 10;
  fetchInProcess = false;
  compUpdate = true;
  comp2Update = true; // Second Level
  showFocusTimer = 0;
  billTimer = 0;
  seatNameSet = false;
  currentOrderChanged = false;
  orderIDForComment = 0;
  keepMenu = false;
  cancelAddClick = false;
  QRCodeLocation = "https://www.telerik.com/kendo-react-ui";
  QRSeatName = "";
  listTopHeight = 200;
  listRowHeight = 110;
  saveTableID = 0;
  // See SessionInfo for cached items, categories, favorites, etc.
  ProductItemGroupID = 0;
  PIG = 0;
  hideItemImage = false;
  stopScroll = false;
  SAVhideItemImage = false;
  imageHeight = 230; // Standard height for the image - does not change
  detailHeaderHeight = 0;
  descAdjust = 0;
  listHeight = 0;
  popupHeight = 0; // The height of the item desc popup
  scrollPopup = false; // This is set to true if item popup is set to shorter than needed
  SAVdetailHeaderHeight = 0;
  SAVlistHeight = 0;
  SAVpopupHeight = 0;
  SAVscrollPopup = false;

  // All items component
  catPosition = 0;
  catRange = 5;
  catStep = 3;
  catCount = 0;
  inAddOrderItem = false;

  testCnt = 0;
  baseHT = 124;
  specHT = 0;
  dispHT = 0;
  msgHT = 0;

  ProductItemGroups = [];
  MenuLayoutID = 0;
  ProductItemCategories = [];
  menuGroup = 1;
  SIVSaveLvl = -1;
  SIVSave = [];

  SAVQuantity = [];
  SAVshowInfo = [];
  SAVshowInfoChange = [];
  SAVshowOption = [];
  SAVshowOptionGrid = [];
  SAVoptionNames = [];
  SAVoptionStates = [];
  SAVoptionMultiCnt = [];
  SAVallowMulti = [];
  SAVchoiceRequired = [];
  SAVoptionChoice = [];
  SAVoptionChoiceCnt = [];
  SAVoptionTotal = [];
  SAVOptions = [];
  SAVRelatedItems = [];

  SAVProductItemPhotoURL = [];
  SAVSpecialInstruction = [];
  SAVOptionsPrice = [];
  SAVPromotionPrice = [];
  SAVisItemChange = [];
  SAVStatus = [];
  SAVTotalPrice = [];
  SAVTotalItemPrice = [];
  SAVItemDescription = [];
  SAVoptionTotal = [];
  SAVdisplayItemDetail = false;
  SAVitemChanged = false;
  SAVdescAdjust = 0;

  popupOffset = { left: 50,top: 70 };
  showSeatOffset = { left: 2,top: 65 };
  showOrderTypeOffset = { left: 2,top: 65 };
  addPopupOffset = { left: 20,top: 65 };
  billPopupOffset = { left: 15,top: 20 };
  itemChangeOffset = { left: 20,top: 65 };
  menuPopupOffset = { left: 200,top: 10 };
  promoPopupOffset = { left: 20,top: 10 };
  addItemDetailPopupOffset = { left: 5,top: 15 };
  showQRPopupOffset = { left: 40,top: 100 };
  //OffsetToUse = 0;
  //OffsetToReturnTo = 0;
  optionCompleteScroll = false;
  backPrompt = '< Back to Locations';
  backMenuPrompt = '< Back to Menu';

  changeRowIdx = 0;

  //---------------------------------------- OrderItems Class Variables ---------------------------------------- 
  op0 = undefined;
  op1 = undefined;
  op2 = undefined;
  op3 = undefined;
  op4 = undefined;
  op5 = undefined;
  op6 = undefined;
  op7 = undefined;
  op8 = undefined;
  op9 = undefined;
  rowHeight = 10;
  rowRender = (trElement,props) => {
    const trProps = {
      style: { maxHeight: '15px',margin: 0,padding: 0 }
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };
  StoreItemTableObjID = 544619;
  ProductOptionsGroupsTableObjID = 545034;
  ProductItemOptionsTableObjID = 545039;
  loadExistingPage = false;
  rolesUpdated = false;
  // Option Control
  optionKeys = [0,0,0,0,0,0,0,0];
  optionNames = ['','','','','','','','','',''];
  optionGroupID = [0,0,0,0,0,0,0,0];
  optionStates = ['','','','','','','','','',''];
  Options = [[],[],[],[],[],[],[],[],[],[]];
  OptionCount = 0;
  OptionElementCount = 0;
  RelatedItemCount = 0;
  ExistQty = 0;
  AllOptionsDone = false;
  LoadFull = false;
  showInfo = false;
  // Save Values
  saveoptionKeys = [];
  SAVoptionNames = [];
  SAVoptionGroupID = [];
  SAVoptionStates = [];
  SAVOptions = [];
  saveOptionCount = 0;
  SAVExistQty = 0;
  SAVAllOptionsDone = false;
  SAVLoadFull = false;
  //
  showOptionsComplete = true;
  setShowNotify = 0;
  topLevelStoreItem = 0;

  //---------------------------------------- OrderItems Class Variables ----------------------------------------
  runMonitorProcess = false;
  // Mount
  async componentDidMount() {
    if (!SessionInfo.session || SessionInfo.session === '')
      return;
    /*window.addEventListener('scroll',this.scrollList);*/  // Add viewport change listeners
    window.addEventListener('resize',this.handleViewportChange);
    window.addEventListener('orientationchange',this.handleViewportChange);
    window.visualViewport?.addEventListener('resize',this.handleViewportChange);
    window.visualViewport?.addEventListener('scroll',this.handleViewportChange);
    // Handle virtual keyboard on mobile
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize',() => {
        const viewportHeight = window.visualViewport.height;
        document.documentElement.style.setProperty('--viewport-height',`${viewportHeight}px`);
        if (this.state.displayItemDetail) {
          this.handleViewportChange();
        }
      });
    }
    this.compUpdate = true;
    this.comp2Update = true;
    try {
      trace(`----> OrderPage Did Mount - existing: ${this.loadExistingPage}, reset: ${SessionInfo.ResetOrder}, defaultLogon: ${SessionInfo.defaultLogon}, restart: ${SessionInfo.Restart}, loadexisting: ${this.loadExistingPage}, RoleID: ${SessionInfo.PersonInfo.RoleID}`);
      trace(`      Width: ${SessionInfo.Width}, Height: ${SessionInfo.Height}, userID: ${SessionInfo.OMUserID},  personID: ${SessionInfo.PersonInfo.CustomerID}, OrderID: ${SessionInfo.CustomOrderID}, StoreLocationID: ${SessionInfo.StoreLocationID} `);
      ItemDetailSecondLevel = false;
      SessionInfo.currentPage = "OrderPage";
      SessionInfo.setLocationFunc = this.setLocation;
      //SessionInfo.height = window.innerHeight; // Window Height, Screen Height - not always set properly   
      SessionInfo.height = window.visualViewport.height; // Window Height, Screen Height - not always set properly
      const offsetTop = window.visualViewport.offsetTop;
      this.compUpdate = false;
      this.lastCategory = "";
      if (SessionInfo.ResetOrder === true && this.state.StoreItems.length === 0) {
        trace(`ResetOrder Incorrect!`);
        await this.resetOrder(); // Just to be safe  
        SessionInfo.ResetOrder = false; // Turn off - I believe that this was getting set in LogOff - which was in error 
      }
      if (this.ProductItemGroupID === 0) {
        let CD = await CallOM("GetDefaultProductItemGroup",0,SessionInfo.StoreLocationID,0);
        if (CD.x.o < 9500 && CD.d) {
          this.ProductItemGroupID = parseInt(CD.x.p);
          this.ProductItemGroups = CD.d.rows;
        }
        this.PIG = this.ProductItemGroupID;
        trace(`----> ProductItemGroupID: ${this.ProductItemGroupID}`);
        trace(`Groups: ${JSON.stringify(this.ProductItemGroups)}`); // This shows the Menu Groupings based on ProductItemGroup
      }
      if (SessionInfo.ResetOrder === true) {
        SessionInfo.firstOrderComplete = true;
        await this.resetOrder();
        trace(`======== Added 23May24 - reset Order - fetchTableInfo`);
        await this.fetchTableInfo(); // Setup Initial Table Info
        this.runMonitorProcess = true;
        //SessionInfo.PauseOPMonitor = false;
      } else { // Otherwise - normal entry or normal return from ItemSelection - or from Receipt Selection
        trace(`mount - AfterSignIn: ${SessionInfo.AfterSignIn}, Restart: ${SessionInfo.Restart}, CopyOrder: ${SessionInfo.CopyOrderToCurrent}, CustomOrderID: ${SessionInfo.CustomOrderID}`)
        if (SessionInfo.AfterSignIn === true) {
          SessionInfo.AfterSignIn = false;
          if (SessionInfo.CustomOrderID > 0) {
            if (this.state.StoreItems.length === 0) { // Added 27Feb25 - needs testing
              trace(`--> Active Order Found: ${SessionInfo.CustomOrderID}`);
              if (this.state.Categories.length === 0) { // Add 4Dec23 - Categories and Items were not getting loaded if existing order??
                await this.loadCategories(this.ProductItemGroupID); // One time load of Categories 
              }
              this.setState({ selectedItems: undefined });
              this.clearSearch();
              await this.loadItems(this.ProductItemGroupID);
            }
            if (this.state.StoreItems.length > 0) {
              let CD = await CallOM("SwitchCustomer",0,SessionInfo.CustomOrderID,0);
              let CustomerID = CD.d;
              this.setState({ CustomerID });
              this.loadExistingPage = true;
            } else { // Note - cant load existing if storeitems not loaded yet 
              SessionInfo.CustomOrderID = 0;
              let CD = await CallOM("CancelOrder",0,SessionInfo.CustomOrderID,0); // 27Feb25 - This is temporary - the items are not loading
              await this.clearOrderInfo(); // This will also Load the Menu Items
            }
          }
        } else if (SessionInfo.Restart === true) {
          SessionInfo.Restart = false;
          if (SessionInfo.CustomOrderID > 0) { // Check Order Status
            let CD = await CallOM("GetCustomOrderItems",0,SessionInfo.CustomOrderID,0);
            trace(`GetCustomOrderItems CD.o: ${CD.x.o}  d: ${JSON.stringify(CD)}`);
            if (CD.x.o < 9500) {
              row = CD.d;
              if (row.CustomOrderStatus >= 12) {
                SessionInfo.CustomOrderID = 0;
                await this.clearOrderInfo(); // This will also Load the Menu Items
              }
            }
            else
              SessionInfo.CustomOrderID = 0;
          }
        } else if (SessionInfo.CopyOrderToCurrent === true) {
          if (SessionInfo.CustomOrderID === 0) { // If Copy to Current - And no current OrderID - Create one - the Copy happens below
            await this.addOrder();
            trace(`New Order: ${SessionInfo.CustomOrderID}`);
            //this.state = SessionInfo.OrderPage;
            this.loadExistingPage = true;
          }
        } else if (this.loadExistingPage === false && SessionInfo.CustomOrderID === 0 && this.state.StoreItems.length > 0) {
          // Fresh Load - check if customer has outstanding order
          //trace(`===> Check for Existing Order`);
          let CD = await CallOM("GetCustomOrderIDActive",0,0,0);
          trace(`-> OrderPage - GetCustomOrderIDActive CD: ${JSON.stringify(CD)}, SessionInfo.CustomOrderID: ${SessionInfo.CustomOrderID}`);
          if (CD.d && CD.d !== 0) {
            SessionInfo.CustomOrderID = CD.d;
            if (SessionInfo.CustomOrderID > 0) {
              trace(`--> Active Order Found: ${SessionInfo.CustomOrderID}`);
              if (this.state.Categories.length === 0) { // Add 4Dec23 - Categories and Items were not getting loaded if existing order??
                await this.loadCategories(this.ProductItemGroupID); // One time load of Categories
                this.setState({ selectedItems: undefined });
                this.clearSearch();
                await this.loadItems(this.ProductItemGroupID);
              }
              this.addCheckForCurrentOrder();
              this.loadExistingPage = true; // This should cause getCurrentTotal to be executed
            }
          }
        }
        trace(`=======> loadExistingPage: ${this.loadExistingPage}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
        if (this.loadExistingPage === true && SessionInfo.CustomOrderID > 0) {
          trace(`--> Load Existing - OrderID: ${SessionInfo.CustomOrderID}, CustomerID: ${this.state.CustomerID},${SessionInfo.PersonInfo.CustomerID} RefreshOrder: ${SessionInfo.RefreshOrder}, Key: ${menuSelectedKey}`);
          this.closePopups(0);
          if (SessionInfo.RefreshOrder === true) {
            SessionInfo.RefreshOrder = false;
            this.setState({ selectedItems: [] });
            let StoreItems = this.state.StoreItems.slice();
            StoreItems.forEach(item => {
              item.IsSelected = false;
            });
            this.setState({ StoreItems });
          }
          if (SessionInfo.CopyOrderToCurrent == true && SessionInfo.CopyCustomOrderID > 0) {
            try { // Copy OrderItems to Current Order - Note that this may be a New Order
              trace(`Add Receipt Items from OrderID: ${SessionInfo.CopyCustomOrderID}`);
              let CD = await CallOM("CopyReceiptToCurrentOrder",SessionInfo.CopyCustomOrderID,SessionInfo.CustomOrderID,0);
              if (CD.x.o === 0)
                await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
              else if (CD.x.o < 9500) {
                trace(`CopyReceiptToCurrentOrder CD.o: ${CD.x.o}  d: ${JSON.stringify(CD)}`);
              }
            } catch (error) {
              trace(`CopyOrderToCurrent Error: ${error}`,5);
              trace(`Reset: ${SessionInfo.ResetOrder}, loadExistingPage: ${this.loadExistingPage}`,5)
            }
          }
          SessionInfo.CopyOrderToCurrent = false;
          SessionInfo.CopyCustomOrderID = 0;
          //this.forceUpdate();
          this.setState({ TableID: SessionInfo.CurrentTableID });
          this.setState({ TableName: SessionInfo.CurrentTableName });
          this.setState({ SeatCount: SessionInfo.SeatCount });
          //--- Load Existing Order -----
          //trace(`===> Load Existing OrderID: ${SessionInfo.CustomOrderID}, TableName: ${this.state.TableName}, TableID: ${SessionInfo.CurrentTableID}, SeatCount: ${SessionInfo.SeatCount}`);
          await this.getCurrentTotal();
          trace(`load (1) - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
        } //--------------------------------------------------------------------------------------------------------------------------------------------------------------
        else { // Fresh start (as in startup) - create new Order 
          trace(`---> Fresh Start - Clear Order and LoadItems`);
          this.setState({ TableID: SessionInfo.CurrentTableID });
          this.setState({ TableName: SessionInfo.CurrentTableName });
          this.setState({ SeatCount: 0 });
          trace(`--> Fresh Load - OrderID: ${SessionInfo.CustomOrderID}, StoreLocationID: ${SessionInfo.StoreLocationID}, TableID: ${SessionInfo.CurrentTableID}, TableName: ${SessionInfo.CurrentTableName}`);
          this.lastSelectedPID = SessionInfo.PersonInfo.CustomerID;
          SessionInfo.BillPaymentDone = false; // Don't show the Summary Popup
          SessionInfo.BillPaymentComplete = true; // Reset the order
          SessionInfo.firstOrderComplete = true;
          let customOrderID = SessionInfo.CustomOrderID;
          await this.resetOrder(); // NOTE: Reset, Clear and LoadItems
          SessionInfo.CustomOrderID = customOrderID;
          trace(`--> After Fresh Load - OrderID: ${SessionInfo.CustomOrderID}, StoreLocationID: ${SessionInfo.StoreLocationID}, TableID: ${SessionInfo.CurrentTableID}, TableName: ${SessionInfo.CurrentTableName}`);
        }
      }
      trace(`=========== set order menu layout: ${SessionInfo.DefaultMenuLayout}`);
      this.setMenuLayout(SessionInfo.DefaultMenuLayout); // Set Default Menu Layout
      this.compUpdate = true; // Turn on UI Updates
      this.forceUpdate();
      browserPageHasFocus = true;
      SessionInfo.PauseOPMonitor = false;
      trace(`=================================================================== fetchTableInfo`);
      await this.fetchTableInfo(); // Get Initial Information for Order and Table 
      if (SessionInfo.HoursForToday === '') {
        try {
          let CD = await CallOM("GetStoreHoursOfOperationForToday",0,SessionInfo.StoreLocationID,0);
          SessionInfo.HoursForToday = CD.d.toString();
        }
        catch (Ex) {
          await OMTrace(2,`Failure in GetStoreHoursOfOperationForToday - Error: ${Ex}`);
        }
        trace(`Hours For Today: ${SessionInfo.HoursForToday}`);
        await this.setState({ HoursForToday: SessionInfo.HoursForToday });
      }
      this.showLocationHours();
      if (menuSelectedKey !== 0) {
        trace(`-- selectedKey: ${menuSelectedKey} `);
        let setKey = menuSelectedKey;
        this.setState({ selected: setKey });
        menuSelectedKey = setKey; // Setting menuSelectedKey should highlight the category? But does not - MenuItem needs to be invoked
        let menuItm = SessionInfo.catNames[this.PIG].find(p => p.key == setKey)
        if (menuItm) {
          trace(`menuItm: ${JSON.stringify(menuItm)}`);
          menuItm.selected = true;
        }
        trace(`reload Menu - PIG: ${this.PIG} - catNames: ${JSON.stringify(SessionInfo.catNames[this.PIG])}`);
        let scrollCatMenuItems = MenuListItems(SessionInfo.catNames[this.PIG].slice(0,SessionInfo.catNames[this.PIG].length));
        trace(`Load - scrollCatMenuItems: ${JSON.stringify(scrollCatMenuItems)}`);
        this.setState({ scrollCatMenuItems });
      }
      //trace(`----After Audio --------------------------------`);
      //trace(this.bellSound);
      //----- Testing -----
      //trace(`Testing`);
      //try {
      //  InitScriptX();
      //  TestScriptX();
      //}
      //catch (e) {
      //  trace(`unable to execute InitScriptX - msg: ${e}`);
      //}
      //trace(`Test Bambora Checkout`);
      //try {
      //  trace(`execute custom Checkout `);
      //  var customCheckout = customcheckout();
      //  var cardNumber = customCheckout.create('card-number')
      //  cardNumber.mount('#card-number');
      //  trace(`after card-number mount `);
      //  customCheckout.on('error', function (event) {
      //    if (event.field === 'card-number') {
      //      trace('Card number has errors: ' + JSON.stringify(event));
      //    } else if (event.field === 'cvv') {
      //      trace('CVV has errors: ' + JSON.stringify(event));
      //    } else if (event.field === 'expiry') {
      //      trace('Expiry has errors: ' + JSON.stringify(event));
      //    }
      //  });

      //  customCheckout.on('complete', function (event) {
      //    if (event.field === 'card-number') {
      //      trace('Card number is complete: ' + JSON.stringify(event));
      //    } else if (event.field === 'cvv') {
      //      trace('CVV is complete: ' + JSON.stringify(event));
      //    } else if (event.field === 'expiry') {
      //      trace('Expiry is complete: ' + JSON.stringify(event));
      //    }
      //  });
      //}
      //catch (e) {
      //  trace(`unable to execute CustomCheckout in monitor - msg: ${e}`);
      //}
      //--------------------------------------------------
    } catch (error) {
      trace(`OrderPage Mount Error: ${error}`,5);
      trace(`Reset: ${SessionInfo.ResetOrder},loadExistingPage: ${this.loadExistingPage}`,5)
    }
    //------------------------------------------------------------- 
    browserPageHasFocus = document.hasFocus();
    this.monitorProcess(true); // *** Run Monitor - always start after mount regardless of errors
    trace(`----> Order Page Mounted - monitor: ${this.runMonitorProcess}, focus: ${browserPageHasFocus}, Menu Select: ${SessionInfo.MenuLayoutSelection}, Default: ${SessionInfo.DefaultMenuLayout}`,1);
    trace(`----> HasViewSeats ${SessionInfo.AC.HasViewSeats}, OrderType: ${SessionInfo.OrderType}`); 
  }
  componentWillUnmount() {
    trace(`----> Order Page UNMount`);
    window.removeEventListener('focus',this.checkFocus);
    window.removeEventListener('blur',this.checkFocus);
    SessionInfo.VisibilityEvent = false;
    window.removeEventListener('resize',this.handleViewportChange);
    window.removeEventListener('orientationchange',this.handleViewportChange);
    window.visualViewport?.removeEventListener('resize',this.handleViewportChange);
    window.visualViewport?.removeEventListener('scroll',this.handleViewportChange);
    if (SessionInfo.session !== '') {
      this.closePopups(0);
      SessionInfo.OrderPage = this.state;
    }
    this.runMonitorProcess = false;
    if (this.timeout)
      clearTimeout(this.timeout);
  }
  shouldComponentUpdate() { // Refresh - and pause refresh
    return this.compUpdate && this.comp2Update;
  }

  //----- Timer Process - Application Control Logic -------------------------------------------------
  setTimer() {
    if (SessionInfo.loggedOn === true) {
      if (this.runMonitorProcess === true)
        this.timeout = setTimeout(this.monitorProcess.bind(this),200); // 200 milliseconds
    } else {
      this.runMonitorProcess = false;
    }
  }
  //----- Timer Process - Application Control Logic -------------------------------------------------
  monitorProcess = async (force) => { // Note - Monitor only runs if logged on
    if (force)
      this.runMonitorProcess = true;
    //trace(`monitor - run: ${this.runMonitorProcess}, loggedOn: ${SessionInfo.loggedOn}, focus: ${browserPageHasFocus}, pause: ${SessionInfo.PauseOPMonitor}`);
    if (SessionInfo.forceLogoff === true) {
      trace(`forceLogoff in monitor`);
      SessionInfo.forceLogoff = false;
      this.props.navigate("/Login");
    }
    if (this.runMonitorProcess === true && SessionInfo.loggedOn === true && SessionInfo.PauseOPMonitor === false) {
      try {
      if (browserPageHasFocus === true && ItemDetailSecondLevel == false) {
        //await OMTrace(0, `OrderPage Has Focus: ${document.hasFocus()}`);
        if (this.showFocusTimer++ > 10) {
          //trace(`OrderPage Has Focus: ${document.hasFocus()}`);
          this.showFocusTimer = 0;
        }
        if (1 === 1 || document.hasFocus() === true) { // Execute monitor process
          //---- Ping and Notification Processing -------------
          if (SessionInfo.setShowNotify > 0 && SessionInfo.notifyMessage.length > 0) {
            this.setState({ notifyMessage: SessionInfo.notifyMessage });
            SessionInfo.notifyTimer = SessionInfo.notifyTime;
            this.setNotifyMessage(true); // Show the Message 

            if (SessionInfo.notifyRing && (SessionInfo.SoundOn === true || SessionInfo.SoundOverride === true)) {
              //trace(`Play Notify Sound: ${SessionInfo.notifyRing}`);
              try {
                await SessionInfo.notifyRing.play();
              }
              catch (Ex) {
                trace(`Ring Ex: ${Ex}`);
              }
              SessionInfo.notifyRing = undefined;
              SessionInfo.SoundOverride = false;
            }
          }
          SessionInfo.setShowNotify = 0;
          if (SessionInfo.notifyTimer > 0) {
            if (--SessionInfo.notifyTimer <= 0)
              this.setNotifyMessage(false);
          } else if (SessionInfo.showNotify === true)
            this.setNotifyMessage(false); // Hide the Notify Message
          if (SessionInfo.pingCounter++ > 50) {
            SessionInfo.pingCounter = 0;
            await PingApp();
          }
          //---- End of Notification Processing ------------- 
          let fetchRefresh = 25;
          if (SessionInfo.AppCfg.HasSeats === false)
            fetchRefresh = 100;
          else if (this.state.seatCount === 0)
            fetchRefresh = 40;
          if (SessionInfo.CustomOrderID > 0) {
            if (this.fetchCount++ > fetchRefresh && this.fetchInProcess === false) { // Note - on restart of page - multiple copies of Monitor may be running
              trace(`------> Fetch Table Info - CustomOrderID: ${SessionInfo.CustomOrderID}`);
              this.fetchCount = 0;
              // Update current Seat Information based on other users logging on
              await this.fetchTableInfo(); // In Monitor - check if anything changes
              if (this.state.SeatCount != SessionInfo.SeatCount)
                this.setState({ SeatCount: SessionInfo.SeatCount }); // NOTE 13Sep22 - Only do this if the count has changed
            }
          //  else
          //    this.fetchCount++;
          }
          // 21Mar23 - To be added - later
          //else {
          //  if (this.fetchCount > 25 && this.fetchInProcess === false) { // Note - on restart of page - multiple copies of Monitor may be running
          //    this.fetchCount = 0;
          //    // Update current Seat Information based on other users logging on
          //    await this.fetchTableInfo(); // Need to check if anything changes!
          //    await this.getCurrentTotal(); // Possibly this instead?
          //    if (this.state.SeatCount != SessionInfo.SeatCount)
          //      this.setState({ SeatCount: SessionInfo.SeatCount }); // NOTE 13Sep22 - Only do this if the count has changed
          //  }
          //  else {
          //    this.fetchCount++;
          //}
          //this.setState({ SeatCount: SessionInfo.SeatCount }); // NOTE 13Sep22 - have to be really careful about unnecessary State Updates - causes complete UI Refresh
          if (this.billTimer > 0) {
            this.billTimer--;
          } else if (this.state.showBillSummary === true) {
            //this.setState({ showBillSummary: false }); // Hide the Bill Summary  
            this.doneComment();
          }
          this.lastCategory = ""; // Just in case UI Refresh - which refreshes the whole List
        }
      }
      } catch (Ex) {
        trace(`monitorProcess Error: ${Ex}`,5);
      }
    }
    this.setTimer(); // Required!!
  }
  //-----------------------------------------------
  handleViewportChange = () => {
    // Update screen dimensions
    SessionInfo.height = window.visualViewport?.height || window.innerHeight;
    SessionInfo.width = window.visualViewport?.width || window.innerWidth;

    // Recalculate popup offsets if popups are visible
    if (this.state.displayItemDetail) {
      // Recalculate item detail popup position
      this.calculateDetailPopupPosition();
    }

    // Force re-render to update popup positions
    this.forceUpdate();
  }
  calculateDetailPopupPosition = () => {
    // Center the popup or adjust based on available space
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const viewportWidth = window.visualViewport?.width || window.innerWidth;

    // Calculate popup dimensions
    if (this.popupHeight > (viewportHeight - 60)) {
      this.popupHeight = viewportHeight - 60;
      this.scrollPopup = true;
    }

    // Update CSS variables for popup dimensions
    this.setDisplayHeights();
  }
  //-----------------------------------------------
  setMenuLayout(MenuLayoutID) {
    trace(`==-->setMenuLayout: ${MenuLayoutID}`);
    if (MenuLayoutID == 0)
      MenuLayoutID = SessionInfo.DefaultMenuLayout;
    if (MenuLayoutID == 0)
      MenuLayoutID = 1;
    this.setState({ useMenuLayout1: false });
    this.setState({ useMenuLayout2: false });
    this.setState({ useMenuLayout3: false });
    this.setState({ useMenuLayout4: false });
    this.setState({ useMenuLayout5: false });
    this.setState({ useMenuLayout6: false });
    this.setState({ useMenuLayout7: false });
    this.setState({ useMenuLayout8: false });
    if (MenuLayoutID == 1) {
      SessionInfo.MenuLayoutSelection = 1;
      this.setState({ useMenuLayout1: true });
      this.listRowHeight = 84 + 26; // What is the 26 for?
    } else if (MenuLayoutID == 2) {
      SessionInfo.MenuLayoutSelection = 2;
      this.setState({ useMenuLayout2: true });
      this.listRowHeight = 158 + 26; // Large Picture
    } else if (MenuLayoutID == 3) {
      SessionInfo.MenuLayoutSelection = 3;
      this.setState({ useMenuLayout3: true });
      this.listRowHeight = 75 + 26; // Note - ML3 is variable height
    } else if (MenuLayoutID == 4) {
      SessionInfo.MenuLayoutSelection = 4;
      this.setState({ useMenuLayout4: true });
      this.listRowHeight = 54 + 26; // Small format
    } else if (MenuLayoutID == 5) {
      SessionInfo.MenuLayoutSelection = 5;
      this.setState({ useMenuLayout5: true });
      this.listRowHeight = 54 + 26; // Extra small format
    } else if (MenuLayoutID == 6) {
      SessionInfo.MenuLayoutSelection = 6;
      this.setState({ useMenuLayout6: true });
      this.listRowHeight = 188 + 26; // Extra small format
    } else if (MenuLayoutID == 7) {
      SessionInfo.MenuLayoutSelection = 7;
      this.setState({ useMenuLayout7: true });
      this.listRowHeight = 158; // Large Picture
    } else if (MenuLayoutID == 8) {
      SessionInfo.MenuLayoutSelection = 8;
      this.setState({ useMenuLayout8: true });
      this.listRowHeight = 158 + 26; // Large Picture
    }
    trace(`use Menu: ${SessionInfo.MenuLayoutSelection}, listRowHeight: ${this.listRowHeight}, Images: ${SessionInfo.HasCategoryImages}`);
    this.setState({ useCategoryImages: SessionInfo.HasCategoryImages });
    this.setState({ useCategoryDesc: SessionInfo.HasCategoryImages }); // Turn on and off with Images control for now
    if (SessionInfo.HasCategoryImages === false) {
      document.documentElement.style.setProperty('--category-height','35px');
    }
  }
  //---------------------------------------- OrderItems Initialize - Component Did Mount ---------------------------------------- 
  displayAddFullItemToOrder = async (item,isChange,loadFull) => {
    try {
      this.setState({ showPromo: false });
      this.setNotifyMessage(false);
      trace(`displayAddFullItemToOrder - imageVal: ${item.imageVal ? 'SET' : 'EMPTY'}, Image: ${item.Image ? `base64(${item.Image.length})` : 'EMPTY'}, ImageID: ${item.ImageID}, StoreItemID: ${item.StoreItemID}`);
      if (!item.imageVal && item.Image) {
        try {
          const byteCharacters = atob(item.Image);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++)
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          const byteArray = new Uint8Array(byteNumbers);
          item.imageVal = URL.createObjectURL(new Blob([byteArray],{ type: 'image/jpeg' }));
          trace(`displayAddFullItemToOrder - decoded Image to blob URL: ${item.imageVal}`);
        } catch (Ex) {
          trace(`displayAddFullItemToOrder - Image decode failed: ${Ex}`,5);
        }
      } else if (!item.imageVal && !item.Image && item.ImageID) {
        trace(`displayAddFullItemToOrder - no Image data, fetching by ImageID: ${item.ImageID}`);
        await this.GetProductItemImage(item.ImageID);
      } else {
        trace(`displayAddFullItemToOrder - using existing imageVal: ${item.imageVal ? 'SET' : 'EMPTY'}`);
      }
      console.log(`displayAddFullItemToOrder - imageVal: ${item.imageVal ? 'SET' : 'EMPTY'}`);
      if (!item.imageVal) {
        console.log(`item: ${JSON.stringify(item)}`);
        console.log(`No imageVal, fetching image for ImageID: ${item.ImageID}`);
        let imageURL = await getImageFileFromServer(item.ImageID,3);
        item.imageVal = imageURL;
      }
      this.setState({ ProductItemPhotoURL: item.imageVal });
      //this.setState({ image: SessionInfo.CurrentImage });
      //trace(`item: ${JSON.stringify(item)}`);
      this.resetOptions();
      this.compUpdate = false; // Stop Updates
      this.OptionCount = 0;
      this.OptionElementCount = 0;
      this.RelatedItemCount = 0;
      this.setState({ OptionStatus: "" });
      // Load Store Item - and Option Groups and Options
      this.StoreItemID = item.StoreItemID;
      const startTime = performance.now();
      document.documentElement.style.setProperty('--options-image-height',`${this.imageHeight}px`); // Set to standard Image Height
      document.documentElement.style.setProperty('--itemDetailPopupHt',`${560}px`); // Reset Popup Height 
      await this.loadStoreItem(item,loadFull,true); // Load the Item and the Options - this.StoreItemID 
      if (SIV.HasOptions === true)
        loadFull = true;
      this.LoadFull = loadFull;
      // Set Height of Description ---- Make adjustment for Long Description in Header - Set size of popup? ----- 
      let baseHeight = 480;
      if (this.LoadFull === true)
        baseHeight = 650;
      else
        this.AllOptionsDone = true;
      this.descAdjust = 24;
      let IDLth = SessionInfo.SIV.ItemDescription.length;
      //trace(`Item Desc: ${SessionInfo.SIV.ItemDescription}`);
      trace(`Item Desc Lth: ${IDLth}`);
      if (IDLth > 50) { // Note - this seems to work fine for 16px font size
        this.descAdjust += Math.floor((IDLth / 48) * 17); // Adjustment for Number of Description Lines - Assume 48/Line - 15px per line - see line-height in optionHeader
        trace(`Description adjust: ${this.descAdjust}`);
      }
      this.setState({ DescHeight: this.descAdjust }); // Standard height is 24 + adjustment for long descriptions
      // This is always first level
      // Note that Options are loaded above in loadStoreItem
      let specInstAdjust = 0;
      this.topLevelStoreItem = this.StoreItemID; // Note - the only place that this is set
      if (isChange === true) { // Load current OrderItem information for existing OrderItem
        trace(`---> ChangeItem in Display: ${item.StoreItemID}, isChange: ${isChange}`);
        this.setState({ isItemChange: true });
        await this.loadOrderItem(item,isChange); // SessionInfo.CurrentItem
        specInstAdjust = 0;
        //  this.setState({ RelatedItems: [] });
        //  this.RelatedItemCount = 0; // Related should not show on Change
      }
      else { // New Item
        this.setState({ isItemChange: false });
        this.setState({ TotalItemPrice: this.state.ItemPrice });
        this.setState({ SpecialInstruction: '' });
        if (this.LoadFull === true && ItemDetailSecondLevel === false) {
          await this.loadRelatedItems(''); // Note - related items not added for second level popup
        }
        else {
          await this.setState({ RelatedItems: [] });
        }
      }
      const endTime = performance.now();
      const executionTime = Math.round(endTime - startTime);
      console.log(`===> loadStoreItem execution time: ${executionTime} milliseconds`);
      trace(`---> after loadStoreItem - change: ${isChange}, current: ${this.StoreItemID}, promo: ${SessionInfo.PromoStoreItemID}, hasOption: ${SIV.HasOptions}, Option Count: ${this.OptionCount}, related: ${this.RelatedItemCount}, loadFull: ${this.LoadFull}`);
      trace(`-> showFullItem - lth: ${this.state.ItemsList.length}, show item list: ${this.state.showChangeItems}`);
      this.hideItemImage = false;
      this.setState({ hideOptionImage: false });
      this.detailHeaderHeight = this.imageHeight + 155; // 230 + Standard 
      if (SIV.HasOptions === true) {
        this.detailHeaderHeight += 24;
      }
      if (this.showInfo === true)
        specInstAdjust = 54; // Special Instructions
      this.detailHeaderHeight += this.descAdjust + specInstAdjust; // long description and specialinstructions adjustment to header element 
      this.listHeight = this.OptionCount * 30 + this.OptionElementCount * 15 + this.RelatedItemCount * 45; // Height of the option and related lists
      this.popupHeight = baseHeight + this.descAdjust + specInstAdjust + this.listHeight;
      this.scrollPopup = false; // see scrollOptions
      trace(`DISPLAY headerHT: ${this.detailHeaderHeight}, baseHT: ${baseHeight}, descAdjust: ${this.descAdjust}, imageHT: ${this.imageHeight}, showInfoHT: ${specInstAdjust}, listHT: ${this.listHeight}, popupHT: ${this.popupHeight}, window height: ${SessionInfo.height}`);
      SessionInfo.height = window.innerHeight;
      if (this.popupHeight > (SessionInfo.height - 60)) {
        this.popupHeight = SessionInfo.height - 60;
        this.scrollPopup = true;
      }
      trace(`        OptionGroups: ${this.OptionCount}, OptionCount: ${this.OptionElementCount}, Related: ${this.RelatedItemCount}, listHeight: ${this.listHeight}, scrollPopup: ${this.scrollPopup}`);
      this.setDisplayHeights();
      this.setState({ itemChanged: isChange === true });
      this.setState({ displayItemDetail: true });
    }
    catch (error) {
      trace(`displayAddFullItemToOrder Init Err: ${error}`,5);
    }
    this.compUpdate = true; // Updates back on
  }
  setDisplayHeights = () => {
    trace(`DisplayHeights: detailHeaderHeight: ${this.detailHeaderHeight}, popupHeight: ${this.popupHeight}, listHeight: ${this.listHeight}, scrollPopup: ${this.scrollPopup}`);
    document.documentElement.style.setProperty('--options-header-height',`${this.detailHeaderHeight}px`); // Image + Description Height 
    document.documentElement.style.setProperty('--itemDetailPopupHt',`${this.popupHeight}px`); // Popup Height 
    document.documentElement.style.setProperty('--options-list-height',`${this.listHeight}px`); // option list Height 
  }
  //---------------------------------------- OrderItems Initialize - Component Did Mount ----------------------------------------
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Horizontal Scrolling -- add 27May22
  //componentDidUpdate(prevProps, prevState) {
  //  const { alignCenter } = prevState;
  //  const { alignCenter: alignCenterNew } = this.state;
  //  if (alignCenter !== alignCenterNew && this.menu) {
  //    this.menuList.setInitial();
  //    this.menuList.forceUpdate();
  //    this.forceUpdate();
  //  }
  //}
  onUpdateHS = ({ translate }) => { // On Horizontal Scroll of the Scroller
    //trace(
    //  // `onUpdate: translate: ${translate} firstItemVisible: ${firstItemVisible}, lastItemVisible: ${lastItemVisible}`
    //  `onUpdate: translate: ${translate}`
    //);
    this.setState({ translate });
  };
  setSlowdownFactor = ev => {
    this.setState({ slowdownFactor: ev.target.value });
  }
  setSelected = ev => {
    const { value } = ev.target;
    trace(`set selected: ${value}`);
    this.setState({ selected: value });
    menuSelectedKey = value;
  };
  toggle = () => {
    this.setState({ showList: !this.state.showList });
  };
  onCatSelect = (key) => {
    trace(`Category onCatSelect: ${key}, this.state.selected ${this.state.selected}`);
    this.setState({ showMenu: false });
    this.lastCategory = "";
    if (this.state.selected === key) { // Turn Off Selection
      this.setState({ selected: 0 });
      menuSelectedKey = 0; // Note - menuSelectedKey is a main variable - and is used in the menu object
      this.handleCatChangeS(0);
    } else { // Select
      trace(`Turn ON Select: ${key}`);
      //trace(`catNames: ${JSON.stringify(SessionInfo.catNames)}`);
      this.setState({ selected: key });
      menuSelectedKey = key;
      let menuItm = SessionInfo.catNames[this.PIG].find(p => p.key == key)
      if (menuItm) {
        trace(`menuItm: ${JSON.stringify(menuItm)}`);
        menuItm.selected = true;
        //trace(`after catNames: ${JSON.stringify(SessionInfo.catNames)}`);
      }
      this.lastCategory = "";
      this.handleCatChangeS(key);
    }
  };
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  closePopups(src) {
    trace(`close Popups - ${src}, keep: ${this.keepMenu}`);
    if (src != 10) {
      this.setNotifyMessage(false);
      this.setState({ showSeatsPopup: false });
      this.setState({ showOrderTypePopup: false });
      this.setState({ showSelectOrderTypePopup: false });
      this.setState({ showVerifyCancel: false });
      this.setState({ showPromo: false });
      this.setState({ showBillSummary: false });
      this.setState({ optionHeader: false });
      this.setState({ showQRCode: false });
    }
    this.setState({ showMenu: false });
  }
  //----------------------------------------------------
  resetOrder = async () => {
    trace(`RESET OrderID: ${SessionInfo.CustomOrderID}, TableName: ${SessionInfo.CurrentTableName}, TotalBill: ${SessionInfo.TotalBill}, PayDone: ${SessionInfo.BillPaymentDone}, BillPaymentComplete: ${SessionInfo.BillPaymentComplete}`);
    this.closePopups(6);
    // Note - commented out 19Jun24
    //if (SessionInfo.LocationOn === true) { // Note - need to do this for each new order - verify location - this requires more logic
    //  navigator.geolocation.getCurrentPosition(function (position) {
    //    trace(`Latitude is : ${position.coords.latitude}, Longitude is : ${position.coords.longitude}`);
    //  });
    //}
    if (SessionInfo.BillPaymentDone === true) {
      //trace(`TotalBill : ${SessionInfo.TotalBill}, TotalTip: ${SessionInfo.TotalTip}, Order: ${SessionInfo.CustomOrderID}`);
      this.closePopups(12);
      this.setState({ TableName: SessionInfo.CurrentTableName });
      this.setState({ TotalBill: SessionInfo.TotalBill });
      this.setState({ TotalTip: SessionInfo.TotalTip });
      this.setState({ BillCount: SessionInfo.RelatedOrders });
      this.setState({ PaidBills: SessionInfo.PaidOrders });
      this.setState({ TotalQuantity: 0 });
      this.setState({ RatingValue: 0 }); // Set to Default Value
      this.orderIDForComment = SessionInfo.CustomOrderID;
      this.billTimer = 100;
      this.setState({ showBillSummary: true }); // Display the Bill Summary and Feedback popup
      this.forceUpdate();
      SessionInfo.BillPaymentDone = false;
      trace(`BillPayDone - PaidOrders: ${SessionInfo.PaidOrders}, RelatedOrders: ${SessionInfo.RelatedOrders}, BillSummary: ${this.state.showBillSummary}`);
      if (SessionInfo.PaidOrders >= SessionInfo.RelatedOrders)
        SessionInfo.BillPaymentComplete = true; // Flag all Orders Paid
    }
    if (SessionInfo.BillPaymentComplete === true) {
      await this.clearOrderInfo(); // This calls loadItems
    }
  }
  clearOrderInfo = async () => { // clear order, reset order, start fresh   
    trace(`clear OrderInfo for location: ${SessionInfo.StoreLocationID}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
    SessionInfo.ResetOrder = false;
    SessionInfo.CustomOrderID = 0;
    SessionInfo.ParentOrderID = 0;
    SessionInfo.SeatCount = 0;
    SessionInfo.CheckoutPage = undefined;
    SessionInfo.ShowAllOrders = false;
    SessionInfo.PayAllOrders = false;
    this.setState({ CustomOrderID: 0 });
    this.setState({ ItemCount: 0 });
    this.setState({ SubTotalPrice: 0 });
    this.setState({ TotalTaxAmount: 0 });
    this.setState({ TotalPrice: 0 });
    this.setState({ TotalQuantity: 0 });
    trace(`--> set SeatName: ${SessionInfo.CurrentSeat}, firstOrderComplete: ${SessionInfo.firstOrderComplete}`);
    this.setState({ SeatName: SessionInfo.CurrentSeat });
    this.setState({ SeatCount: 0 });
    this.setState({ SeatOrders: [] });
    this.setState({ ServiceDescription: "" });
    this.setState({ OrderNotes: '' });
    this.setState({ AddressID: 0 });
    await this.loadCategories(this.ProductItemGroupID); // One time load of Categories
    this.setState({ selectedItems: undefined });
    this.clearSearch();
    await this.loadItems(this.ProductItemGroupID);
    if (SessionInfo.firstOrderComplete === false) // Note - 20Nov22 - this does not seem to work?
      await this.addOrder(); // Get Open Order - for CustomerID, Location and TableID - Or Add a CustomOrder if required
  }
  //--- Load Menu Items - LoadMenuItems ------------------------------------------------------------
  loadItems = async (PIG) => { // PIG is Product Item Group ID - LoadStoreItems
    this.compUpdate = false;
    if (PIG && PIG > 0) {
      if (SessionInfo.StoreItems.includes(PIG) === true) {
        this.setState({ StoreItems: SessionInfo.StoreItems[PIG] });
        this.ProductItemGroupID = PIG;
        this.PIG = PIG;
        return;
      }
      this.ProductItemGroupID = PIG;
    }
    else
      PIG = this.ProductItemGroupID;
    trace(`Load Menu Items for location: ${SessionInfo.StoreLocationID}, PIG: ${PIG}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
    try {
      if (SessionInfo.categories.includes(PIG) && SessionInfo.categories[PIG].length > 0) {
        let ix = 0;
        SessionInfo.categories[PIG].forEach(elem => {
          if (elem.selected === true) {
            elem.selected = false;
          }
        });
        SessionInfo.selectedCategories.forEach(elem => {
          if (elem.selected === true) {
            elem.selected = false;
          }
        });
        this.setState({ Categories: SessionInfo.categories[PIG] });
      }
      let CD = await CallOM("GetFavorites",0,SessionInfo.CustomOrderID,0);
      if (CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        trace(`GetFavorities 2 CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
        if (CD.d)
          SessionInfo.favoriteItems[this.PIG] = CD.d;
        else
          SessionInfo.favoriteItems[this.PIG] = [];
      }
      // Note - Fetch the StoreItems from the main menu - LOAD MENU ITEMS - GetProductItemsForLocation uses DisplayOrder
      trace(`---> Load StoreItems: location: ${SessionInfo.StoreLocationID}, ProductItemGroupID: ${JSON.stringify(this.ProductItemGroupID)}, MenuLayout: ${SessionInfo.MenuLayoutSelection}, CustomOrderID: ${SessionInfo.CustomOrderID}`)
      let parm2 = 0x01; // get image
      if (SessionInfo.MenuLayoutSelection === 3)
        parm2 = 0x03; // no image - don't truncate - Note - Changed 6May26 to 0x03 from 0x02 - Include the ImageID        
      else if (SessionInfo.MenuLayoutSelection === 5)
        parm2 = 0x04; // no image - double column       
      else if (SessionInfo.MenuLayoutSelection === 6)
        //parm = 13; // double column + ImageColumn + don't get image
        parm2 = 0x40; // 0x40 - double column
      //else // retrieve ImageID - include Image column with Image
      //  parm2 = 0x81; // 0x01 - get image + 0x80 - include Image column with Image 
      // Load StoreItems
      CD = await CallOM("GetProductItemsForLocation",0,SessionInfo.StoreLocationID,CTYP.TypParm,[TYP.STR,'',TYP.INT,this.ProductItemGroupID],'',parm2); // Note - for ProductCategory 1 - starting at Item 1
      //trace(`Items For Location: ${JSON.stringify(CD.d)}`);
      this.setState({ ItemSelect: "" });
      if (CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        if (CD && CD.d && CD.d.rows) {
          trace(`Product Items for Location - row count: ${CD.d.rows.length}`);
          try {
            let StoreItems = CD.d.rows.map(dataItem => Object.assign({ selected: false,ItemTotal: 0.0 },dataItem));
            //trace("Store Items: " + JSON.stringify(StoreItems));
            if (SessionInfo.favoriteItems[this.PIG] && SessionInfo.favoriteItems[this.PIG].length > 0) {
              SessionInfo.favoriteItems[this.PIG].forEach(item => {
                let ix = StoreItems.findIndex(storItem => storItem.StoreItemID === item);
                if (ix >= 0) {
                  StoreItems[ix].IsFavorite = true;
                }
              });
            }
            this.lastCategory = "";
            this.setState({ StoreItems });
            SessionInfo.StoreItems[PIG] = StoreItems.slice(); // ALL the StoreItems
            SessionInfo.saveStoreItems[PIG] = StoreItems.slice(); // ALL the StoreItems
          } catch (error) {
            await OMTrace(2,`Failure in loadItems - Error: ${error}, OrderId: ${SessionInfo.CustomOrderID}`);
          }
        }
        else
          trace(`NO ProductItems for Location: ${SessionInfo.StoreLocationID}`);
        trace(`Load Items - parm2: ${parm2}, MenuLayout: ${SessionInfo.MenuLayoutSelection}, HasImages: ${SessionInfo.HasCategoryImages}`);
        if ((parm2 & 0x01) > 0 && (parm2 & 0x80) == 0 && SessionInfo.MenuLayoutSelection != 3) {
          trace(`---> Load Images for Menu Items`);
          this.addImages(PIG);
        }
      }
    } catch (error) {
      await OMTrace(2,`Failure (2) in loadItems - Error: ${error}, OrderId: ${SessionInfo.CustomOrderID}`);
    }
    this.compUpdate = true;
  }
  //
  addImages = async (PIG) => {
    let StoreItems = SessionInfo.StoreItems[PIG].slice();
    let lth = StoreItems.length;
    let cnt = 0;
    let imageID;
    let imageURL;
    trace(`Add Images = lth: ${lth}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
    for (let ix = 0; ix < lth; ix++) {
      //trace(`StoreItem (${ix}): ${JSON.stringify(StoreItems[ix])}`);
      if (StoreItems[ix].ImageID) {
        imageID = StoreItems[ix].ImageID;
        imageURL = await getImageFileFromServer(imageID,3);
        StoreItems[ix].imageVal = imageURL;
      } else if (StoreItems[ix].Image) {
        StoreItems[ix].imageVal = imagePrep(StoreItems[ix].Image);
      }
      //trace(`After StoreItem (${ix}): ${JSON.stringify(StoreItems[ix])}`);
      // If Double Column - Convert 2nd column
      if (StoreItems[ix].ImageID1) {
        imageID = StoreItems[ix].ImageID;
        imageURL = await getImageFileFromServer(imageID,3);
        StoreItems[ix].imageVal1 = imageURL;
      } else if (StoreItems[ix].Image1) {
        StoreItems[ix].imageVal1 = imagePrep(StoreItems[ix].Image1);
      }
      if (cnt++ > 5) {
        cnt = 0;
        this.setState({ StoreItems });
      }
    };
    this.setState({ StoreItems });
    SessionInfo.StoreItems[PIG] = StoreItems.slice(); // ALL the StoreItems
    SessionInfo.saveStoreItems[PIG] = StoreItems.slice(); // ALL the StoreItems
  }
  loadCategories = async (PIG) => { // GetCategories - Load Menu Items
    trace(`loadCategories - this.ProductItemGroupID: ${this.ProductItemGroupID}, PIG: ${PIG}`);
    if (PIG && PIG > 0) {
      if (SessionInfo.categories.includes(PIG) === true) {
        this.setState({ Categories: SessionInfo.categories[PIG] });
        this.setState({ catNames: SessionInfo.catNames[PIG] });
        this.ProductItemGroupID = PIG;
        this.PIG = PIG;
        this.catCount = SessionInfo.catNames[PIG].length;
        return;
      }
      this.ProductItemGroupID = PIG;
    }
    else
      PIG = this.ProductItemGroupID;
    this.PIG = PIG;
    trace(`Load Categories for PIG: ${PIG}, ProductItemGroupID: ${this.ProductItemGroupID}, StoreLocationID: ${this.StoreLocationID}`);
    try {
      let CD = await CallOM("GetProductItemCatsForStore",this.ProductItemGroupID,SessionInfo.StoreLocationID,0);
      if (CD && CD.d) {
        if (CD.x.o === 0)
          await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
        else if (CD.x.o < 9500) {
          trace(`---> Return Categories: ${JSON.stringify(CD.d)}`);
          try {
            this.ProductItemCategories = CD.d.rows.map(row => Object.assign({ text: row.ProductItemCategory,disabled: false,value: row.ProductItemCategoryID,selected: false },row));
            //trace(`Categories: ${JSON.stringify(Categories)}`);
            SessionInfo.categories[PIG] = this.ProductItemCategories.slice();
            this.setState({ Categories: this.ProductItemCategories });
            let catNames = [];
            this.ProductItemCategories.forEach(cat => {
              //trace("cat: " + JSON.stringify(cat));
              catNames.push({ "name": cat.ProductItemCategory,"key": cat.ProductItemCategoryID,"selected": cat.selected });
            });
            SessionInfo.catNames[PIG] = catNames.slice();
            this.setState({ catNames });
            //trace(`Cats: ${JSON.stringify(SessionInfo.categories)}`);
            //trace(`loadCategories - catNames: ${JSON.stringify(SessionInfo.catNames[PIG])}`);
            this.catCount = SessionInfo.categories[PIG].length;
            this.menu = null;
            let scrollCatMenuItems = MenuListItems(SessionInfo.catNames[PIG].slice(0,SessionInfo.catNames[PIG].length)); //  SessionInfo.catNames[0]);
            this.setState({ scrollCatMenuItems });
            //trace(`loadCategories scrollCatMenuItems: ${JSON.stringify(scrollCatMenuItems)}`);
          } catch (error) {
            await OMTrace(2,`Failure in loadCategories - Error: ${error}`);
          }
        }
      }
    } catch (error) {
      await OMTrace(2,`Failure (2) in loadCategories - Error: ${error}`);
    }
    this.catCount = SessionInfo.catNames[PIG].length;
  }
  setSelectedFavorites = async () => {
    trace(`set Selected Favorites - OrderID: ${SessionInfo.CustomOrderID}`);
    let StoreItems = SessionInfo.saveStoreItems[this.PIG];
    StoreItems.forEach(storItem => { // For EACH Store item - reset Totals
      storItem.ItemTotal = 0.0;
      storItem.IsFavorite = false;
      storItem.IsSelected = false;
      if (storItem.HasSecond === true) {
        storItem.ItemTotal1 = 0.0;
        storItem.IsFavorite1 = false;
        storItem.IsSelected1 = false;
      }
    });
    SessionInfo.favoriteItems[this.PIG] = [];
    let CD = await CallOM("GetFavorites",0,SessionInfo.CustomOrderID,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`GetFavorities 1 CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
      SessionInfo.favoriteItems[this.PIG] = CD.d;
    }
    if (SessionInfo.favoriteItems[this.PIG] && SessionInfo.favoriteItems[this.PIG].length > 0) {
      SessionInfo.favoriteItems[this.PIG].forEach(item => {
        let ix = StoreItems.findIndex(storItem => storItem.StoreItemID === item);
        //trace(`fav item: ${item}, ix: ${ix}`);
        if (ix >= 0) {
          StoreItems[ix].IsFavorite = true;
        } else {
          let ix = StoreItems.findIndex(storItem => storItem.StoreItemID1 === item);
          if (ix >= 0) {
            StoreItems[ix].IsFavorite1 = true;
          }
        }
      });
    }
    await this.getCurrentTotal();
    trace(`load (2) - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
    this.lastCategory = "";
    this.setState({ StoreItems });
    SessionInfo.StoreItems[this.PIG] = StoreItems.slice(); // NOTE - save ALL the StoreItems with Favorite and current purchase info
    SessionInfo.saveStoreItems[this.PIG] = StoreItems.slice(); // NOTE - save ALL the StoreItems with Favorite and current purchase info
  }

  acknowledgeMessage = async () => {
    let CD = await CallOM("AcknowledgeNotification",0,SessionInfo.AppNotificationID);
    this.setNotifyMessage(false);
    SessionInfo.notifyTimer = 50;
    SessionInfo.acknowledge = false;
    this.forceUpdate();
  }
  //------------------------- List Template Functions ------------------------------------------------------------------
  // Select Item from current Item Change List to change - Note this only done for items that have options
  onChangeItem = async (item) => {
    this.CustomOrderItemID = item.CustomOrderItemID;
    trace(`change one Item: ${JSON.stringify(item)}, Order: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID}`);
    this.setState({ showChangeItems: false });
    this.setState({ itemChanged: false });
    this.setState({ displayItemDetail: true });
    this.cancelAddClick = false;
    SessionInfo.CurrentItem = item;
    this.OptionCount = 0;
    this.setState({ OptionsPrice: 0 });
    await this.displayAddFullItemToOrder(item,true,true); // isChange and loadFull
  }
  copyItem = (item) => {
    //trace(`OrderA item: ${JSON.stringify(item)}`);
    let aItem = Object.assign({},item);
    aItem.StoreItemID = item.StoreItemID1;
    aItem.ReferenceItemID = item.ReferenceItemID1;
    aItem.ProductItemCategoryID = item.ProductItemCategoryID1;
    aItem.ItemName = item.ItemName1;
    aItem.ItemDescription = item.ItemDescription1;
    aItem.ItemPrice = item.ItemPrice1;
    aItem.ImageID = item.ImageID1;
    if (item.Image !== undefined)
      aItem.Image = item.Image1;
    aItem.IsSelected = item.IsSelected1;
    aItem.IsFavorite = item.IsFavorite1;
    aItem.IsPromotion = item.IsPromotion1;
    aItem.IsDietModify = item.IsDietModify1;
    aItem.IsQuick = item.IsQuick1;
    aItem.HasOptions = item.HasOptions1;
    aItem.HasRelated = item.HasRelated1;
    aItem.imageVal = item.imageVal1;
    //trace(`Order AItem: ${JSON.stringify(aItem)}`);
    return aItem;
  }
  // Display Item detail for double column menu
  displayAddItemToOrderA = async (item,rowIdx,isChange) => {
    let aItem = this.copyItem(item);
    trace(`Display AItem: ${JSON.stringify(aItem)}`);
    trace(`---> call AddItemToOrder - ID: ${aItem.StoreItemID}, rowIdx: ${rowIdx}`);
    await this.displayAddItemToOrder(aItem,rowIdx,isChange);
    item.IsSelected1 = aItem.IsSelected;
  }
  displayAddItemToOrder = async (item,rowIdx,isChange) => {
    // NOTE: current Order Information is in this.state.ItemsList
    //trace(`==> displayAddItemToOrder: ${JSON.stringify(item)}, rowIdx: ${rowIdx}`);
    //await this.displayAddFullItemToOrder(item,rowIdx,isChange,false);
    if (SessionInfo.AC.HasDetail === true) { // This is set to false if ApplicationTypeID < 2
      trace(`---> Display - ID: ${item.StoreItemID}, rowIdx: ${rowIdx}, inAddOrderItem: ${this.inAddOrderItem}, CustomOrderItemID: ${this.CustomOrderItemID}, isChange: ${isChange}, Options: ${item.HasOptions}`);
      if (this.inAddOrderItem === false) { // Control double click
        try {
          this.inAddOrderItem = true; // Prevent multiple calls to this function
          trace(`Add/Change Item: ${item.StoreItemID}, Order: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID}, ItemDetailSecondLevel: ${ItemDetailSecondLevel}, displayItemDetail: ${this.state.displayItemDetail}, cancelAddClick: ${this.cancelAddClick}, menu select: ${SessionInfo.MenuLayoutSelection}, detailHeaderHeight: ${this.detailHeaderHeight}`);
          // Note - This will close the current window if open - user will have to hit item again to open
          if (ItemDetailSecondLevel === false && this.state.displayItemDetail === true)
            this.setState({ displayItemDetail: false }); // Note sure? Does this mean already in DisplayItem
          else if (this.cancelAddClick === false) {
            SessionInfo.CurrentItem = item;
            this.StoreItemID = item.StoreItemID;
            SessionInfo.PromoStoreItemID = 0;
            //this.CustomOrderItemID = 0;
            SessionInfo.SelectedItems = this.state.selectedItems;
            //if (SessionInfo.MenuLayoutSelection === 3)
            //  SessionInfo.CurrentImage = item.imageVal;
            if (item === undefined || (item.HasOptions == true && item.OptionCount == undefined)) {
              console.error(`displayAddItemToOrder - item or OptionCount is undefined`); // `: ${JSON.stringify(item)}`);
              //handleRestart(10); // Restart the app - this is a critical error - not identifying the problem correctly - always restarting 
              //await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
            }
            trace(`====> HasOptions: ${item.HasOptions}, count: ${item.OptionCount}, related: ${item.HasRelated}  showChangeItems: ${this.state.showChangeItems},detailHeaderHeight: ${this.detailHeaderHeight}`);
            if (item.HasOptions === true || item.HasRelated === true) { // Options or Related Information indicated in Item Retrieval - show FULL Detail 
              await this.displayAddFullItemToOrder(item,isChange,true); // Display options/related
            } else { // Display Item Description & Price with or without Image    
              //if (SessionInfo.MenuLayoutSelection === 3) // No Images - not sure if this is relevant 
              //  this.setState({ ProductItemPhotoURL: SessionInfo.CurrentImage });
              await this.displayAddFullItemToOrder(item,isChange,false);
            }
          }
        } catch (ex) {
          trace(`displayAddItemToOrder - error: ${ex}`);
          this.inAddOrderItem = false;
        } finally {
          this.inAddOrderItem = false;
        }
      }
    }
    this.cancelAddClick = false;
  }
  //------------------------------------------------
  // addOrder AddCustomOrder UpdateCustomOrder   
  addOrder = async () => {
    let CD;
    try {
      if (SessionInfo.CustomOrderID === 0) { // Add a CustomOrder 
        trace(`Create CustomOrder (1) - StoreLocationID: ${SessionInfo.StoreLocationID}`);
        SessionInfo.OrderType = 4; // Order at Table
        CD = await CallOM("CreateCustomOrderTab",0,SessionInfo.StoreLocationID,CTYP.TypParm,[TYP.INT,SessionInfo.OrderType,TYP.INT,this.state.AddressID,TYP.STR,"",TYP.STR,"",TYP.INT,SessionInfo.CurrentTableID]);
        if (CD.x.o < 9500) {
          if (SessionInfo.CustomOrderID != CD.d.CustomOrderID) {
            SessionInfo.CustomOrderID = CD.d.CustomOrderID; // Newly Created Order 
            SessionInfo.IsNewOrder = true;
          }
          this.setState({ TableName: CD.d.TableName });
          this.setState({ SeatCount: CD.d.SeatCount });
          SessionInfo.CurrentTableName = CD.d.TableName;
          SessionInfo.SeatCount = CD.d.SeatCount;
          if (SessionInfo.SeatName === '')
            SessionInfo.SeatName = `Seat #: ${SessionInfo.SeatCount}`;
          SessionInfo.ParentOrderID = CD.d.ParentOrderID;
          trace(`CreateCustomOrderTabID: ${SessionInfo.CustomOrderID}, TableName: ${this.state.TableName}`);
        }
      }
    } catch (error) {
      await OMTrace(2,`Failure in addOrder in ItemDetail - Error: ${error}`);
    }
    return;
  }
  //------------------------------------------------
  // OrderItem Popup   
  dbAddItemToOrder = async () => {
    trace(`db Add Item to Order - StoreItem: ${this.StoreItemID}`);
    try {
      let currentND = -1;
      await this.addUpdateOrderItem(); // Add the OrderItem to the Order  
      if (this.topLevelStoreItem === this.StoreItemID) {
      } else { // A Promo or Related Item - added - pop back to previous
        this.StoreItemID = this.topLevelStoreItem;
        trace(`After Add - topLevel SI: ${this.topLevelStoreItem}, SI: ${this.StoreItemID}`);
        this.popCurrentOptionState();
      }
      ItemDetailSecondLevel = false;
      this.fetchTableInfo(); // Setup Initial Table Info
    }
    catch (error) {
      trace(`Failure in dbAddItemToOrder - msg: ${error}`,5);
    }
  }
  changeQuantity = (e) => {
    trace(`changeQuantity: ${e.target.value}, Existing Qty: ${this.ExistQty}, change: ${this.state.isItemChange}, status: ${this.state.OrderItemStatus}`); //JSON.stringify(e));
    let newQuantity = e.target.value;
    if (this.state.isItemChange === true) {
      if (newQuantity < this.ExistQty) {
        if (this.state.OrderItemStatus >= 2) { // Status Active Item
          SetNotify(`Change to an Ordered Item - Current Ordered Quantity is ${this.ExistQty}`,NOTIFY.Message);;
          newQuantity = this.ExistQty;
        }
      }
      this.setState({ itemChanged: true });
    }
    this.setState({ Quantity: newQuantity });
    trace(`change Quantity: ${newQuantity}`); //JSON.stringify(e));
    let TotalItemPrice = (this.state.ItemPrice + this.state.OptionsPrice) * newQuantity;
    this.setState({ TotalItemPrice });
  }
  addUpdateOrderItem = async () => {
    let CD;
    trace(`addUpdateOrderItem - OrderID: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID}, Qty: ${this.state.Quantity}, OptionsPrice: ${this.state.OptionsPrice}, OptionCount: ${this.OptionCount}, Name: ${this.state.ItemName}, Desc: ${this.state.ItemDescription}`);
    let OrderItemID = this.CustomOrderItemID;
    let TotalPrice = 0.0;
    let SelectedOptions = 0;
    for (let ix = 0; ix < this.OptionCount; ix++) {
      for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
        if (this.state.Options[ix][ox].Select === true)
          SelectedOptions++;
      }
    }
    try {
      if (SessionInfo.CustomOrderID === 0) { // Add a CustomOrder if required
        await this.addOrder();
      } //int OptionCount, decimal Quantity, decimal Weight, string SpecialInstruction
      console.log(`call OMT - CustomOrderID: ${SessionInfo.CustomOrderID}, Quantity: ${this.state.Quantity}, Weight: ${this.state.Weight}`);
      CD = await CallOMT("AddUpdateOrderItem",TYP.INT,SessionInfo.CustomOrderID,TYP.INT,0,TYP.INT,this.StoreItemID,TYP.DEC,this.state.OptionsPrice,TYP.INT,SelectedOptions,TYP.DEC,this.state.Quantity,TYP.DEC,this.state.Weight,TYP.STR,this.state.SpecialInstruction);
      if (CD.x.o === 0 || CD.x.o > 9500) {
        LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
        this.CustomOrderItemID = -2;
      }
      else if (CD.x.o < 9500) {
        let inform = " Added";
        if (this.state.Quantity > 1)
          inform = this.state.Quantity + " " + inform;
        this.setState({ orderMessage: this.state.ItemName + inform });
        trace(`addUpdateOrderItem - AddUpdateOrderItem return data: ${JSON.stringify(CD)}`);
        OrderItemID = CD.d["CustomOrderItemID"];
        TotalPrice = CD.d["TotalPrice"];
      }
      else {
        trace(`addUpdateOrderItem FAIL - AddUpdateOrderItem return data: ${JSON.stringify(CD.d)}`);
        this.CustomOrderItemID = -3;
      }
      trace(`OrderItem Added - Add Options to OrderItemID: ${OrderItemID} to Order: ${SessionInfo.CustomOrderID}`);
      if (OrderItemID > 0) {
        //trace(`OptionCount: ${this.OptionCount}`);
        // Note - OptionCount is the number of OptionGroups
        for (let ix = 0; ix < this.OptionCount; ix++) {
          //trace(`Options Lth: ${this.state.Options[ix].length}`);
          for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
            //trace(`option - ix:${ix}, ox:${ox}, key:${this.optionKeys[ix]} option: ${JSON.stringify(this.state.Options[ix][ox])}`);
            if (this.state.Options[ix][ox].Select === true) {
              CD = await CallOMT("AddOrderItemOption",TYP.INT,this.StoreItemID,TYP.INT,OrderItemID,TYP.INT,this.optionKeys[ix],TYP.INT,this.state.Options[ix][ox].ID,TYP.DEC,-1,TYP.DEC,1,TYP.DEC,0); // Quantity, Price, Weight -> Price -1 means look it up
            }
          }
        }
      }
      if (!SessionInfo.SelectedItems)
        SessionInfo.SelectedItems = [];
      let ix = SessionInfo.SelectedItems.findIndex(selItem => selItem.OrderItemID === OrderItemID);
      if (ix < 0) { // Not Found - so Add
        SessionInfo.SelectedItems.push({ 'ItemID': this.StoreItemID,'Count': this.state.Quantity,'Total': TotalPrice,'OrderItemID': OrderItemID });
        //trace("Add to Selected Items: " + JSON.stringify(SessionInfo.SelectedItems));
      }
    } catch (error) {
      await OMTrace(2,`Failure in addUpdateOrderItem in OrderPage - Error: ${error}`);
    }
    return CD;
  }
  changeOrderItem = async () => {
    let CD;
    let OrderItemID = this.CustomOrderItemID;
    let SelectedOptions = 0;
    for (let ix = 0; ix < this.OptionCount; ix++) {
      for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
        if (this.state.Options[ix][ox].Select === true)
          SelectedOptions++;
      }
    }
    trace(`---> Change OrderItem - CustomOrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID}, Quantity: ${this.state.Quantity}, OptionCount: ${SelectedOptions} `);
    try {
      if (SessionInfo.CustomOrderID > 0 && this.CustomOrderItemID > 0) { // This should ALWAYS be the case on a change
        CD = await CallOMT("AddUpdateOrderItem",TYP.INT,SessionInfo.CustomOrderID,TYP.INT,this.CustomOrderItemID,TYP.INT,this.StoreItemID,TYP.DEC,this.state.OptionsPrice,TYP.INT,SelectedOptions,TYP.DEC,this.state.Quantity,TYP.DEC,this.state.Weight,TYP.STR,this.state.SpecialInstruction);
        if (CD.x.o === 0) {
          await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
          this.CustomOrderItemID = -2;
        }
        else if (CD.x.o < 9500) {
          //trace(`changeOrderItem - AddUpdateOrderItem return data: ${JSON.stringify(CD.d)}`);
          OrderItemID = CD.d["CustomOrderItemID"];
        }
        else {
          this.CustomOrderItemID = -3;
        }
        CD = await CallOM("DeleteOrderItemOptions",0,this.CustomOrderItemID,0);
        trace(`OrderItemID: ${OrderItemID}`);
        if (OrderItemID > 0) {
          trace(`OptionCount: ${this.OptionCount}`); // OptionCount is the number of Option Groups
          for (let ix = 0; ix < this.OptionCount; ix++) {
            //trace(`Options Lth: ${this.state.Options[ix].length}`);
            for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
              //trace(`option - ix:${ix}, ox:${ox}, key:${this.optionKeys[ix]} option: ${JSON.stringify(this.state.Options[ix][ox])}`);
              if (this.state.Options[ix][ox].Select === true) {
                CD = await CallOMT("AddOrderItemOption",TYP.INT,this.StoreItemID,TYP.INT,OrderItemID,TYP.INT,this.optionKeys[ix],TYP.INT,this.state.Options[ix][ox].ID,TYP.DEC,-1,TYP.DEC,1,TYP.DEC,0); // Quantity, Price, Weight -> Price -1 means look it up
              }
            }
          }
        }
      }
    } catch (error) {
      await OMTrace(2,`Failure in changeOrderItem - Error: ${error}`);
    }
    return CD;
  }
  loadStoreItem = async (currentItem,loadFull,getImage) => { // Load Detail Information including Options
    try {
      let ImageID = 0;
      let currentImageID = 0;
      trace(`loadStoreItem - current: ${this.StoreItemID}, promo item: ${SessionInfo.PromoStoreItemID}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
      //trace(`*** currentItem: ${JSON.stringify(currentItem)}`);
      if (SessionInfo.PromoStoreItemID > 0) // ** NOTE **
        this.StoreItemID = SessionInfo.PromoStoreItemID;
      this.setState({ StoreLocationItemID: this.StoreItemID });
      //let CD = await CallOM("GetFullDescription",SessionInfo.CustomOrderID,this.StoreItemID,0);
      //trace("after Get GetFullDescription: " + JSON.stringify(CD.d));
      currentItem.FullDescription = "Not Fetched";
      //var row = CD.d;
      //let CD = await CallOM("GetStoreItem",SessionInfo.CustomOrderID,this.StoreItemID,0);
      //trace("after Get StoreItem: " + JSON.stringify(CD.d));
      //var row = CD.d;
      var row = currentItem; // Note - use currentItem to populate fields - Note - still need full description
      if (row) {
        StoreItemsO.forEach(elem => {
          if (elem.n in row) {
            //trace(`Set ${elem.n}: ${row[elem.n]}`);
            let sobj = {};
            try {
              if (elem.t === 34 || elem.t === 35) { // Date, DateTime
                sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
                //sobj[elem.n] = row[elem.n];
                SIV[elem.n] = new Date(row[elem.n]);
              } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
                sobj[elem.n] = row[elem.n];
                //let sobjS = {};
                //sobjS[elem.n + 'S'] = row[elem.n];
                ////trace(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
                //this.setState(sobjS); // Set the String shadow var
                SIV[elem.n] = row[elem.n];
              } else if (elem.t === 28) { // Money
                sobj[elem.n] = row[elem.n];
                //let sobjS = {};
                //sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
                ////trace(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
                //this.setState(sobjS); // Set the String shadow var
                SIV[elem.n] = row[elem.n];
              } else if (elem.t === 41) { // Media - Image or Document
                sobj[elem.n] = row[elem.n];
                SIV[elem.n] = row[elem.n];
                if (elem.n === 'ImageID')
                  currentImageID = row[elem.n];
                //} else if (elem.t === 15) { // Encoded
                //  trace(`Encoded sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${SIV[elem.n]}`);
              } else {
                sobj[elem.n] = row[elem.n];
                SIV[elem.n] = row[elem.n];
              }
              //trace(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${SIV[elem.n]}`);
              //if (this.state[elem.n] === undefined)
              //  trace(`=== ${elem.n} is not defined in state ===`);
              this.setState(sobj);
            }
            catch (error) {
              trace(`Set StoreItemsO Field: ${elem.n}, Error: ${error.message}`,5);
            }
          }
        });
        //trace(`SIV: ${JSON.stringify(SIV)}`);
        this.setState({ SpecialInstruction: "" });
        //let index = StoreItemsO.findIndex(p => p.n === "ImageID"); // Note - for new line will find 0
        trace(`Fetch StoreItemID: ${this.StoreItemID}, New StoreItemID: ${SIV.StoreItemID}, ImageID: ${SIV.ImageID},${currentImageID}, imageVal: ${SIV.imageVal}, HasOptions: ${SIV.HasOptions}`);
        SessionInfo.SIV = SIV;
      }
      this.setState({ TotalPrice: SIV.ItemPrice });
      this.setState({ OptionsPrice: 0 });
      SessionInfo.headerTitle = SIV.ItemName;
      trace(`ProductItemPhotoURL-2 URL: ${currentItem.imageVal}, SIV.ImageID: ${SIV.ImageID}, currentImageID: ${currentImageID}`);
      if (getImage == true && !currentItem.imageVal) {
        let fetchImageID = SIV.ImageID || currentImageID || currentItem.ImageID;
        if (fetchImageID)
          await this.GetProductItemImage(fetchImageID); // This takes 15% of the load time
        else
          trace(`No ImageID available to fetch for StoreItemID: ${this.StoreItemID}`,3);
      } else if (currentItem.imageVal) {
        this.setState({ ProductItemPhotoURL: currentItem.imageVal });
      }
      //-----------------------------------------------------------------
      if (loadFull === true) {
        this.setState({ displayItemDetail: true });
        this.forceUpdate(); // 3Oct24 - this works - display initial (short) popup
      }
      //-----------------------------------------------------------------
      this.setState({ stateHasChanged: false });
      if (SIV.HasOptions === true)
        loadFull = true;
      if (loadFull === true) { // This takes 70% of the time 
        //this.setState({ displayItemDetail: true }); 
        //this.forceUpdate(); // 3Oct24 - this works
        await this.LoadGroupData(this.StoreItemID);
        trace("---------- Load Options Complete ----------");
      }
      else
        this.AllOptionsDone = true;
    }
    catch (Ex) {
      trace(`Error in LoadStoreItem: ${Ex}`);
    }
  }
  GetProductItemImage = async (imageID) => {
    trace(`GetProductItemImage - fetching imageID: ${imageID}`);
    if (!imageID) {
      trace(`GetProductItemImage - imageID is 0/null, skipping fetch`,3);
      return;
    }
    let imageURL = await getImageFileFromServer(imageID);
    trace(`GetProductItemImage - result URL: ${imageURL ? 'SET' : 'EMPTY'}`);
    this.setState({ ProductItemPhotoURL: imageURL });
  }
  //------------------------------------------------                                                
  quickAddItemToOrder = async (item) => {
    //trace(`quick add item: ${JSON.stringify(item)}`);
    SessionInfo.CurrentItem = item;
    await this.quickAddItemToOrderBase(item.StoreItemID,item.ItemName);
  }
  quickAddItemToOrderA = async (item) => {
    SessionInfo.CurrentItem = this.copyItem(item);
    await this.quickAddItemToOrderBase(item.StoreItemID1,item.ItemName1);
  }
  quickAddItemToOrderBase = async (storeItemID,itemName) => {
    this.cancelAddClick = true;
    this.closePopups(7);
    this.CustomOrderItemID = 0;
    //trace(`quick add: item: ${JSON.stringify(item)}`);
    trace(`Quick add: item: ${itemName},${storeItemID}, Order: ${SessionInfo.CustomOrderID}, ItemID: ${this.CustomOrderItemID}, Quantity: ${this.state.Quantity}, OptionCount: ${this.OptionCount} `);
    let CD;
    try {
      if (SessionInfo.CustomOrderID === 0) {
        await this.addOrder(); // Add a CustomOrder if required
      }
      // Note - 1 item - 0 options selected
      CD = await CallOMT("AddUpdateOrderItem",TYP.INT,SessionInfo.CustomOrderID,TYP.INT,0,TYP.INT,this.StoreItemID,TYP.DEC,0,TYP.INT,0,TYP.DEC,1,TYP.DEC,0,TYP.STR,'Quick Add');
      if (CD.x.o === 0) {
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
        this.CustomOrderItemID = -2;
      }
      else if (CD.x.o < 9500) {
        trace(`quickAddItemToOrder - AddUpdateOrderItem return data: ${JSON.stringify(CD.d)}`);
        this.CustomOrderItemID = CD.d["CustomOrderItemID"];
        //await this.getCurrentTotal(); - Called in fetchTableInfo
        SessionInfo.PauseOPMonitor = false;
        await this.fetchTableInfo();
      }
      else {
        trace(`quickAddItemToOrder FAIL - AddUpdateOrderItem return data: ${JSON.stringify(CD.d)}`);
        this.CustomOrderItemID = -3;
      }
    } catch (error) {
      await OMTrace(2,`Failure in quickAddItemToOrder - Error: ${error}`);
    }
    return CD;
  }
  //removeItemFromOrder = async (item) => {
  //  this.removeStoreItem(item);
  //}
  //cancelAddChgDel = () => {
  //  this.removeChoose();
  //}
  addItemToFavorites = async (item) => {
    this.cancelAddClick = true;
    //trace("Favorite Item: " + item.StoreItemID);
    let CD = await CallOM("AddFavorites",SessionInfo.CustomOrderID,item.StoreItemID,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`favorite added for item: ${item.StoreItemID}`);
      let ix = this.state.StoreItems.findIndex(storItem => storItem.StoreItemID === item.StoreItemID);
      //trace(`favorite storeItemID: ${item.StoreItemID}, ix: ${ix}`);
      if (ix >= 0) { // Manipulate state array items; https://www.robinwieruch.de/react-state-array-add-update-remove/?msclkid=f39d880ebcdc11ec85f269db7902fa0b
        let StoreItems = this.state.StoreItems.slice();
        StoreItems[ix].IsFavorite = !StoreItems[ix].IsFavorite;
        this.lastCategory = "";
        this.setState({ StoreItems });
      }
    }
  }
  addItemToFavoritesA = async (item) => {
    this.cancelAddClick = true;
    let CD = await CallOM("AddFavorites",SessionInfo.CustomOrderID,item.StoreItemID1,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      let ix = this.state.StoreItems.findIndex(storItem => storItem.StoreItemID1 === item.StoreItemID1);
      if (ix >= 0) { // Manipulate state array items; https://www.robinwieruch.de/react-state-array-add-update-remove/?msclkid=f39d880ebcdc11ec85f269db7902fa0b
        let StoreItems = this.state.StoreItems.slice();
        StoreItems[ix].IsFavorite1 = !StoreItems[ix].IsFavorite1;
        this.lastCategory = "";
        this.setState({ StoreItems });
      }
    }
  }
  addShowPromotion = async (event,item,rowIdx) => {
    event.preventDefault(); // Halt Item Add Event 
    event.stopPropagation();
    SessionInfo.CurrentItem = item;
    await this.addShowPromotionBase(item.StoreItemID,rowIdx)
  }
  addShowPromotionA = async (event,item,rowIdx) => {
    event.preventDefault(); // Halt Item Add Event 
    event.stopPropagation();
    SessionInfo.CurrentItem = this.copyItem(item);
    await this.addShowPromotionBase(item.StoreItemID1,rowIdx)
  }
  addShowPromotionBase = async (storeItemID,rowIdx) => {
    try {
      this.inAddOrderItem = true;
      this.cancelAddClick = true;
      trace(`Promotion StoreItem: ${storeItemID} (OrderPage)`);
      let CD = await CallOM("GetPromotionInfo",SessionInfo.CustomOrderID,storeItemID,0);
      if (CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        trace(`--> Promotion info: ${JSON.stringify(CD.d)}`);
        this.displayPromotion(CD.d,rowIdx);
      }
    } catch {
      this.inAddOrderItem = false;
    } finally {
      this.inAddOrderItem = false;
    }
  }
  //------------------------- Order List Template ----------------------------------------------------------------------------------------------------------------------------
  /*StoreItemHeader = () => {
    return (
      <ListViewHeader className='listOrderHeader'>
        <div className='listHeaderLeft'>
          {SessionInfo.AC.HasTotals === true ?
            <>
              <span className="listOrderHeaderTotal">Total &nbsp;&nbsp;&nbsp;</span>
              <span className="listOrderHeaderMoney" style={{ fontWeight: 'bold' }}>{moneyFormat(this.state.TotalPrice)}</span>
              <br style={{ lineHeight: '2px',fontSize: 'small' }} />
              {this.state.ItemCount === 0 ?
                <span className="listOrderHeaderCount" style={{ left: '210px',}}>No Items Yet</span> : null}
              {this.state.ItemCount === 1 ?
                <span className="listOrderHeaderCount" style={{ left: '210px' }}>1 Item Selected</span> : null}
              {this.state.ItemCount > 1 ?
                <span className="listOrderHeaderCount" style={{ left: '210px' }}>{this.state.ItemCount} Items</span> : null}
              {this.state.TotalQuantity > this.state.ItemCount ?
                <span className="listOrderHeaderQuantity">&nbsp;({this.state.TotalQuantity})</span> : null}
              <span></span>
            </> : null}
        </div>
        {SessionInfo.AC.HasShoppingCart === true ?
          <div className='listHeaderRight'>
            {SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?
              <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} >&nbsp;Place Order &nbsp;</Button> : null}
          </div> :
          <div className='listHeaderCenter'>
            <span style={{ fontSize: '22px',fontWeight: 'bold' }}>&nbsp;Restaurant Menu</span>
          </div>}
      </ListViewHeader>
    );
  }*/
  StoreItemHeader = () => {
    return (
      <ListViewHeader className='listOrderHeader'>
      </ListViewHeader>
    );
  }
  lastCategory = "";
  // Menu Control
  //HasShoppingCart: false,
  //HasTotals: false,
  //HasQuickAdd: false,
  //HasPromotion: false,
  //HasDetail: false,
  //-------------------------------------------------------------------------------------------------------------
  // Menu Layouts - Menulayout
  //---------- Menu Layout 1 -------------------------------------------------------------------
  // Standard/Original Layout - Image on right side, medium size description
  StoreItemFormat1 = props => {
    let rowIdx = props.index;
    //trace(`rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormat1 row: ${rowIdx}, item: ${JSON.stringify(item)}`);
    //trace(`StoreItemFormat - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) { // imageVal has not been set yet
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
      categoryName = this.state.Categories[ix].ProductItemCategory;
      categoryDesc = this.state.Categories[ix].Description;
      this.lastCategory = item.ProductItemCategoryID;
      // Image
      const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
      categoryImage = URL.createObjectURL(imageVal);
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategory">
            {this.state.useCategoryImages ?
              <div className="listOMCatL">
                <Avatar rounded='large' size='large' type='image' className='avatarCategoryPic' >
                  <img src={categoryImage} alt='' style={{ height: '74px',width: '74px' }} title={`${categoryName}`} />
                </Avatar>
              </div> : <div className="listOMCatNIL"> &nbsp;</div>}
            <div className="listOMCatR">
              <span className="listOMCatTitle" style={{ fontWeight: "bold" }} >{categoryName}</span>
              <br style={{ lineHeight: '0px',}} />
              {this.state.useCategoryDesc ?
                <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
            </div>
            <div className='listOMCatRight'>
              {/*<br />
              {SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?
                <CartAdd alt="" stroke={SessionInfo.buttonColor} id="AddItemBtn" title={`Checkout - Shopping Cart`} className="listShoppingCart" onClick={this.onCheckout} /> : null}*/}
            </div>
          </div> : null}

        <div className="listOrderRowML1" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listOMTextDiv1">
            <span className="listOMItemNameML1">{item.ItemName}&nbsp;&nbsp;
              {SessionInfo.AC.HasFavorites === true ?
                <>
                  {item.IsFavorite ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
                </> : null}
              {SessionInfo.AC.HasDietControl === true && item.IsDietModify ?
                <>
                  <span> &nbsp;</span>
                  <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="dietImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                </> : null}
            </span><br />
            <p className="listOMItemDescML1">{item.ItemDescription}</p>
          </div>
          <div className="listOMBuyDiv1">
            <div className="listOMPriceTotalML1">
              <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
              {item.IsSelected ?
                <>
                  <span className="listOMCountML2" > &nbsp; x {item.ItemCount}</span>
                  <span className="listOMTotalML2" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                </> :
                <div>
                  {item.IsQuick && SessionInfo.AC.HasQuickAdd ?
                    <CirclePlus alt="" stroke={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMQuickBuy1" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
                </div>
              }
              {SessionInfo.AC.HasShoppingCart ?
                <div className="listOMCartPromoML1">
                  {item.IsSelected ?
                    <div>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML1" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      {item.HasOptions ?
                        <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML1Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} /> : null}
                    </div>
                    :
                    <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML1" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML1" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </div> : null}
            </div>
            <div className="listOMImageDiv1">
              <Avatar rounded='large' size='large' type='image' className='avatarOrderPic'>
                <img src={item.imageVal} alt='' className='listOrderMenuColImage' title={`${item.ItemName}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />
              </Avatar>
            </div>
          </div>
        </div>
      </div>
    );
  }
  //---------- Menu Layout 2 -------------------------------------------------------------------
  // Alternate Format - Large Image on left side
  StoreItemFormat2 = props => {
    let rowIdx = props.index;
    //trace(`ALT rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormatAlt - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) {
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
      categoryName = this.state.Categories[ix].ProductItemCategory;
      categoryDesc = this.state.Categories[ix].Description;
      this.lastCategory = item.ProductItemCategoryID;
      // Image
      const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
      categoryImage = URL.createObjectURL(imageVal);
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategoryML2">
            {this.state.useCategoryImages ?
              <>
                <div className="listOMCatLML2">
                  <Avatar rounded='large' size='large' type='image' className='avatarCategoryPic' >
                    <img src={categoryImage} alt='' style={{ height: '74px',width: '74px' }} title={`${categoryName}`} />
                  </Avatar>
                </div>
                <div className="listOMCatRML2">
                  <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
                  <br style={{ lineHeight: '0px',}} />
                  {this.state.useCategoryDesc ?
                    <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
                </div>
                <div className='listOMCatRightML2'>
                  {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
                  {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
                </div>
              </> :
              <>
                <div className="listOMCatRMLeft7">
                  <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
                  <br style={{ lineHeight: '0px',}} />
                  {this.state.useCategoryDesc ?
                    <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
                </div>
                <div className='listOMCatRightML7'>
                  {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
                  {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
                </div>
              </>
            }
          </div> : null}

        <div className="listOrderRowML2" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listOMTextDiv2">
            <span className="listOMItemNameML2">{item.ItemName}&nbsp;&nbsp;
              {SessionInfo.AC.HasFavorites === true ?
                <>
                  {item.IsFavorite ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
                </> : null}
              {SessionInfo.AC.HasDietControl === true && item.IsDietModify ?
                <>
                  <span> &nbsp;</span>
                  <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="dietImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                </> : null}
            </span><br />
            <span className="listOMItemDescML2">{item.ItemDescription}</span>
            <div className="listOMFullDescML2">{item.ItemFullDescription}</div>
          </div>
          <div className="listOMBuyDiv2">
            <div className="listOMPriceTotalML2">
              <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
              {item.IsSelected ?
                <>
                  <span className="listOMCountML2" > &nbsp; x {item.ItemCount}</span>
                  <span className="listOMTotalML2" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                </> :
                <div>
                  {item.IsQuick && SessionInfo.AC.HasQuickAdd ?
                    <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMQuickBuy2" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
                </div>
              }
              {SessionInfo.AC.HasShoppingCart ?
                <div className="listOMCartPromoML2">
                  {item.IsSelected ?
                    <div>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML2" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML2Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    </div>
                    :
                    <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML2" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML2" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </div> : null}
            </div>
          </div>
          <div className="listOMImageDiv2">
            <Avatar rounded='large' size='large' type='image' style={{ height: '148px',width: '148px',}}>
              <img src={item.imageVal} alt='' style={{ height: '148px',width: '148px',}} title={`${item.ItemName}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />
            </Avatar>
          </div>
        </div>
      </div>
    );
  }
  //---------- Menu Layout 3 ------------------------------------------------------------------- 
  // Alternate Format - No Image - Large description
  StoreItemFormat3 = props => {
    let rowIdx = props.index;
    //trace(`ALT rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormat3 - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) {
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      try {
        let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
        categoryName = this.state.Categories[ix].ProductItemCategory;
        categoryDesc = this.state.Categories[ix].Description;
        this.lastCategory = item.ProductItemCategoryID;
        // Image
        const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
        categoryImage = URL.createObjectURL(imageVal);
      }
      catch (error) {
        console.error(`Error loading category information: ${error}`);
      }
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategoryML3">
            {/*<Avatar rounded='large' size='large' type='image' className='avatarCategoryPicML3' >*/}
            {this.state.useCategoryImages ?
              <Avatar rounded='large' size='large' type='image' className='avatarCategoryPicML3' >
                <img src={categoryImage} alt='' style={{ height: '74px',width: '100%' }} title={`${categoryName}`} />
              </Avatar> : <div className="listOMCatNIL"> &nbsp;</div>}
            <div className="listOMCatROML3">
              <span style={{ fontSize: 22,color: "white",fontWeight: "bold" }} >{categoryName}</span>
              <br style={{ lineHeight: '0px',}} />
              {this.state.useCategoryDesc ?
                <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
            </div>
            {/*<div className='listOMCatRightOML3'>
              {SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?
                <Button id="checkoutButton" icon="cart" className="largeButtonSq" onClick={this.onCheckout} ></Button> : null}
            </div>*/}
          </div> : null}

        <div className="listOrderRowML3" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listOMTextDiv3">
            <div className="listOMItemNameML3">&nbsp; {item.ItemName}&nbsp;&nbsp;&nbsp;
              {SessionInfo.AC.HasFavorites === true ?
                <>
                  {item.IsFavorite ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
                </> : null}
              {SessionInfo.AC.HasDietControl === true && item.IsDietModify ?
                <>
                  <span> &nbsp;</span>
                  <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="dietImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                </> : null}
            </div>
            {item.ItemDescription.length > 10 ?
              <div className="listTitleML3">{item.ItemDescription}</div> : null}
            <div style={{ fontSize: 13,color: SessionInfo.brandColor1,display: 'block',height: '3px',marginTop: '-15px',marginBottom: '5px' }}>________________________________________</div>
            <div className="listOMFullDescML3">{item.ItemFullDescription}</div>
          </div>
          <div className="listOMBuyDiv3">
            <div className="listOMPriceTotalML3">
              <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
              {item.IsSelected ?
                <>
                  <span className="listOMCountML3" > &nbsp; x {item.ItemCount}</span>
                  <span className="listOMTotalML3" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                </> :
                <div>
                  {item.IsQuick && SessionInfo.AC.HasQuickAdd ?
                    <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMQuickBuy3" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
                </div>
              }
              {SessionInfo.AC.HasShoppingCart ?
                <div className="listOMCartPromoML3">
                  {item.IsSelected ?
                    <div>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML3" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML3Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    </div>
                    :
                    <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML3" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML3" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </div> : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
  //---------- Menu Layout 4 -------------------------------------------------------------------
  // Alternate Format - Small cell size, no image, centered description
  StoreItemFormat4 = props => {
    let rowIdx = props.index;
    //trace(`ALT rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormatAlt - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) {
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
      //trace(`Format4 - Categories: ${JSON.stringify(this.state.Categories)}`);
      categoryName = this.state.Categories[ix].ProductItemCategory;
      categoryDesc = this.state.Categories[ix].Description;
      this.lastCategory = item.ProductItemCategoryID;
      // Image
      const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
      categoryImage = URL.createObjectURL(imageVal);
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategoryML4">
            {/*<div className="listOMCatLML4">
              <Avatar rounded='large' size='large' type='image' className='avatarCategoryPic' >
                <img src={categoryImage} alt='' style={{ height: '74px',width: '74px' }} title={`${categoryName}`} />
              </Avatar>
            </div> : <div className="listOMCatNIL"> &nbsp;</div>}*/}
            <div className="listOMCatRML4">
              <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
              <br style={{ lineHeight: '0px',}} />
              {this.state.useCategoryDesc ?
                <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
            </div>
            <div className='listOMCatRightML4'>
              {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
              {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
            </div>
          </div> : null}

        <div className="listOrderRowML4" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listOMTextDiv4">
            {SessionInfo.AC.HasFavorites === true ?
              <>
                {item.IsFavorite ?
                  <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                  :
                  <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
              </> : null}
            {SessionInfo.AC.HasDietControl === true && item.IsDietModify ?
              <>
                <span> &nbsp;</span>
                <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="dietImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
              </> : null}
            <span className="listOMItemNameML4">&nbsp; {item.ItemName}&nbsp;&nbsp;&nbsp;
            </span><br />
            <span className="listOMItemDescML4">{item.ItemDescription}</span>
          </div>
          <div className="listOMBuyDiv4">
           <div className="listOMPriceTotalML4">
             <span>{item.ItemPrice % 1 === 0 ? `$${item.ItemPrice.toFixed(0)}` : moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
             {item.IsSelected ?
               <>
                 <span className="listOMCountML4" > &nbsp; x {item.ItemCount}</span>
                 <span className="listOMTotalML4" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
               </> :
               <div>
                 {item.IsQuick && SessionInfo.AC.HasQuickAdd && !item.IsSelected ?
                   <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMQuickBuy4" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
               </div>
             }
           </div>
            {SessionInfo.AC.HasShoppingCart ?
              <div className="listOMCartPromoML4">
                {item.IsSelected ?
                  <div>
                    <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML4" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                    {/*<CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML4Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />*/}
                  </div>
                  :
                  <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML4" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                  <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML4" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
              </div> : null}
            {/*  <div className="listOMImageDiv4">*/}
            {/*    <Avatar rounded='large' size='large' type='image' className='avatarOrderPic'>*/}
            {/*      <img src={item.imageVal} alt='' style={{ height: '76px',width: '76px',}} title={`${item.ItemName}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />*/}
            {/*    </Avatar>*/}
            {/*  </div>*/}
          </div>
        </div>
      </div>
    );
  }
  //---------- Menu Layout 5 -------------------------------------------------------------------
  // Alternate Format - Double column, no image, tight format
  StoreItemFormat5 = props => {
    let rowIdx = props.index;
    //trace(`ALT rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormatAlt - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) {
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
      categoryName = this.state.Categories[ix].ProductItemCategory;
      categoryDesc = this.state.Categories[ix].Description;
      this.lastCategory = item.ProductItemCategoryID;
      // Image
      const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
      categoryImage = URL.createObjectURL(imageVal);
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategory">
            {/*<div className="listOMCatL">
                <Avatar rounded='large' size='large' type='image' className='avatarCategoryPic' >
                  <img src={categoryImage} alt='' style={{ height: '74px',width: '74px' }} title={`${categoryName}`} />
                </Avatar>
              </div> : <div className = "listOMCatNIL"> &nbsp;</div>} */}
            <div className="listOMCatRML5">
              <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
              <br style={{ lineHeight: '0px',}} />
              {this.state.useCategoryDesc ?
                <p style={{ fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
            </div>
            <div className='listOMCatRightML5'>
              {/*<br />*/}
              {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
              {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
            </div>
          </div> : null}

        <div className="listOrderRowML5">

          <div className="listOrderRowColLeft" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
            <div className="listOMTextDiv5">
              {SessionInfo.AC.HasFavorites === true ?
                <>
                  {item.IsFavorite ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
                </> : null}
              {SessionInfo.AC.HasDietControl === true ?
                <>
                  {item.IsDietModify ?
                    <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="favoriteImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    : null}
                </> : null}
              <span className="listOMItemNameML5">{item.ItemName}&nbsp;&nbsp;&nbsp;</span><span className="brsmall" />
              <span className="listOMItemDescML5">{item.ItemDescription}</span>
            </div>
            <div className="listOMBuyDiv5">
              <div className="listOMPriceTotalML5">
                <span>{moneyFormat(item.ItemPrice)}</span>
                {item.IsSelected ?
                  <>
                    <span className="listOMCountML5" >x {item.ItemCount}</span>
                    <span className="listOMTotalML5" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                  </> :
                  <div>
                    {item.IsQuick && SessionInfo.AC.HasQuickAdd ?
                      <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMCircleML5" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
                  </div>
                }
                <div className="listOMCartPromoML5">
                  {item.IsSelected ?
                    <div>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML5" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML5Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    </div>
                    :
                    <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML5" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML5" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </div>
              </div>
            </div>
          </div>

          <div className="listOrderRowColRight" onClick={(e) => this.displayAddItemToOrderA(item,rowIdx,false)}>
            {item.HasSecond === true ?
              <>
                <div className="listOMTextDiv5">
                  {item.IsFavorite1 ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName1} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavoritesA(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName1} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavoritesA(item)} />}
                  <span className="listOMItemNameML5">{item.ItemName1}&nbsp;&nbsp;&nbsp;</span><span className="brsmall" />
                  <span className="listOMItemDescML5">{item.ItemDescription1}</span>
                </div>
                <div className="listOMBuyDiv5">
                  <div className="listOMPriceTotalML5">
                    <span >{moneyFormat(item.ItemPrice1)}</span> <br style={{ lineHeight: '0px',}} />
                    {item.IsSelected1 ?
                      <>
                        <span className="listOMCountML5" > &nbsp; x {item.ItemCount}</span>
                        <span className="listOMTotalML5" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                      </> :
                      <div>
                        {item.IsQuick1 && SessionInfo.AC.HasQuickAdd ?
                          <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName1} to the Order`} className="listOMCircleML5" onClick={(e) => this.quickAddItemToOrderA(item)} /> : null}
                      </div>
                    }
                    {SessionInfo.AC.HasShoppingCart ?
                      <div className="listOMCartPromoML5">
                        {item.IsSelected1 ?
                          <div>
                            <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML5" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                            <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML5Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                          </div>
                          :
                          <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName1} to the Order`} className="listOMCartML5" onClick={(e) => this.displayAddItemToOrderA(item,rowIdx,false)} />}
                        {SessionInfo.AC.HasPromotion && item.IsPromotion1 ?
                          <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName1}`} className="listOMPromoML5" onClick={(e) => this.addShowPromotionA(e,item,rowIdx)} /> : null}
                      </div> : null}
                  </div>
                </div>
              </> : null}
          </div>
        </div>
      </div>
    );
  }
  //---------- Menu Layout 6 -------------------------------------------------------------------
  // Alternate Format - Double column, no image, tight format
  StoreItemFormat6 = props => {
    let rowIdx = props.index;
    //trace(`ALT rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormatAlt - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) {
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
      categoryName = this.state.Categories[ix].ProductItemCategory;
      categoryDesc = this.state.Categories[ix].Description;
      this.lastCategory = item.ProductItemCategoryID;
      // Image
      const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
      categoryImage = URL.createObjectURL(imageVal);
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategory">
            {/*<div className="listOMCatL">
                <Avatar rounded='large' size='large' type='image' className='avatarCategoryPic' >
                  <img src={categoryImage} alt='' style={{ height: '74px',width: '74px' }} title={`${categoryName}`} />
                </Avatar>
              </div> : <div className = "listOMCatNIL"> &nbsp;</div>} */}
            <div className="listOMCatRML6">
              <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
              <br style={{ lineHeight: '0px',}} />
              {this.state.useCategoryDesc ?
                <p style={{ fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
            </div>
            <div className='listOMCatRightML6'>
              {/*<br />
              {SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?
                <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
            </div>
          </div> : null}

        <div className="listOrderRowML6">

          <div className="listOrderRowCol6Left" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
            <div className="listOMTextDiv6">
              <span className="listOMItemNameML6">{item.ItemName}&nbsp;&nbsp;&nbsp;</span><span className="brsmall" />
              {SessionInfo.AC.HasFavorites === true ?
                <>
                  {item.IsFavorite ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
                </> : null}
              {SessionInfo.AC.HasDietControl === true ?
                <>
                  {item.IsDietModify ?
                    <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="favoriteImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    : null}
                </> : null}
              <span className="listOMItemDescML6">{item.ItemDescription}</span>
            </div>
            <div className="listOMBuyDiv6">
              <div className="listOMPriceTotalML6">
                <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
                {item.IsSelected ?
                  <>
                    <span className="listOMCountML6" > &nbsp; x {item.ItemCount}</span>
                    <span className="listOMTotalML6" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                  </> :
                  <div>
                    {item.IsQuick && SessionInfo.AC.HasQuickAdd ?
                      <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMCircleML6" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
                  </div>
                }
                <div className="listOMCartPromoML6">
                  {item.IsSelected ?
                    <div>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML6" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML6Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    </div>
                    :
                    <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML6" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML6" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </div>
              </div>
            </div>
            {/*<div className="listOrderMenuCol6ML2">*/}
            <Avatar rounded='large' size='large' type='image' style={{ height: '100px',width: '100px',}}>
              <img src={item.imageVal} alt='' style={{ height: '100px',width: '100px',}} title={`${item.ItemName}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />
            </Avatar>
            {/*</div>*/}
          </div>

          <div className="listOrderRowCol6Right" onClick={(e) => this.displayAddItemToOrderA(item,rowIdx,false)}>
            {item.HasSecond === true ?
              <>
                <div className="listOMTextDiv6">
                  <span className="listOMItemNameML6">{item.ItemName1}&nbsp;&nbsp;&nbsp;</span><span className="brsmall" />
                  {item.IsFavorite1 ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName1} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavoritesA(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName1} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavoritesA(item)} />}
                  <span className="listOMItemDescML6">{item.ItemDescription1}</span>
                </div>
                <div className="listOMBuyDiv6">
                  <div className="listOMPriceTotalML6">
                    <span>{moneyFormat(item.ItemPrice1)}</span> <br style={{ lineHeight: '0px',}} />
                    {item.IsSelected1 ?
                      <>
                        <span className="listOMCountML6" > &nbsp; x {item.ItemCount1}</span>
                        <span className="listOMTotalML6" >{moneyFormat(item.ItemTotal1)} &nbsp;</span>
                      </> :
                      <div>
                        {item.IsQuick1 && SessionInfo.AC.HasQuickAdd ?
                          <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName1} to the Order`} className="listOMCircleML6" onClick={(e) => this.quickAddItemToOrderA(item)} /> : null}
                      </div>
                    }
                    {SessionInfo.AC.HasShoppingCart ?
                      <div className="listOMCartPromoML6">
                        {item.IsSelected1 ?
                          <div>
                            <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML6" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                            <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML6Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                          </div>
                          :
                          <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName1} to the Order`} className="listOMCartML6" onClick={(e) => this.displayAddItemToOrderA(item,rowIdx,false)} />}
                        {SessionInfo.AC.HasPromotion && item.IsPromotion1 ?
                          <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName1}`} className="listOMPromoML6" onClick={(e) => this.addShowPromotionA(e,item,rowIdx)} /> : null}
                      </div> : null}
                  </div>
                </div>
                <Avatar rounded='large' size='large' type='image' style={{ height: '100px',width: '100px',}}>
                  <img src={item.imageVal1} alt='' style={{ height: '100px',width: '100px',}} title={`${item.ItemName1}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />
                </Avatar>
              </> : null}
          </div>
        </div>
      </div>
    );
  }
  //---------- Menu Layout 7 -------------------------------------------------------------------
  // Alternate Format - Large Image on left side
  StoreItemFormat7 = props => {
    let rowIdx = props.index;
    //trace(`ALT rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormatAlt - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) {
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
      categoryName = this.state.Categories[ix].ProductItemCategory;
      categoryDesc = this.state.Categories[ix].Description;
      this.lastCategory = item.ProductItemCategoryID;
      // Image
      const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
      categoryImage = URL.createObjectURL(imageVal);
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategoryML7">
            {this.state.useCategoryImages ?
              <>
                <div className="listOMCatLML7">
                  <Avatar rounded='large' size='large' type='image' className='avatarCategoryPic' >
                    <img src={categoryImage} alt='' style={{ height: '74px',width: '74px' }} title={`${categoryName}`} />
                  </Avatar>
                </div>
                <div className="listOMCatRML7">
                  <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
                  <br style={{ lineHeight: '0px',}} />
                  {this.state.useCategoryDesc ?
                    <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
                </div>
                <div className='listOMCatRightML7'>
                  {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
                  {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
                </div>
              </> :
              <>
                <div className="listOMCatRMLeft7">
                  <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
                  <br style={{ lineHeight: '0px',}} />
                  {this.state.useCategoryDesc ?
                    <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
                </div>
                <div className='listOMCatRightML7'>
                  {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
                  {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
                </div>
              </>
            }
          </div> : null}

        <div className="listOrderRowML7" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listOMImageDiv7">
            <Avatar rounded='large' size='large' type='image' style={{ height: '148px',width: '148px',}}>
              <img src={item.imageVal} alt='' style={{ height: '148px',width: '148px',}} title={`${item.ItemName}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />
            </Avatar>
          </div>
          <div className="listOMBuyDiv7">
            <div className="listOMPriceTotalML7">
              <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
              {item.IsSelected ?
                <>
                  <span className="listOMCountML7" > &nbsp; x {item.ItemCount}</span>
                  <span className="listOMTotalML7" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                </> :
                <div>
                  {item.IsQuick && SessionInfo.AC.HasQuickAdd ?
                    <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMQuickBuy7" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
                </div>
              }
              {SessionInfo.AC.HasShoppingCart ?
                <div className="listOMCartPromoML7">
                  {item.IsSelected ?
                    <div>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML7" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML7Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    </div>
                    :
                    <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML7" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML7" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </div> : null}
            </div>
          </div>
          <div className="listOMTextDiv7">
            <span className="listOMItemNameML7">{item.ItemName}&nbsp;&nbsp;
              {SessionInfo.AC.HasFavorites === true ?
                <>
                  {item.IsFavorite ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
                </> : null}
              {SessionInfo.AC.HasDietControl === true && item.IsDietModify ?
                <>
                  <span> &nbsp;</span>
                  <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="dietImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                </> : null}
            </span><br />
            <span className="listOMItemDescML7">{item.ItemDescription}</span>
            <div className="listOMFullDescML7">{item.ItemFullDescription}</div>
          </div>
        </div>
      </div>
    );
  }
  //---------- Menu Layout 8 -------------------------------------------------------------------
  // Alternate Format - Large Image on left side
  StoreItemFormat8 = props => {
    let rowIdx = props.index;
    //trace(`ALT rowIdx: ${rowIdx}`);
    //trace(props);
    //trace(`top: ${props.Object.scrollTop}`);
    let item = props.dataItem;
    //trace(`StoreItemFormatAlt - item: ${JSON.stringify(item)}`);
    //if (!item.imageVal) {
    //  if (!item.Image) { // Note - blank
    //    item.imageVal = getImageFileFromServer(0,0); // Get Blank
    //  } else {
    //    item.imageVal = imagePrep(item.Image);
    //  }
    //}
    let showCategory = false;
    let categoryName = '';
    let categoryDesc = '';
    let categoryImage = undefined;
    //trace(`CategoryID: ${item.ProductItemCategoryID}, lastCategory: ${this.lastCategory}`);
    if (item.ProductItemCategoryID !== this.lastCategory) {
      showCategory = true;
      let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
      categoryName = this.state.Categories[ix].ProductItemCategory;
      categoryDesc = this.state.Categories[ix].Description;
      this.lastCategory = item.ProductItemCategoryID;
      // Image
      const byteCharacters = window.atob(this.state.Categories[ix].ImageID);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let imageVal = new Blob([byteArray],{ type: 'image/jpeg' });
      categoryImage = URL.createObjectURL(imageVal);
    }

    return (
      <div>
        {showCategory === true ?
          <div className="listOrderCategoryML8">
            {this.state.useCategoryImages ?
              <>
                <div className="listOMCatLML8">
                  <Avatar rounded='large' size='large' type='image' className='avatarCategoryPic' >
                    <img src={categoryImage} alt='' style={{ height: '74px',width: '74px' }} title={`${categoryName}`} />
                  </Avatar>
                </div>
                <div className="listOMCatRML8">
                  <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
                  <br style={{ lineHeight: '0px',}} />
                  {this.state.useCategoryDesc ?
                    <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
                </div>
                <div className='listOMCatRightML8'>
                  {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
                  {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
                </div>
              </> :
              <>
                <div className="listOMCatRMLeft7">
                  <span style={{ fontSize: 22,color: "black",fontWeight: "bold" }} >{categoryName}</span>
                  <br style={{ lineHeight: '0px',}} />
                  {this.state.useCategoryDesc ?
                    <p style={{ fontSize: 18,color: "black",fontWeight: "normal",wordWrap: "true",lineHeight: "100%" }} >{categoryDesc}</p> : null}
                </div>
                <div className='listOMCatRightML7'>
                  {/*{SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?*/}
                  {/*  <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} ></Button> : null}*/}
                </div>
              </>
            }
          </div> : null}

        <div className="listOrderRowML8" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listOMTextDiv8">
            <span className="listOMItemNameML8">{item.ItemName}&nbsp;&nbsp;
              {SessionInfo.AC.HasFavorites === true ?
                <>
                  {item.IsFavorite ?
                    <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
                    :
                    <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
                </> : null}
              {SessionInfo.AC.HasDietControl === true && item.IsDietModify ?
                <>
                  <span> &nbsp;</span>
                  <DietFlag alt="" fill={SessionInfo.dietColor} id="DietarySeclectBtn" title={`${item.ItemName} has Dietary Options`} className="dietImage" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                </> : null}
            </span><br />
            <span className="listOMItemDescML8">{item.ItemDescription}</span>
            <div className="listOMFullDescML8">{item.ItemFullDescription}</div>
          </div>
          <div className="listOMBuyDiv8">
            <div className="listOMPriceTotalML8">
              <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
              {item.IsSelected ?
                <>
                  <span className="listOMCountML8" > &nbsp; x {item.ItemCount}</span>
                  <span className="listOMTotalML8" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
                </> :
                <div>
                  {item.IsQuick && SessionInfo.AC.HasQuickAdd ?
                    <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="listOMQuickBuy8" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
                </div>
              }
              {SessionInfo.AC.HasShoppingCart ?
                <div className="listOMCartPromoML8">
                  {item.IsSelected ?
                    <div>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML8" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML8Add" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />
                    </div>
                    :
                    <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="listOMCartML8" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} />}
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML8" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </div> : null}
            </div>
          </div>
          <div className="listOMImageDiv8">
            <Avatar rounded='large' size='large' type='image' style={{ height: '148px',width: '148px',}}>
              <img src={item.imageVal} alt='' style={{ height: '148px',width: '148px',}} title={`${item.ItemName}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />
            </Avatar>
          </div>
        </div>
      </div>
    );
  }
  //--------- Footer ---------------------------------------------------------------------------------------------------
  /*StoreItemFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listOrderFooter'>
        <div className='listFooterLeft'>
          {SessionInfo.AC.HasTotals === true ?
            <>
              <span className='listName'>SubTotal </span>
              <span className='listMoneyTot'>{moneyFormat(this.state.SubTotalPrice)}</span>
              <br />
              <span className='listName'>Tax </span>
              <span className='listMoneyTot'>{moneyFormat(this.state.TotalTaxAmount)}</span>
              <br />
              <span className='listName'>TOTAL </span>
              <span className='listMoneyTot'>{moneyFormat(this.state.TotalPrice)}</span>
            </> : null}
        </div>
        <div className='listFooterRight'>
          {SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?
            <Button id="checkoutButton2" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} >Place Order</Button> : null}
          <span>&nbsp; <Button id="topButton" icon="arrow-end-up" look="outline" className="largeButton" onClick={this.gotoTop} ></Button></span>
        </div>
      </ListViewFooter>
    );
  }*/
  StoreItemFooter = () => {
    return (
      <ListViewFooter className='listOrderFooter'>
      </ListViewFooter>
    );
  }
  //------------------------------------------------- MultiItems List Template -------------------------------------------------------------------------------------------------------------------------------------------------------
  ItemListHeader = () => {
    return (
      <ListViewHeader className='infoItemChangeListHeader'>
        <span style={{ fontSize: 16,fontWeight: 'bold',color: "darkblue" }} >&nbsp;&nbsp; Choose Item to Change</span> {/* {this.state.chooseItemName} */}
      </ListViewHeader>
    );
  }
  ItemListFormat = props => {
    let item = props.dataItem;
    trace(`line item: ${JSON.stringify(item)}`);
    //let imageVal = undefined;
    //if (item["Image"]) {
    //  let value = item["Image"];
    //  //trace("ImageCell value: " + value);
    //  const byteCharacters = atob(value);
    //  const byteNumbers = new Array(byteCharacters.length);
    //  for (let i = 0; i < byteCharacters.length; i++) {
    //    byteNumbers[i] = byteCharacters.charCodeAt(i);
    //  }
    //  const byteArray = new Uint8Array(byteNumbers);
    //  let image = new Blob([byteArray], { type: 'image/jpeg' });
    //  //trace("image: " + JSON.stringify(image));
    //  imageVal = URL.createObjectURL(image);
    //}
    return (
      <div className="listRow">
        <div className="listColPayM1">
          <span style={{ fontSize: 14,color: "black",fontWeight: 'normal',width: '200px' }} >{this.moneyFormat(item.Price)} x {item.Quantity} : {this.moneyFormat(item.TotalPrice)}</span><span>&nbsp; &nbsp; {item.OptionCount} Options </span>
          {item.OptionsPrice > 0 ? <span> : {this.moneyFormat(item.OptionsPrice)}</span> : null}
          <br />
        </div>
        <div className="listColChangeM3">
          {/*<Button icon="track-changes" className="smallButton" style={{ top: 1,}} onClick={(e) => this.onChangeItem(item)}>Change</Button>*/}
          <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} className="addChange" title={`Change Item `} onClick={(e) => this.onChangeItem(item)} />
        </div>
      </div>
    );
  }
  ItemListFooter = () => {
    return (
      <ListViewFooter className='listFooter3'>
        <div>
          <span style={{ fontSize: 16,fontWeight: 'bold',color: "darkblue" }} >&nbsp; &nbsp;</span>
        </div>
      </ListViewFooter>
    );
  }
  //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Main Order Item Functions
  choiceForItem = async (event,item,rowIdx) => {
    event.stopPropagation();
    trace(`choose For Item: ${JSON.stringify(item)}`);
    this.cancelAddClick = true;
    let storeItemID = item.StoreItemID;
    let itemName = item.ItemName
    this.setState({ chooseItemName: itemName });
    trace(`chooseStore Item: ${JSON.stringify(itemName)}`);
    //trace(`choose - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
    let ix = this.state.selectedItems.findIndex(selItem => selItem.ItemID === storeItemID);
    if (ix < 0)
      trace(`selectedItems do not contain storeItemID: ${storeItemID}`);
    else
      this.CustomOrderItemID = this.state.selectedItems[ix].OrderItemID;
    //trace(`storeItemID: ${storeItemID}, ix: ${rx}, rowIdx: ${rowIdx}, OrderItemID: ${this.CustomOrderItemID}`);
    if (rowIdx > 0)
      this.itemChangeOffset.top = rowIdx * this.listRowHeight + this.listTopHeight;
    else
      this.itemChangeOffset.top = this.listTopHeight;
    this.changeRowIdx = rowIdx;
    // Check for multiple orderItems for same storeItem
    let CD = await CallOM("GetOrderItemsForItem",SessionInfo.CustomOrderID,storeItemID,0);
    if (CD.x.o === 0 || CD.x.o > 9500) {
      //await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      this.props.navigate("/Login");
    } else {
      let ItemsList = CD.d.rows; // List of OrderItems                                 
      trace(`OrderItem info: ${JSON.stringify(CD.d)}, ItemListLth: ${ItemsList.length}`);
      if (ItemsList.length > 0) { // At least one item has been selected
        this.CustomOrderItemID = ItemsList[0].CustomOrderItemID;
        //let item = ItemsList[0]; // The first set
        //trace(`Multi info for: ${itemName}, storeItemID: ${storeItemID}, OrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID} ItemList Lth: ${ItemsList.length}`);
        trace(`Multi Items: ${JSON.stringify(ItemsList)}`);
        //this.setState({ showInfoChange: false });
        await this.setState({ ItemsList }); // Items List in Order for the Item
        // 27Aug24 - This is the number of items selected with options - the options may be different
        if (ItemsList.length > 1) { // Multiple Items have been selected
          this.setState({ OptionStatus: "" });
          this.setState({ showChangeItems: true }); // Show orderitem selection
        }
        else
          this.setState({ showChangeItems: false });
        trace(`====> change Item: ${item.StoreItemID}, Order: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID},${item.CustomOrderItemID}, showChangeItems: ${this.state.showChangeItems}, changeRowIdx: ${this.changeRowIdx} `);
        if (item.CustomOrderItemID && item.CustomOrderItemID > 0)
          this.CustomOrderItemID = item.CustomOrderItemID;
        SessionInfo.CurrentItem = item;
        SessionInfo.PromoStoreItemID = 0;
        SessionInfo.SelectedItems = this.state.selectedItems;
        this.topLevelStoreItem = this.StoreItemID;
        this.cancelAddClick = false;
        await this.displayAddItemToOrder(item,rowIdx,true); // Change
      }
      else
        this.setState({ showChangeItems: false });
    }
  }
  //removeStoreItem = (item) => {
  //  this.setState({ showChangeItems: false });
  //  let storeItemID = item.StoreItemID;
  //  trace(`remove - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
  //  this.deleteOrderStoreItem(storeItemID);
  //  let ix = this.state.selectedItems.findIndex(selItem => selItem.ItemID === storeItemID);
  //  trace(`removeItem: ${storeItemID}, ix: ${ix}`);
  //  this.setState({ selectedItems: this.state.selectedItems.splice(ix,1) });
  //  ix = this.state.StoreItems.findIndex(storItem => storItem.StoreItemID === storeItemID);
  //  trace(`store item: ${storeItemID}, ix: ${ix}`);
  //  if (ix >= 0) {
  //    let StoreItems = this.state.StoreItems.slice();
  //    StoreItems[ix].IsSelected = false;
  //    this.lastCategory = "";
  //    this.setState({ StoreItems });
  //  }
  //}
  //---------------- Promotions ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  displayPromotion = async (row,rowIdx) => {
    trace(`displayPromotion row: ${JSON.stringify(row)}`);
    this.compUpdate = false;
    this.setState({ ComboItems: [] });
    // Retrieved Value Assignment for: StorePromotions
    StorePromotionsO.forEach((elem) => {
      if (elem.n in row) {
        //trace(`Set ${elem.n}: ${row[elem.n]}`);
        let sobj = {};
        try {
          if (elem.t === 34 || elem.t === 35) { // Date, DateTime
            //sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
            sobj[elem.n] = row[elem.n];
            SPV[elem.n] = new Date(row[elem.n]);
          } else if (elem.t === 28) {
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
            //trace(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS);
            SPV[elem.n] = row[elem.n];
          } else {
            sobj[elem.n] = row[elem.n];
            SPV[elem.n] = row[elem.n];
          }
          //trace(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${SPV[elem.n]}`);
          this.setState(sobj);
          // Add item specific code here
          //if (elem.n === 'ImageID')
          //  ImageID = row[elem.n];
        }
        catch (error) {
          trace(`Set StorePromotionsO Field: ${elem.n}, Error: ${error.message}`,5);
        }
      }
    });
    if (SPV.StorePromotionName === "Not Found") {
      this.setState({ showPromo: false });
      this.notifyMessage = "Promotion Not Found";
    }
    else {
      if (SPV.PromoStoreItemID === 0)
        SessionInfo.PromoStoreItemID = SPV.StoreItemID;
      else
        SessionInfo.PromoStoreItemID = SPV.PromoStoreItemID;
      this.setState({ ItemPrice: SessionInfo.CurrentItem.ItemPrice });
      trace(`displayPromotion - PromoStoreItemID: ${SessionInfo.PromoStoreItemID}`);
      this.setState({ stateHasChanged: false });
      let storeItemID = SessionInfo.CurrentItem.StoreItemID;
      if (this.state.selectedItems) {
        trace(`choose - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
        let ix = this.state.selectedItems.findIndex(selItem => selItem.ItemID === storeItemID);
        if (ix < 0)
          trace(`selectedItems does not contain storeItemID: ${storeItemID}`);
        else
          this.CustomOrderItemID = this.state.selectedItems[ix].OrderItemID;
      } else
        SessionInfo.CustomOrderID = 0; // Added 13Jun23
      let rx = this.state.StoreItems.findIndex(storItem => storItem.StoreItemID === storeItemID);
      trace(`display Promotion for storeItemID: ${storeItemID}, ix: ${rx}`);
      if (rx > 0)
        this.promoPopupOffset.top = rowIdx * this.listRowHeight + this.listTopHeight;
      else
        this.promoPopupOffset.top = this.listTopHeight;
      this.setState({ showPromo: true });
      if (SPV.PromotionType === "Combo Price") {
        let CD = await CallOM("GetComboRelatedInfo",SessionInfo.CustomOrderID,SPV.StorePromotionID,0);
        if (CD.x.o === 0)
          await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
        else if (CD.x.o < 9500) {
          //trace(`Related info: ${JSON.stringify(CD.d.rows)}`);
          let ComboItems = CD.d.rows.map(dataItem => Object.assign({ selected: false },dataItem));
          //trace("Related Items: " + JSON.stringify(ComboItems));
          this.setState({ ComboItems });
          //SessionInfo.saveRelatedItems = RelatedItems.slice();
        }
      }
      this.GetPromotionImage(SPV.ImageID);
    }
    this.compUpdate = true;
  }
  //
  GetPromotionImage = async (imageID) => {
    try {
      trace(`GetPromotionImage ID: ${imageID}`);
      let imageURL = await getImageFileFromServer(imageID,4);
      this.setState({ PromotionPhotoURL: imageURL });
      trace("GetPromotionImage Complete ");
    }
    catch (error) {
      trace(`Set GetPromotionImage: ${imageID}, Error: ${error.message}`,5);
    }
  }
  removeChoose = () => {
    this.setState({ showChangeItems: false });
  }
  //--------------------------------------------------------------------------------------------------------------------------------
  onExpandChange = (event) => {
    event.item.expanded = !event.item.expanded;
    this.forceUpdate();
  }
  onMenuItemClick = async (event) => {
    //trace(`MenuItemClick - event: ${JSON.stringify(event.item)}`);
    SessionInfo.StoreName = this.state.StoreName;
    SessionInfo.CurrentTableName = this.state.TableName;
    SessionInfo.SeatName = this.state.SeatName;
    SessionInfo.SeatCount = this.state.SeatCount;
    SessionInfo.ItemCount = this.state.ItemCount;
    trace(`menu event Item: ${event.item.text}`);
    if (SessionInfo.currentItem !== undefined) {
      //trace('Current Item: ' + SessionInfo.currentItem.text);
      SessionInfo.currentItem.selected = false;
    }
    SessionInfo.currentItem = event.item;
    //trace('2 Current Item: ' + SessionInfo.currentItem.text);
    event.item.selected = true;
    event.item.expanded = true;
    //trace(`Event - name: ${JSON.stringify(event.item)}`);
    SessionInfo.MenuSelect = event.item;
    this.keepMenu = false;
    this.setState({ showMenu: false });
    if (SessionInfo.menuAction !== undefined) {
      await SessionInfo.menuAction(); // onMenuItemClick in AppMain.js
    }
    this.forceUpdate();
  }
  setLocation = async (event) => {
    SessionInfo.GuestCount += 1;
    this.QRSeatName = `Guest${SessionInfo.GuestCount}`;
    this.setState({ QRSeatName: this.QRSeatName });
    this.QRCodeLocation = `https://interactmenu.com/?tableid=${SessionInfo.CurrentTableID}&locationid=${SessionInfo.StoreLocationID}&seat=${this.QRSeatName}`;
    trace(`QRLoc: ${this.QRCodeLocation}`);
    this.setState({ showQRCode: true });
  }
  //--------------------------------------------------------------------------------------------------------------------------------
  fetchTableInfo = async () => {
    //trace(`====> fetchTableInfo - pauseGoTo: ${SessionInfo.PauseOPMonitor}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
    if (SessionInfo.PauseOPMonitor === false && SessionInfo.CustomOrderID > 0) {
      this.fetchInProcess = true;
      this.fetchCount = 0;;
      let CD = await CallOM("GetTableInfoForOrder",1,SessionInfo.CustomOrderID,0); // This gets Total and Seat Information for the table - not orderItems - see getCurrentTotal below - or GetCustomOrderTotal
      //trace(`---> TableInfo: ${JSON.stringify(CD.d)}, o: ${CD.x.o}, orderID: ${SessionInfo.CustomOrderID}`);
      if (CD.x.o === 0 || CD.x.o >= 9500)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else {
        if (CD.d && CD.d !== null) {
          try {
            trace(`Status: ${CD.d.Status}, Seat: ${CD.d.SeatName}, Count: ${CD.d.SeatCount}`)
            //trace(`CD.d: ${JSON.stringify(CD.d)}`);
            this.setState({ StoreName: CD.d.LocationName });
            if (CD.d.Status >= 10) { // Order is complete
              SessionInfo.BillPaymentDone = true;
              SessionInfo.BillPaymentComplete = true;
              SessionInfo.firstOrderComplete = true;
              await this.resetOrder();
            } else {
              SessionInfo.CurrentOrderCustomerID = CD.d.CustomerID;
              if (this.state.TableName !== CD.d.TableName)
                this.setState({ TableName: CD.d.TableName });
              if (SessionInfo.CurrentSeat === '') {
                if (this.state.SeatName !== CD.d.SeatName) {
                  this.setState({ SeatName: CD.d.SeatName });
                  SessionInfo.SeatName = CD.d.SeatName;
                }
              }
              if (this.state.SeatCount !== CD.d.SeatCount) {
                this.setState({ SeatCount: CD.d.SeatCount });
                SessionInfo.SeatCount = CD.d.SeatCount;
              }
              //trace(`Check Order has Changed - TotalPrice: ${this.state.TotalPrice},${typeof this.state.TotalPrice} Owe: ${CD.d.Owe},${typeof CD.d.Owe}`);
              if (this.state.TotalPrice !== CD.d.Owe) {
                trace(`Order has Changed - Order Status: ${CD.d.Status}, Seat: ${CD.d.SeatName}, Count: ${CD.d.SeatCount}, TotalPrice: ${this.state.TotalPrice},${typeof this.state.TotalPrice} Owe: ${CD.d.Owe},${typeof CD.d.Owe}`);
                await this.getCurrentTotal(); // Get current totals and selectedItems
                trace(`load (3) - fetchTableInfo - selectedItems count: ${this.state.selectedItems.length}`);
                //trace(`load (3) - fetchTableInfo - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
              }
            }
            //trace(`SeatCount: ${this.state.SeatCount}, Session SC: ${SessionInfo.SeatCount}`);
          } catch (error) {
            await OMTrace(2,`Failure in fetchTableInfo - Error: ${error}`);
          }
        }
        else {
          SessionInfo.CustomOrderID = 0;
        }
      }
    } else {
      let location = parseInt(SessionInfo.StoreLocationID);
      if (Number.isInteger(SessionInfo.CurrentTableID) === false)
        SessionInfo.CurrentTableID = 0;
      let table = parseInt(SessionInfo.CurrentTableID);
      //trace(`GetLocationInfo: location: ${location}, table: ${table}`);
      let CD = await CallOM("GetLocationInfo",location,table,0);
      if (!CD || !CD.d)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else {
        //trace(`LocationInfo: ${JSON.stringify(CD)}`);
        this.setState({ StoreName: CD.d.StoreName });
        this.setState({ TableName: CD.d.TableName });
      }
    }
    this.fetchInProcess = false;
    this.fetchCount = 0;
  }
  //
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  ComboHeader = () => {
    return (
      <ListViewHeader className='listComboHeader'>
        <div className='listComboHeaderLeft'>
          <span style={{ fontSize: 'large',fontWeight: 'bold' }}>Combo Items </span>
        </div>
      </ListViewHeader>
    );
  }
  // 9AUG24 - The following css needs to be changed to combo item specific format - or possibly combine combo item and related item
  ComboItemFormat = props => {
    let item = props.dataItem;
    let imageVal = undefined;
    if (item["Image"]) {
      let value = item["Image"];
      //trace("ImageCell value: " + value);
      const byteCharacters = window.atob(value);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let image = new Blob([byteArray],{ type: 'image/jpeg' });
      //trace("image: " + JSON.stringify(image));
      imageVal = URL.createObjectURL(image);
    }
    return (
      <div className="listOrderRow">
        <div className="listCol1">
          <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >{item.ItemName}&nbsp;&nbsp;&nbsp;
            {/*  {SessionInfo.AC.HasPromotion && item.IsPromotion ?*/}
            {/*    <Promotion alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" />*/}
            {/*    : null}*/}
          </span><br />
          <span style={{ fontSize: 13,color: "black" }} >{item.ItemDescription}</span>
        </div>
        <div className="listOrderMenuComboML"> {/* Needs to be resetup */}
          <div className="listOMPriceTotalML1">
            <span style={{ fontSize: 18,color: "black",fontWeight: "bold" }} >{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
            {item.IsSelected ?
              <>
                <span className="listOMCountML1" > &nbsp; x {item.ItemCount}</span>
                <span className="listOMTotalML1" >{moneyFormat(item.ItemTotal)} &nbsp;</span>
              </> : <br />}
            <div className="listOMCartPromoML1">
              {/*{item.IsSelected ?*/}
              {/*  <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="functionImage" onClick={(e) => choiceForItem(e,item)} />*/}
              {/*  :*/}
              {/*  <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="functionImage" onClick={(e) => displayAddItemToOrder(item)} />}*/}
              {/*  {SessionInfo.AC.HasPromotion && item.IsPromotion ?*/}
              {/*    <Promotion alt="" fill={SessionInfo.attnColor} id="FavoriteSelectBtn" title={`There is a Promotion for ${item.ItemName}`} className="functionImageR" /> : null}*/}
            </div>
          </div>
          <div className="listOMImageDiv1">
            <Avatar rounded='large' size='large' type='image' style={{ height: '76px',width: '76px',}}>
              <img alt="" src={imageVal} style={{ height: '76px',width: '76px',}} title={`${item.ItemName} (Photo Coming}`} onClick={(e) => this.addComboItemToOrder(item)} />
            </Avatar>
          </div>
        </div>
      </div>
    );
  }
  ComboFooter = () => {
    return (
      <ListViewFooter className='listComboFooter'>
        {/*  <div className='listFooterLeft'>*/}
        {/*    <span style={{ fontSize: 'large', fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Combo Items </span>*/}
        {/*  </div>*/}
        {/*  <div className='listFooterRight'>*/}
        {/*  </div>*/}
      </ListViewFooter>
    );
  }
  addComboItemToOrder = async (item) => {
    trace(`Add Related Item: ${item.StoreItemID}, Order: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID}`);
    SetNotify(`Add Related Item: ${item.StoreItemID}, ${item.ItemName}`,NOTIFY.Message);
  }
  //---------- Categories ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  setCategory = async (moveCnt) => {
    //trace(`setCategory: ${JSON.stringify(SessionInfo.categories)}`);
    //this.closePopups(1);
    if (this.catCount <= 0) {
      await this.loadCategories(this.ProductItemGroupID);
      if (this.catCount === 0) {
        SessionInfo.categories[this.PIG] = [];
        this.catCount = 1;
        this.catRange = 1;
        SessionInfo.selectedCategories = [];
        trace(`no categories on setCategory - group: {this.ProductItemGroupID}`);
        this.props.navigate("/AppMain");
        return;
      }
    }
    trace(`setCategory - move: ${moveCnt}, start: ${this.catPosition}, range: ${this.catRange}, count: ${this.catCount}`);
    if (this.catPosition >= this.catCount - this.catRange && moveCnt > 0)
      this.catPosition = 0; // Go to start
    else if (this.catPosition === 0 && moveCnt < 0)
      this.catPosition = this.catCount - this.catRange; // Go to End - Range
    else {
      this.catPosition += moveCnt;
      if (this.catPosition >= this.catCount - this.catRange)
        this.catPosition = this.catCount - this.catRange;
    }
    if (this.catPosition < 0)
      this.catPosition = 0;
    SessionInfo.selectedCategories = [];
    let cnt = 0;
    let max = this.catPosition + this.catRange;
    if (max > SessionInfo.categories[this.PIG].length)
      max = SessionInfo.categories[this.PIG].length;
    trace(`         New - start: ${this.catPosition}, to: ${this.catPosition + this.catRange}, lth: ${SessionInfo.categories[this.PIG].length}`);
    for (let ix = this.catPosition; ix < this.catPosition + this.catRange; ix++) {
      SessionInfo.selectedCategories[cnt++] = SessionInfo.categories[this.PIG][ix];
    }
    //trace(`start: ${this.catPosition}, range: ${this.catRange}, currCat: ${JSON.stringify(SessionInfo.selectedCategories)}`);
  }
  handleCatChangeS = async (cat) => { // Single Selection - the one currently used  
    this.comp2Update = false; // Stop Updates
    try {
      trace(`handle catchange - key: ${cat}, lastCategory: '${this.lastCategory}'`);
      //trace(`saveStoreItems: ${JSON.stringify(SessionInfo.saveStoreItems)}`);
      this.closePopups(3);
      let StoreItems = [];
      let cnt = 0;
      if (cat > 100010) { // Switch ProductItemGroup - with separate Categories & Menu
        trace(`switch Menus - cat: ${cat}, ProductItemGroupID: ${this.ProductItemGroupID}`);
        let PIG = cat - 100010;
        if (PIG != this.ProductItemGroupID) {
          let idx = this.ProductItemGroups.findIndex(dataItem => dataItem.ProductItemGroupID === PIG);
          this.MenuLayoutID = this.ProductItemGroups[idx].MenuLayoutID;
          if (this.MenuLayoutID > 10)
            this.MenuLayoutID -= 10;
          trace(`load items and cats for PIG: ${PIG}, ProductItemGroupID: ${this.ProductItemGroupID}, MenuLayout: ${this.MenuLayoutID}`);
          this.setMenuLayout(this.MenuLayoutID);
          await this.loadItems(PIG);
          await this.loadCategories(PIG);
          this.menuGroup = PIG;
        }
      } else { // Select Items based on Category
        //trace(`handle change - cat: ${cat}`);
        if (cat > 0) {
          SessionInfo.saveStoreItems[this.PIG].forEach(row => {
            //trace(`cat: ${cat}, name: ${row.ItemName}, ItemCat: ${row.ProductItemCategoryID}, Favorite: ${row.IsFavorite}`);
            if (cat == 100000) {
              if (row.IsFavorite === true) {
                StoreItems.push(row);
                cnt++;
              }
            } else if (cat == 100001) {
              if (row.IsPromotion === true) {
                StoreItems.push(row);
                cnt++;
              }
            } else if (cat == 100002) {
              if (row.IsSelected === true) {
                StoreItems.push(row);
                cnt++;
              }
            } else if (cat == 100003) {
              if (row.IsDietModify === true) {
                StoreItems.push(row);
                cnt++;
              }
            } else if (row.ProductItemCategoryID == cat) {
              StoreItems.push(row);
              cnt++;
            }
          });
        }
        trace(`cat match cnt: ${cnt}`);
        this.lastCategory = "";
        if (cnt === 0)
          this.setState({ StoreItems: SessionInfo.saveStoreItems[this.PIG] });
        else
          this.setState({ StoreItems });
      }
      this.lastCategory = "";
    } catch (ex) {
      trace(`CatChange Error: ${ex}`);
    }
    this.comp2Update = true; // Restart Updates
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  getOrderItemRecords = async (search) => { // Get the CustomOrderItems for the current CustomOrder
    //let CD;
    if (!search)
      search = '';
    let CD = await CallOM("GetCustomOrderItems",0,SessionInfo.CustomOrderID,0);
    this.setState({ ItemSelect: "" });
    //trace("Order Items: " + JSON.stringify(CD.d));
    trace("Order o: " + CD.x.o);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      try {
        this.setState({ ItemSelect: search });
        const OrderItems = CD.d.rows.map(dataItem => Object.assign({ selected: false },dataItem));
        this.setState({ OrderItems });
      } catch (error) {
        await OMTrace(2,`Failure in getOrderItemRecords - Error: ${error}`);
      }
    }
  }
  getAddOrderItemRecord = async (barCode) => {
    trace(`CallGetAddStoreItem - Barcode: ${this.barcode}`);
    let CD = await CallOM("GetAddStoreItem",this.CustomOrderID,0,2,barCode);
    this.setState({ ItemSelect: "" });
    trace(`After AddStoreItem: ${JSON.stringify(CD.d)}`);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      try {
        await this.getOrderItemRecords(''); // refetch whole list
        //this.setState({ ItemSelect: search });
        //const StoreItems = CD.d.rows.map(dataItem => Object.assign({ selected: false }, dataItem));
        //this.setState({ StoreItems });
        //this.state.saveStoreItems = StoreItems;
      } catch (error) {
        await OMTrace(2,`Failure in getAddOrderItemRecord - Error: ${error}`);
      }
    }
  }
  deleteOrderItem = async () => {
    let customOrderItemID = this.CustomOrderItemID;
    trace(`deleteOrderItem - Order Item ID: ${customOrderItemID}`);
    await CallOM("DeleteOrderItem",0,customOrderItemID,0);
    await this.getCurrentTotal();
    trace(`load (5) - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
  }
  deleteOrderStoreItem = async (storeItemID) => {
    trace(`deleteOrderStoreItem - Item ID: ${storeItemID}`);
    await CallOM("DeleteOrderStoreItem",SessionInfo.CustomOrderID,storeItemID,0);
    await this.getCurrentTotal();
    trace(`load (4) - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
  }
  // Note - See addOrder in CheckoutPage and in ScannerPage - They need to be consistent
  addOrder = async (seatName) => {
    let CD;
    try {
      if (!SessionInfo.CurrentTableID)
        SessionInfo.CurrentTableID = 0;
      if (!seatName || seatName === '')
        seatName = SessionInfo.CurrentSeat;
      trace(`Create/Get CustomOrder (1) - CustomOrderID: ${SessionInfo.CustomOrderID}, StoreLocationID: ${SessionInfo.StoreLocationID}, TableID: ${SessionInfo.CurrentTableID}, seatName: ${seatName}`);
      if (!seatName || seatName === '') {
        seatName = SessionInfo.PersonInfo.FirstName;
        if (seatName === '')
          seatName = SessionInfo.PersonInfo.LastName;
        if (seatName === '')
          seatName = SessionInfo.logonName;
        trace(`  set seatName: ${seatName}, FirstName: ${SessionInfo.PersonInfo.FirstName}, LastName: ${SessionInfo.PersonInfo.LastName}`);
      }
      SessionInfo.OrderType = 4; // Order at Table
      // Get CustomOrder at Table
      CD = await CallOM("CreateCustomOrderTab",0,SessionInfo.StoreLocationID,CTYP.TypParm,[TYP.INT,SessionInfo.OrderType,TYP.INT,this.state.AddressID,TYP.STR,"",TYP.STR,seatName,TYP.INT,SessionInfo.CurrentTableID]);
      if (!CD || CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        trace(`--> addOrder return data: ${JSON.stringify(CD)}`);
        if (SessionInfo.CustomOrderID != CD.d.CustomOrderID) {
          SessionInfo.CustomOrderID = CD.d.CustomOrderID;
          SessionInfo.IsNewOrder = true;
        }
        trace(`*** CustomOrderID: ${SessionInfo.CustomOrderID}`);
        this.setState({ TableName: CD.d.TableName });
        this.setState({ SeatName: CD.d.SeatName });
        this.setState({ SeatCount: CD.d.SeatCount });
        SessionInfo.CurrentTableName = CD.d.TableName;
        SessionInfo.CurrentTableID = CD.d.TableID;
        SessionInfo.SeatName = CD.d.SeatName;
        SessionInfo.SeatCount = CD.d.SeatCount;
        SessionInfo.ParentOrderID = CD.d.ParentOrderID;
        trace(`CreateCustomOrderTabID: ${SessionInfo.CustomOrderID}, TableName: ${CD.d.TableName}, SeatName: ${CD.d.SeatName}, SeatCount: ${CD.d.SeatCount}, OrderID: ${SessionInfo.CustomOrderID}`);
      }
    } catch (error) {
      await OMTrace(2,`Failure in addOrder - CustomOrderID: ${SessionInfo.CustomOrderID} - Error: ${error}`);
    }
    return CD;
  }
  addCheckForCurrentOrder = async () => { // Called from Component Did Mount
    let CD;
    try {
      if (!SessionInfo.CurrentTableID)
        SessionInfo.CurrentTableID = 0;
      let seatName = SessionInfo.CurrentSeat;
      trace(`CheckFor Current Order - StoreLocationID: ${SessionInfo.StoreLocationID}, TableID: ${SessionInfo.CurrentTableID}, seatName: ${seatName}`);
      if (!seatName || seatName === '') {
        seatName = SessionInfo.PersonInfo.FirstName;
        if (seatName === '')
          seatName = SessionInfo.PersonInfo.LastName;
        if (seatName === '')
          seatName = SessionInfo.logonName;
        trace(`  set seatName: ${seatName}, FirstName: ${SessionInfo.PersonInfo.FirstName}, LastName: ${SessionInfo.PersonInfo.LastName}`);
      }
      SessionInfo.OrderType = 4; // Order at Table
      // Get CustomOrder at Table
      CD = await CallOM("GetCurrentCustomOrder",0,SessionInfo.StoreLocationID,0,"","",SessionInfo.CurrentTableID);
      if (!CD || CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        trace(`--> addOrder return data: ${JSON.stringify(CD)}`);
        if (CD.d.CustomOrderID && CD.d.CustomOrderID > 0) {
          if (SessionInfo.CustomOrderID != CD.d.CustomOrderID) {
            SessionInfo.CustomOrderID = CD.d.CustomOrderID;
            SessionInfo.IsNewOrder = true;
          }
          trace(`*** CustomOrderID: ${SessionInfo.CustomOrderID}`);
          this.setState({ TableName: CD.d.TableName });
          this.setState({ SeatName: CD.d.SeatName });
          this.setState({ SeatCount: CD.d.SeatCount });
          SessionInfo.CurrentTableName = CD.d.TableName;
          SessionInfo.CurrentTableID = CD.d.TableID;
          SessionInfo.SeatName = CD.d.SeatName;
          SessionInfo.SeatCount = CD.d.SeatCount;
          SessionInfo.ParentOrderID = CD.d.ParentOrderID;
          trace(`CreateCustomOrderTabID: ${SessionInfo.CustomOrderID}, TableName: ${CD.d.TableName}, SeatName: ${CD.d.SeatName}, SeatCount: ${CD.d.SeatCount}, OrderID: ${SessionInfo.CustomOrderID}`);
        }
      }
    } catch (error) {
      await OMTrace(2,`Failure in addCheckForCurrentOrder - CustomOrderID: ${SessionInfo.CustomOrderID} - Error: ${error}`);
    }
    return CD;
  }
  // Get Order Totals and OrderItems - stored in selectedItemss
  getCurrentTotal = async () => {
    this.compUpdate = false;
    try {
      trace(`===---> getCurrentTotal - Call GetCustomOrderSelect to get OrderItems - CustomOrderID: ${SessionInfo.CustomOrderID} `);
      let CD = await CallOM("GetCustomOrderSelect",0,SessionInfo.CustomOrderID,0);
      if (CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        trace(`getCurrentTotal - set SelectItems CD.o: ${CD.x.o}  d-count: ${CD.d.length}`);
        //trace(`getCurrentTotal - set SelectItems CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
        if (CD.d) {
          let selectedItems = CD.d.rows;
          SessionInfo.SelectedItems = selectedItems;
          this.setState({ selectedItems }); // Current Items Selected
          CD = await CallOM("GetCustomOrderTotal",0,SessionInfo.CustomOrderID,0);
          //trace(`Total CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
          if (CD.x.o === 0)
            await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
          else if (CD.x.o < 9500) {
            try {
              let SubTotalPrice = parseFloat(CD.d.TotalPrice);
              this.setState({ SubTotalPrice });
              let TotalTaxAmount = parseFloat(CD.d.TotalTaxAmount);
              this.setState({ TotalTaxAmount });
              this.setState({ ItemCount: CD.d.ItemCount });
              this.setState({ TotalQuantity: CD.d.TotalQuantity });
              let TotalPrice = SubTotalPrice + TotalTaxAmount;
              this.setState({ TotalPrice });
              SessionInfo.CurrentOrderCustomerID = CD.d.CustomerID;
              trace(`GetCustomOrderTotal - CurrentOrderCustomerID: ${SessionInfo.CurrentOrderCustomerID}, OrderID: ${SessionInfo.CustomOrderID}, ItemCount: ${CD.d.ItemCount}, selectedItems: ${this.state.selectedItems.length}`);
              //trace(`GetCustomOrderTotal - CurrentOrderCustomerID: ${SessionInfo.CurrentOrderCustomerID}, OrderID: ${SessionInfo.CustomOrderID}, ItemCount: ${CD.d.ItemCount}, selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
            } catch (error) {
              await OMTrace(2,`Failure in getCurrentTotal - Error: ${error}`);
            }
            try {
              if (selectedItems) { //---- Update Icons in Order Page ----
                let changed = false;
                let StoreItems = this.state.StoreItems.slice();
                //trace(`set SELECTED - StoreItems: ${JSON.stringify(StoreItems)}`);
                StoreItems.forEach(storItem => { // Reset Totals - For EACH Store item
                  storItem.ItemTotal = 0.0;
                  storItem.ItemCount = 0;
                  storItem.IsSelected = false;
                  if (storItem.HasSecond === true) {
                    storItem.ItemTotal1 = 0.0;
                    storItem.ItemCount1 = 0;
                  }
                });
                this.state.selectedItems.forEach(item => { // For EACH selected item
                  let ix = StoreItems.findIndex(storItem => storItem.StoreItemID === item.ItemID);
                  if (ix >= 0) {
                    //trace(`storeItems item found - ix: ${ix}, storeItem: ${JSON.stringify(StoreItems[ix])}`)
                    StoreItems[ix].IsSelected = true;
                    StoreItems[ix].ItemTotal += item.Total;
                    StoreItems[ix].ItemCount += item.Count;
                    changed = true;
                    //trace(`load 3 selected - ix: ${ix}, ItemTotal: ${StoreItems[ix].ItemTotal}, item: ${item.Total}`);
                    //this.lastCategory = "";
                  } else { // If it was not found - must mean a second item (two column)
                    ix = StoreItems.findIndex(storItem => storItem.StoreItemID1 === item.ItemID);
                    if (ix >= 0) {
                      //trace(`storeItems ALT - ix: ${ix}, storeItem: ${JSON.stringify(StoreItems[ix])}`)
                      StoreItems[ix].IsSelected1 = true;
                      StoreItems[ix].ItemTotal1 += item.Total;
                      StoreItems[ix].ItemCount1 += item.Count;
                      changed = true;
                    }
                    else {
                      if (menuSelectedKey == 0) // If > 0 currently in category select
                        trace(`*** item: ${item.ItemID} not found in StoreItems - lth: ${StoreItems.length}`);
                    }
                  }
                });
                if (changed === true)
                  this.setState({ StoreItems });
              }
            } catch (error) {
              await OMTrace(2,`Failure in getCurrentTotal set Items - Error: ${error}`);
            }
          }
        } else {
          trace(`getCurrentTotal - Order: ${SessionInfo.CustomOrderID} does not exist (Abandoned and Deleted?)`);
          SessionInfo.CustomOrderID = 0;
        }
      }
    } catch (error) {
      trace(`getCurrentTotal - Order: ${SessionInfo.CustomOrderID} failed: ${error}`);
    }
    this.compUpdate = true;
  }
  onCheckout = async () => {
    if (Object.is(this.state.TotalPrice,NaN)) { // Test for NAN
      this.setState({ TotalPrice: 0.0 });
      window.scrollTo(0,0);
      await CallOM("UpdateCustomOrderType",0,SessionInfo.CustomOrderID,CTYP.TypParm,[TYP.INT,this.state.OrderType,TYP.DT,this.state.RequestDateTime,TYP.INT,this.state.AddressID,TYP.STR,this.state.OrderNotes]);
      SetNotify("Add some Items to your Order",NOTIFY.Alert);
    } else if (this.state.TotalPrice > 0) {
      SessionInfo.PauseOPMonitor = true;
      this.props.navigate("/CheckoutPage");
    }
    else {
      window.scrollTo(0,0);
      SetNotify("Add some Items to your Order",NOTIFY.Warn);
    }
  }
  gotoTop = () => {
    window.scrollTo(0,0);
  }
  //------------- Seats --------------------------------
  showSeats = async () => { // Fetch the current seat orders and Display the Seat Popup
    this.compUpdate = false;
    this.currentOrderChanged = false;
    trace(`Show Seats - CustomerOrderID: ${SessionInfo.CustomOrderID}`);
    if (SessionInfo.CustomOrderID === 0) { // Note - The button should not show until the order is started
      trace(`Add CustomerOrderID`);
      if (SessionInfo.firstOrderComplete === false)
        await this.addOrder(); // Add a CustomOrder if required
    }
    let CD = await CallOM("GetAllCustomOrderNames",0,SessionInfo.CustomOrderID,0);
    if (CD.x.o < 9500) {
      try {
        this.setState({ SetSeatName: '' });
        this.setState({ setName: false });
        if (CD.d) {
          //trace(`GetAllCustomOrderNames - CD.d: ${JSON.stringify(CD.d)}, CustumOrderID: ${SessionInfo.CustomOrderID}`);
          const SeatOrders = CD.d.rows;
          //if (this.state.TotalPrice === 0 && this.seatNameSet === false) {
          if (this.state.TotalPrice === 0 && this.seatNameSet === false) {
            for (let seat of SeatOrders) {
              if (seat.CustomOrderID === SessionInfo.CustomOrderID) {
                seat.Select = true;
                this.setState({ SetSeatName: seat.SeatName });
                this.setState({ setName: true });
                this.seatNameSet = true;
                break;
              }
            }
          }
          this.setState({ SeatOrders });
          this.setState({ showBillSummary: false });
          this.setState({ showSeatsPopup: true });
          if (SeatOrders.length != this.state.SeatCount)
            this.setState({ SeatCount: SeatOrders.length });
          this.forceUpdate();
        } else {
          trace(`GetAllCustomOrderNames - no CD.d: ${JSON.stringify(CD)}, CustumOrderID: ${SessionInfo.CustomOrderID}`);
        }
      } catch (error) {
        await OMTrace(2,`Failure in GetAllCustomOrderNames - Error: ${error}`);
      }
      this.compUpdate = true;
    }
  }
  addSeat = async () => {
    if (this.state.SetSeatName === '') {
      SetNotify("Seat Name Required",NOTIFY.Warn);
    }
    else {
      await this.addOrder(this.state.SetSeatName); // New Seat Requires new Order
      await this.showSeats();
      await this.doneSeats();
    }
  }
  setSeatName = async () => {
    trace(`Set Seat - Name: ${this.state.SetSeatName}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
    let seatName = this.state.SetSeatName;
    trace(`--> Set - setSeatName: ${this.state.SetSeatName}`);
    await CallOM("SetSeatName",0,SessionInfo.CustomOrderID,CTYP.STR,this.state.SetSeatName);
    this.setState({ SetSeatName: '' });
    let current = this.state.SeatOrders.findIndex(dataItem => dataItem.CustomOrderID === SessionInfo.CustomOrderID);
    //trace(`current: ${current}`);
    let SeatOrders = this.state.SeatOrders.slice();
    SeatOrders[current].SeatName = seatName;
    this.setState({ SeatOrders });
    this.setState({ setName: false });
    trace(`seatOrders: ${JSON.stringify(this.state.SeatOrders)}`);
  }
  doneSeats = async () => {
    trace(`doneSeats - OrderID: ${SessionInfo.CustomOrderID}, setSeatName: ${this.state.SetSeatName}`);
    if (this.state.SetSeatName !== '') {
      if (this.state.SetSeatName !== this.state.SeatName) {
        await CallOM("SetSeatName",0,SessionInfo.CustomOrderID,CTYP.STR,this.state.SetSeatName);
        this.setState({ SeatName: this.state.SetSeatName });
      }
      this.setState({ SetSeatName: '' });
    }
    await this.setSelectedFavorites();
    this.setState({ showSeatsPopup: false });
    await this.fetchTableInfo();
  }
  exitSeats = async () => {
    this.setState({ showSeatsPopup: false });
  }
  //------------- Menu --------------------------------
  openMenu = (event) => {
    event.stopPropagation();
    this.closePopups(7);
    trace(`open Menu -  defaultLogon: ${SessionInfo.defaultLogon}, RoleID: ${SessionInfo.PersonInfo.RoleID}`);
    this.keepMenu = true;
    this.setState({ showMenu: true });
    trace(`open Menu - showMenu: ${this.state.showMenu}`);
  }
  //-------------- Search -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  searchButton = async (event) => {
    trace('search Button: ' + this.state.searchValue);
    event.preventDefault();
    event.stopPropagation();
    await this.searchCurrent(this.state.searchValue);
  }
  searchCurrent = async (search) => {
    if (!search || typeof search !== 'string' || search === 'all' || search === 'ALL')
      search = "";
    if (search === undefined)
      search = "";
    trace(`Search for: ${search}`);
    this.itemSearch(search);
  }
  updateSearchValue = async (evt) => { // Original Search Value event handler
    let newValue = evt.value;
    //trace(`searchValue: ${this.state.searchValue}, targetname: ${evt.name}, event.value: ${evt.target.value}, ${newValue}`);
    if (!(newValue.length > 0 && (newValue[0] === '*' || newValue[0] === '`'))) {
      if (newValue.length >= 2 || this.state.lastSearchValue.length > newValue.length) {
        this.setState({ lastSearchValue: newValue });
        this.itemSearch(newValue);
      }
      else {
        this.setState({ lastSearchValue: newValue });
      }
    }
    this.setState({ searchValue: newValue }); // Note - moved save to State to last operation
  }
  chgSrchVal = (event) => {
    this.setState({ searchValue: event.target.value });
    this.setState({ stateHasChanged: true });
    trace(`searchValue: ${this.state.searchValue}, targetname: ${event.target.name}, event.value: ${event.target.value}`);
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ stateHasChanged: true });
    if (!(event.target.value.length > 0 && (event.target.value[0] === '*' || event.target.value[0] === '`'))) {
      if (event.target.value.length >= 2 || this.state.lastSearchValue.length > event.target.value.length) {
        this.setState({ lastSearchValue: event.target.value });
        this.itemSearch(event.target.value);
      }
      else {
        this.setState({ lastSearchValue: event.value });
      }
    }
  }
  chgTAFldVal = (event) => {
    trace(`searchValue: ${this.state.searchValue}, targetname: ${event.target.name}, event.value: ${event.value}`);
    this.setState({ [event.target.name]: event.value });
    this.setState({ stateHasChanged: true });
    if (!(event.value.length > 0 && (event.value[0] === '*' || event.value[0] === '`'))) {
      if (event.value.length >= 2 || this.state.lastSearchValue.length > event.value.length) {
        this.setState({ lastSearchValue: event.value });
        this.itemSearch(event.value);
      }
      else {
        this.setState({ lastSearchValue: event.value });
      }
    }
    this.setState({ showInfoChange: true });
    this.setState({ itemChanged: true });
  }
  itemSearch = async (srchStr) => { // Search for Match
    trace(`ItemSearch - search: ${srchStr}, lth: ${srchStr.length} group lth: ${this.ProductItemGroups.length}`);
    //trace(`saveStoreItems: ${JSON.stringify(SessionInfo.saveStoreItems)}`);
    this.closePopups(3);
    if (srchStr.length > 2) {
      this.comp2Update = false; // Stop Updates
      let StoreItems = [];
      let cnt = 0;
      let cats = [];
      let groupSwitch = false;
      try {
        let srch = new RegExp(srchStr,"i"); // case insensitive
        let groupFnd = 0;
        if (srchStr.length > 3 && this.ProductItemGroups.length > 1) { // Search ProductItemGroups
          for (let ix = 0; ix < this.ProductItemGroups.length; ix++) {
            trace(`grp: ${this.ProductItemGroups[ix].ProductItemGroup}, srch: ${srch}`);
            if (this.ProductItemGroups[ix].ProductItemGroup.search(srch) >= 0) {
              groupFnd = this.ProductItemGroups[ix].ProductItemGroupID;
              this.MenuLayoutID = this.ProductItemGroups[ix].MenuLayoutID;
              break;
            }
          }
          if (groupFnd > 0 && groupFnd != this.menuGroup) { // Load in Categories for new ProductItemGroup
            //trace(`====> ItemGroup Found: ${srchStr}, groupFnd: ${groupFnd}, srch: ${srch}, MenuLayout: ${this.MenuLayoutID}`);
            this.setMenuLayout(this.MenuLayoutID);
            let PIG = groupFnd;
            await this.loadItems(PIG);
            await this.loadCategories(PIG); // Need someway to reset Menu to first item (Left side)
            this.menuGroup = PIG;
            groupSwitch = true;
            this.setState({ searchValue: '' });
          }
        }
        //this.state.Categories.forEach(cat => { // Get the Categories that match
        this.ProductItemCategories.forEach(cat => { // Get the Categories that match
          if (cat.ProductItemCategory.search(srch) >= 0)
            cats.push(cat.ProductItemCategoryID);
        });
        SessionInfo.saveStoreItems[this.PIG].forEach(row => {
          //trace(`search idx: ${row.ItemName.search(srchStr)}, name: ${row.ItemName}, ItemDesc: ${row.ItemDescription.search(srchStr)}, Desc: ${row.ItemDescription}`);
          //trace(`search row: ${JSON.stringify(row)}`);
          let found = false;
          if (cats.length > 0) {
            cats.forEach(catID => {
              if (found == true)
                return;
              if (row.ProductItemCategoryID == catID) {
                StoreItems.push(row);
                cnt++
                found = true;
              }
            });
          }
          if (found == false) {
            if (row.ItemName.search(srch) >= 0) {
              StoreItems.push(row);
              cnt++
            } else if (row.ItemDescription.search(srch) >= 0) {
              StoreItems.push(row);
              cnt++
            }
            else if (row.HasSecond === true) {
              if (row.ItemName1.search(srch) >= 0) {
                StoreItems.push(row);
                cnt++
              } else if (row.ItemDescription1.search(srch) >= 0) {
                StoreItems.push(row);
                cnt++
              }
            }
          }
        });
        this.comp2Update = true; // Start Updates
      } catch (ex) {
        console.error(`itemSearch error: ${ex}`);
      }
      trace(`category match: ${cnt}`);
      this.lastCategory = "";
      if (cnt === 0) {
        this.setState({ StoreItems: SessionInfo.saveStoreItems[this.PIG] });
        //  if (groupSwitch === false)
        //    displayMessage('No Items Found');
      } else
        this.setState({ StoreItems });
    } else { // ALL
      this.setState({ StoreItems: SessionInfo.saveStoreItems[this.PIG] });
    }
  }
  clearSearch = async (event) => { // ClearDisplay, Clear Messages - see updateSearchValue
    trace(`clear search: ${this.state.searchValue}`);
    if (this.state.searchValue !== '') {
      await this.loadItems(this.ProductItemGroupID);
      this.setState({ searchValue: '' });
      this.setState({ lastSearchValue: '' });
      this.setState({ clearSetAll: true });
      this.setState({ stateHasChanged: true });
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  cancelTableQR = async () => {
    //  this.setState({ TableID: this.saveTableID });
    //  codeReader.reset();
    this.handleScan("https://interactmenu.com/?tableid=5&locationid=1"); // Test
  }
  startScan = () => {
    trace('ZXing code reader initialized');
    codeReader.decodeFromInputVideoDevice(undefined,'scannerVideo').then(this.handleScan).catch(this.handleError);
  };
  handleScan = async (data) => {
    trace(`handleScan: ${data}`);
    if (data) {
      this.setState({ scannedString: data });
      codeReader.reset();
      let keyInfo = data.toString();
      trace(`Table Select - date: ${keyInfo}`);
      try {
        let CD = await CallOM("GetTableIDName",SessionInfo.StoreLocationID,0,CTYP.STR,keyInfo);
        trace(`On Return - CD: ${JSON.stringify(CD)}`);
        if (CD && CD.x.o < 9500) {
          if (CD.d) {
            let TableID = parseInt(CD.x.p);
            let TableName = CD.d;
            this.setState({ TableID });
            this.setState({ TableName });
            //let HelpPages = CD.d.rows.map(dataItem => Object.assign({ isFavorite: false,selected: false },dataItem));
          }
        }
        else
          this.showError(`Error on Table Switch`);
      } catch (error) {
        await OMTrace(2,`Failure Table Switch - Error: ${error}`);
      }
    }
  };
  handleError = (err) => {
    console.error(err);
  };
  showSpecial = () => {
    console.trace("Show Special");
    this.specHT = 70;
    document.documentElement.style.setProperty('--header-spec-ht',this.specHT + 'px');
    let HHT = this.baseHT + this.specHT + this.dispHT + this.msgHT;
    document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
  }
  showLocationHours = () => {
    this.setState({ HoursForToday: SessionInfo.HoursForToday });
    //console.trace("Show Store Info"); // This is VERY Different -- console.trace ---
    this.setState({ showStoreInfo: true });
    this.dispHT = 70;
    document.documentElement.style.setProperty('--header-disp-ht',this.dispHT + 'px');
    let HHT = this.baseHT + this.specHT + this.dispHT + this.msgHT;
    document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
  }
  setNotifyMessage = (setOn) => {
    if (setOn === true) {
      this.setState({ showNotify: true });
      this.msgHT = 80;
    } else {
      this.setState({ showNotify: false });
      this.msgHT = 0;
    }
    document.documentElement.style.setProperty('--header-msg-ht',this.msgHT + 'px');
    let HHT = this.baseHT + this.specHT + this.dispHT + this.msgHT;
    document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
  }
  Test1Click = () => {
    //--HeadingHeight: 124px;
    //--header - disp - ht: 0px;
    //--header - msg - ht: 0px;
    console.log(`this.testCnt: ${this.testCnt}`);
    if (this.testCnt < 4) {
      if (this.testCnt === 0) {
        this.testCnt = 1;
        this.dispHT = 60;
        this.msgHT = 0;
        this.setState({ showNotify: false });
      } else if (this.testCnt === 1) {
        this.testCnt = 2;
        this.dispHT = 0;
        this.msgHT = 80;
        this.setState({ showNotify: true });
      } else if (this.testCnt === 2) {
        this.testCnt = 3;
        this.dispHT = 60;
        this.msgHT = 80;
        this.setState({ showNotify: true });
      } else if (this.testCnt === 3) {
        this.testCnt = 4;
        this.dispHT = 0;
        this.msgHT = 0;
        this.setState({ showNotify: false });
      }
      document.documentElement.style.setProperty('--header-spec-ht',this.specHT + 'px');
      document.documentElement.style.setProperty('--header-disp-ht',this.dispHT + 'px');
      document.documentElement.style.setProperty('--header-msg-ht',this.msgHT + 'px');
      let HHT = this.baseHT + this.dispHT + this.msgHT;
      document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
    } else {
      if (this.testCnt === 4) {
        this.testCnt = 5;
        SetNotify("This is a very important Message",NOTIFY.Message);
      }
      else if (this.testCnt === 5) {
        this.testCnt = 6;
        SetNotify("This is an Error Message",NOTIFY.Error);
      }
      else if (this.testCnt === 6) {
        this.testCnt = 7;
        SetNotify("This is an Error Message",NOTIFY.Alert);
      }
      else if (this.testCnt === 7) {
        this.testCnt = 0;
        this.setNotifyMessage(false);
        SetNotify("This is an Error Message",NOTIFY.Alert);
      }
    }

  }
  orderTypeClick = async () => {
    trace(`show OrderTypePopup - Location: ${SessionInfo.StoreLocationID}, OrderType: ${SessionInfo.OrderType}`);
    let CD = await CallOM("GetAvailableTime",SessionInfo.StoreLocationID,this.state.OrderType,0);
    if (CD.d) {
      let ADate = new Date(CD.d);
      this.setState({ RequestDateTime: ADate });
    }
    // Note - Scan Order not currently supported here - doesn't make sense
    if (SessionInfo.OrderType == 1)
      this.setState({ DeliveryOrder: true });
    else if (SessionInfo.OrderType == 2)
      this.setState({ PickupOrder: true });
    else if (SessionInfo.OrderType == 4)
      this.setState({ OrderAtTable: true });
    else if (SessionInfo.OrderType == 5)
      this.setState({ OrderAhead: true });
    else {
      this.setState({ OrderType: 4 });
      SessionInfo.OrderType = 4;
      this.setState({ OrderAtTable: true });
    }
    this.setState({ orderTypeError: false });
    // Load Dictionaries
    if (this.state.ProvinceStateCodesDict.length <= 1) {
      let CD = await GetDropdownData(489030);
      this.setState({ ProvinceStateCodesDict: CD.d });
    }
    if (this.state.CountriesDict.length <= 1) {
      let CD = await GetDropdownData(154824);
      this.setState({ CountriesDict: CD.d });
    }
    this.setState({ showOrderTypePopup: true });
  }
  quitOrderType = async () => {
    if (this.state.stateHasChanged === true)
      displayWarning("Order Type Changes Not Saved")
    this.setState({ showOrderTypePopup: false });
  }
  changeTable = async () => {
    this.saveTableID = this.state.TableID;
    this.setState({ TableID: 0 });
    this.startScan()
  }
  doneOrderType = async () => {
    trace(`doneOrderType - OrderID: ${SessionInfo.CustomOrderID}, request Date: ${this.state.RequestDateTime}, OrderType: ${this.state.OrderType}, TableID: ${this.state.TableID}, TableName: ${this.state.TableName}`);
    let finish = true;
    let nowDate = new Date();
    let OTName = '';
    if (this.state.OrderType == 1) { // Delivery Order
      // Address Information
      if (this.state.RequestDateTime <= nowDate) {
        finish = false;
        this.OTError(`Time for Delivery Required`);
      } else if (this.state.Address === "") {
        finish = false;
        this.OTError(`Address for Delivery Required`);
      } else {
        let propState = {};
        AddressesO.forEach((elem) => { // Get Address fields for Save
          if (elem.n in this.state) {
            propState[elem.n] = this.state[elem.n];
          }
        });
        let CD = await CallOM("SaveCustomerAddress",0,0,CTYP.DICTNO,propState,0); // Save to OM
        let AddressID = parseInt(CD.d);
        trace(`Save Address ID: ${AddressID}`);
        this.setState({ AddressID });
        OTName = "Delivery Order";
      }
    } else if (this.state.OrderType == 2) {
      if (this.state.RequestDateTime <= nowDate) {
        finish = false;
        this.OTError(`Time for Pickup Required`);
      } else {
        this.setState({ PickupOrder: true });
        OTName = "Order For Pickup";
      }
    } else if (this.state.OrderType == 4) {
      this.setState({ OrderAtTable: true });
      OTName = "Order At Table";
    } else if (this.state.OrderType == 5) {
      if (this.state.RequestDateTime <= nowDate) {
        finish = false;
        this.OTError(`Time for Arrival Required`);
      } else {
        this.setState({ OrderAhead: true });
        OTName = "Order Ahead";
      }
    }
    if (finish == true) { // Set common variables and close popup
      this.setState({ currentOrderTypeName: OTName });
      await CallOM("UpdateCustomOrderType",0,SessionInfo.CustomOrderID,CTYP.TypParm,[TYP.INT,this.state.OrderType,TYP.DT,this.state.RequestDateTime,TYP.INT,this.state.AddressID,TYP.STR,this.state.OrderNotes]);
      this.setState({ orderTypeError: false });
      this.setState({ showOrderTypePopup: false });
    }
  }
  doneSelectOrderType = async () => {
    trace(`doneOrderType - OrderID: ${SessionInfo.CustomOrderID}`);
    this.setState({ showSelectOrderTypePopup: false });
    this.setState({ orderTypeError: false });
  }
  selectOrderType = async () => {
    trace(`selectOrderType - OrderID: ${SessionInfo.CustomOrderID}`);
    this.setState({ showSelectOrderTypePopup: true });
    this.setState({ orderTypeError: false });
  }
  OTError = (message) => {
    this.setState({ orderError: message });
    this.setState({ orderTypeError: true });
  }
  chgOTCheckboxVal = async (event) => { // Switch Handling
    let setVal = true;
    this.setState({ orderTypeError: false });
    //if (this.state[event.target.name] === true)
    //  setVal = false;
    //this.setState({ [event.target.name]: setVal });
    this.setState({ DeliveryOrder: false });
    this.setState({ OrderForPickup: false });
    this.setState({ OrderAtTable: false });
    this.setState({ OrderAhead: false });
    if (event.target.name == "DeliveryOrder") {
      this.setState({ DeliveryOrder: true });
      this.setState({ OrderType: 1 });
      SessionInfo.OrderType = 1; // Delivery
      let CD = await CallOM("GetCustomerAddress",1,0,0);
      trace(`CustomerAddress: ${JSON.stringify(CD)}`);
      let row = CD.d;
      this.loadAddressFields(row);
      CD = await CallOM("GetCustomerAddresses",0,0,0); // For 
      //CD = await GetDropdownData(110191);
      trace(`Addresses: ${JSON.stringify(CD.d)}`);
      this.setState({ SavedAddressDict: CD.d.rows });
    } else if (event.target.name == "OrderForPickup") {
      this.setState({ OrderForPickup: true });
      this.setState({ OrderType: 2 });
      SessionInfo.OrderType = 2; // Pickup
    } else if (event.target.name == "OrderAtTable") {
      this.setState({ OrderAtTable: true });
      this.setState({ OrderType: 4 });
      SessionInfo.OrderType = 4; // At Table
    } else if (event.target.name == "OrderAhead") {
      this.setState({ OrderAhead: true });
      this.setState({ OrderType: 5 });
      SessionInfo.OrderType = 5; // Order Ahead
    }
    let CD = await CallOM("GetAvailableTime",SessionInfo.StoreLocationID,SessionInfo.OrderType,0);
    trace(`chgOTCheckboxVal CD: ${JSON.stringify(CD)}`);
    if (CD.d) {
      let ADate = new Date(CD.d);
      this.setState({ RequestDateTime: ADate });
    }
    this.setState({ stateHasChanged: true });
  }
  loadAddressFields = (row) => {
    trace(`load AddressFields`);
    // Retrieved Value Assignment for: Addresses
    AddressesO.forEach(elem => {
      if (elem.n in row) {
        //trace(`Set ${elem.n}: ${row[elem.n]}`);
        let sobj = {};
        try {
          if (elem.t === 34 || elem.t === 35) { // Date, DateTime
            sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
            //sobj[elem.n] = row[elem.n];
            AV[elem.n] = new Date(row[elem.n]);
          } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = row[elem.n];
            //trace(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            AV[elem.n] = row[elem.n];
          } else if (elem.t === 22) { // Bool
            let val = row[elem.n].toString().charAt();
            if (val === '1' || val === 't' || val === 'T') {
              sobj[elem.n] = true;
              AV[elem.n] = true;
            } else {
              sobj[elem.n] = false;
              AV[elem.n] = false;
            }
          } else if (elem.t === 23) { // Decimal
            if (elem.n.indexOf('Percent') >= 0 || elem.n.indexOf('Markup') >= 0) {
              sobj[elem.n] = row[elem.n];
              let sobjS = {};
              sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
              this.setState(sobjS); // Set the String shadow var
              AV[elem.n] = row[elem.n];
            } else { // Decimal
              sobj[elem.n] = row[elem.n];
              AV[elem.n] = row[elem.n];
            }
          } else if (elem.t === 28) { // Money
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
            //trace(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            AV[elem.n] = row[elem.n];
          } else if (elem.t === 41) { // Media - Image or Document
            sobj[elem.n] = row[elem.n];
            AV[elem.n] = row[elem.n];
            if (elem.n === 'ImageID')
              currentImageID = row[elem.n];
          } else if (elem.t === 15) { // Encoded
            //------ Assign Encoded Values ------

            let AList = [];

            let sobjV = {};
            sobjV[`${elem.n}Vals`] = AList; // Set the Vals Array
            this.setState(sobjV); // Set the Vals var
            sobj[elem.n] = row[elem.n];
            //obj[elem.n] = row[elem.n];
            AV[elem.n] = row[elem.n];
            trace(`Encoded sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${AV[elem.n]}`);
          } else { // Default - Number
            sobj[elem.n] = row[elem.n];
            AV[elem.n] = row[elem.n];
          }
          //trace(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${AV[elem.n]}`);
          if (this.state[elem.n] === undefined)
            trace(`=== ${elem.n} is not defined in state ===`);
          this.setState(sobj);
          // Add item specific code here
          //if (elem.n === 'ImageID')
          //  ImageID = row[elem.n];
        }
        catch (error) {
          trace(`Set AddressesO Field: ${elem.n}, Error: ${error.message}`);
        }
      }
    });
  }
  chgOTDTPickerVal = (event) => {
    //trace(event);    
    this.setState({ orderTypeError: false });
    let datetime = event.value;
    let nowdate = new Date();
    let cutoff = new Date(nowdate.getTime() + 30 * 60000);
    if (datetime < cutoff) {
      this.OTError(`Time set to Plus 30 minutes`);
      datetime = cutoff;
    }
    this.setState({ RequestDateTime: datetime });
    this.setState({ stateHasChanged: true });
  }
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  cancelOrder = async () => {
    this.setState({ showSeatsPopup: false });
    this.setState({ showVerifyCancel: true });
  }
  verifiedCancelOrder = async () => {
    let CD = await CallOM("CancelOrder",0,SessionInfo.CustomOrderID,0);
    CD = await CallOM("GetTableInfoForOrder",1,SessionInfo.CustomOrderID,0);
    if (CD && CD.d) {
      this.setState({ SeatCount: CD.d.SeatCount });
      SessionInfo.SeatCount = CD.d.SeatCount;
      SessionInfo.CurrentOrderCustomerID = CD.d.CustomerID;
    }
    this.setState({ showVerifyCancel: false });
    SessionInfo.CustomOrderID = 0;
  }
  skipCancel = async () => {
    this.setState({ showVerifyCancel: false });
    this.setState({ showSeatsPopup: true });
  }
  doneComment = async () => {
    // Save comment and rating
    trace(`Rating: ${this.state.RatingValue}, Comment: ${this.state.ServiceDescription}, OrderID: ${SessionInfo.CustomOrderID}`);
    await CallOM("GuestFeedback",0,this.orderIDForComment,CTYP.TypParm,[TYP.INT,this.state.RatingValue,TYP.STR,this.state.ServiceDescription]);
    this.setState({ showBillSummary: false });
  }
  donePromotion = async () => {
    this.setState({ showPromo: false });
  }
  BoolSelectCell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.SeatSelectClick(props);
      this.doneSeats();
    }
    return (<td><input type="checkbox" checked={value} className="seatCheckbox" onChange={handleChange} /></td>);
  }
  SeatSelectClick = async (event) => {
    let current = this.state.SeatOrders.findIndex(dataItem => dataItem === event.dataItem);
    let SeatOrders = this.state.SeatOrders.slice();
    let currSelect = SeatOrders[current].Select;
    //trace(`current: ${JSON.stringify(SeatOrders[current])}`);
    SeatOrders.forEach(row => {
      row.Select = false;
    });
    if (currSelect === false) {
      SeatOrders[current].Select = true;
      this.setState({ SetSeatName: SeatOrders[current].SeatName });
      if (SessionInfo.CustomOrderID !== SeatOrders[current].CustomOrderID) {
        trace(`current OrderID: ${SessionInfo.CustomOrderID}, new OrderID: ${SeatOrders[current].CustomOrderID}`);
        SessionInfo.CustomOrderID = SeatOrders[current].CustomOrderID; // Note - change current Order based on seat selection
        this.currentOrderChanged = true;
      }
      this.setState({ setName: true });
    } else {
      this.setState({ setName: false });
    }
    this.setState({ SeatOrders });
  }
  //----------------------------------
  ClearMessage = async () => { // ClearDisplay, Clear Messages
    //trace("ClearMessage Pressed - for: " + SessionInfo.currentPage);
    this.setState({ MessagesValue: '' });
    SessionInfo.message = ''; // MessagesValue is set to SessionInfo.message in the Timer loop  
    this.setState({ showSeatsPopup: false }); false
  }
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- 
  chgFldValOT = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ orderTypeError: false });
    this.setState({ stateHasChanged: true });
  }
  chgFldValMask = (event,mask) => {
    //console.log(`chg masked value: ${event.target.value}, mask: ${mask}`);
    this.setState({ [event.target.name]: UnmaskString(event.target.value,mask) });
    //console.log(`chg masked - name: ${event.target.name}:${event.target.value}`);
  }
  chgOTInstructions = async (evt) => {
    this.setState({ OrderNotes: evt.target.value });
    this.setState({ orderTypeError: false });
  }
  chgAddressOTDDFldVal = async (event) => {
    trace(`Set Current : ${JSON.stringify(event.target.value)}`);
    this.setState({ AddressID: event.target.value.AddressID });
    this.setState({ Address: event.target.value.Address });
    let AddressID = event.target.value.AddressID;
    let CD = await CallOM("GetCustomerAddress",1,AddressID,0);
    trace(`CustomerAddress: ${JSON.stringify(CD)}`);
    let row = CD.d;
    this.loadAddressFields(row);
    this.setState({ stateHasChanged: true });
  }
  //-------------------       
  chgRateFldVal = (event) => { 
    event.stopPropagation();
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ stateHasChanged: true });
  }
  chgFldVal = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ stateHasChanged: true });
  }
  chgMoneyFldVal = (event) => {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    this.setState({ [event.target.name]: newVal });
  }
  chgPercentFldVal = (event) => {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    //trace("percent newval: " + newVal);
    newVal /= 100.0;
    this.setState({ [event.target.name]: newVal });
    this.setState({ stateHasChanged: true });
  }
  chgDDFldVal = (event) => {
    this.setState({ [event.target.props.name]: event.target.value.ddID });
    this.setState({ stateHasChanged: true });
  }
  chgAddressDDFldVal = (event) => {
    this.setState({ [event.target.name]: event.target.value.ddName });
    this.setState({ stateHasChanged: true });
  }
  chgCheckboxVal = (event) => {
    let setVal = true;
    if (this.state[event.target.name] === true)
      setVal = false;
    this.setState({ [event.target.name]: setVal });
    this.setState({ stateHasChanged: true });
  }
  chgRateVal = (event) => {
    //event.stopPropagation();
    trace(`Rate Value: ${event.value}, Name: ${event.target.props.name}`);
    console.log(event);
    this.setState({ [event.target.props.name]: event.value });
    this.setState({ stateHasChanged: true });
    this.billTimer = 100; // Reset Bill timer to make sure time for comment
    trace(`billTime: ${this.billTimer}`);
  }
  ClearMessage = async () => { // ClearDisplay, Clear Messages
    //trace("ClearMessage Pressed - for: " + SessionInfo.currentPage);
    this.setState({ MessagesValue: '' });
    SessionInfo.message = ''; // MessagesValue is set to SessionInfo.message in the Timer loop
    SessionInfo.acknowledge = false;
    this.setNotifyMessage(false);
  }
  chgFldValQR = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ stateHasChanged: true });
    this.QRSeatName = event.target.value;
    this.QRCodeLocation = `https://interactmenu.com/?tableid=${SessionInfo.CurrentTableID}&locationid=${SessionInfo.StoreLocationID}&seat=${this.QRSeatName}`;
  }
  clearSeatName = async (event) => { // ClearDisplay, Clear Messages - see updateSearchValue
    trace(`clear SeatName: ${this.state.searchValue}`);
    if (this.state.QRSeatName !== '') {
      await this.loadItems(this.ProductItemGroupID);
      this.setState({ QRSeatName: '' });
      this.setState({ lastSearchValue: '' });
    }
  }
  onMenuBackClick = (item) => {
    this.setState({ showMenu: false });
  }
  //------  Set State for ListView -------
  //onSetListCurrent = () => {
  //  this.setState({ TotalPrice: this.state.TotalPrice });
  //  this.setState({ ItemCount: this.state.ItemCount });
  //  this.setState({ SubTotalPrice: this.state.SubTotalPrice });
  //  this.setState({ TotalTaxAmount: this.state.TotalTaxAmount });
  //}
  gotoLanding = async () => {
    trace("Go To LandingPage");
    this.props.navigate("/LandingPage");
  }
  //<img src={SessionInfo.LogoImageURL} alt='' style={{ height: '100px',width: '60px' }} onClick='((e) => this.gotoLanding())'/>
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // OrderItem Detail Code
  // Note - see displayAddFullItemToOrder() after componentdidmount
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  saveCurrentItemInfo = () => {
    trace(`push - Level: ${this.SIVSaveLvl}`);
    this.SIVSaveLvl++;
    let ix = this.SIVSaveLvl;
    //trace(`SaveVals: ${JSON.stringify(SIV)}`);
    this.SIVSave[ix] = { ...SIV };
    //trace(`SaveVals: ${JSON.stringify(this.SIVSave[ix])}`);
    //                                      
    this.SAVQuantity[ix] = this.state.Quantity;
    this.SAVshowInfo[ix] = this.showInfo;
    this.SAVshowInfoChange[ix] = this.state.showInfoChange;
    this.SAVshowOption[ix] = this.state.showOption.slice();
    this.SAVshowOptionGrid[ix] = this.state.showOptionGrid.slice();
    //--
    this.SAVoptionNames[ix] = this.state.optionNames.slice();
    this.SAVoptionStates[ix] = this.state.optionStates.slice();
    this.SAVoptionMultiCnt[ix] = this.state.optionMultiCnt.slice();
    this.SAVallowMulti[ix] = this.state.allowMulti.slice();
    this.SAVchoiceRequired[ix] = this.state.choiceRequired.slice();
    //
    this.SAVoptionChoice[ix] = this.state.optionChoice.slice();
    this.SAVoptionChoiceCnt[ix] = this.state.optionChoiceCnt.slice();
    //--
    this.SAVoptionTotal[ix] = this.state.optionTotal.slice();
    this.SAVOptions[ix] = this.state.Options.slice();
    trace(`==> OPTIONS Saved - ix: ${ix}`);
    //
    this.SAVRelatedItems[ix] = this.state.RelatedItems.slice();
    //===============================
    this.SAVProductItemPhotoURL[ix] = this.state.ProductItemPhotoURL;
    this.SAVSpecialInstruction[ix] = this.state.SpecialInstruction;
    this.SAVOptionsPrice[ix] = this.state.OptionsPrice;
    this.SAVPromotionPrice[ix] = this.state.PromotionPrice;
    this.SAVisItemChange[ix] = this.state.isItemChange;
    this.SAVStatus[ix] = this.state.OptionStatus;
    this.SAVTotalPrice[ix] = this.state.TotalPrice;
    this.SAVTotalItemPrice[ix] = this.state.TotalItemPrice;
    this.SAVItemDescription[ix] = this.state.ItemDescription;
    //this.SAVx[ix] = this.state.x;
    //this.SAVx[ix] = this.state.x;
    this.SAVoptionTotal[ix] = this.state.optionTotal;
  }
  restoreCurrentItemInfo = async () => {
    trace(`restore - Level: ${this.SIVSaveLvl}`);
    if (this.SIVSaveLvl >= 0) {
      let ix = this.SIVSaveLvl;
      let SIVals = { ...this.SIVSave[ix] }; //.slice();
      //trace(`Restore Vals: ${JSON.stringify(this.SIVSave[ix])}`);
      this.SIVSaveLvl--;
      let sobj = {};
      StoreItemsO.forEach((elem) => {
        try {
          let sobj = {};
          sobj[elem.n] = this.SIVSave[ix][elem.n];
          if (elem.n === "StoreItemID")
            this.StoreItemID = this.SIVSave[ix][elem.n];
          //trace(`Set state sobj: ${JSON.stringify(sobj) }`);
          this.setState(sobj);
        } catch (error) {
          trace(`Error Set state sobj: ${JSON.stringify(sobj)} Error: ${error.message}`);
        }
      });
      await this.restoreOptions(ix);
      this.setDisplayHeights();
    }
  }
  resetOptions = () => {
    this.setState({ Quantity: 1 });
    this.setState({ showInfo: false });
    this.showInfo = false;
    this.setState({ showInfoChange: false });
    const showOption = [false,false,false,false,false,false,false,false,false,false];
    this.setState({ showOption });
    const showOptionGrid = [true,true,true,true,true,true,true,true,true,true];
    this.setState({ showOptionGrid });
    const optionChoice = [0,0,0,0,0,0,0,0];
    this.setState({ optionChoice });
    const optionChoiceCnt = [0,0,0,0,0,0,0,0];
    this.setState({ optionChoiceCnt });
    const optionTotal = [0,0,0,0,0,0,0,0];
    this.setState({ optionTotal });
    this.setState({ RelatedItems: [] });
    this.RelatedItemCount = 0;
    this.OptionCount = 0;
    this.AllOptionsDone = false;
    this.LoadFull = false;
    this.detailHeaderHeight = 0;
    this.listHeight = 0;
    this.popupHeight = 0;
    this.hideItemImage = false;
    document.documentElement.style.setProperty('--options-image-height',`${this.imageHeight}px`); // Image Height  
    this.setState({ hideOptionImage: false });
    this.setState({ isItemChange: false });
    this.setState({ SpecialInstruction: '' });
  }
  saveCurrentOptions = async () => {
    this.saveoptionKeys = this.optionKeys.slice();
    this.SAVoptionNames = this.optionNames.slice();
    //trace(`**** saveCurrent - optionName: ${JSON.stringify(this.SAVoptionNames)}`);
    this.SAVoptionGroupID = this.optionGroupID.slice();
    this.SAVoptionStates = this.optionStates.slice();
    this.SAVOptions = this.Options.slice();
    //trace(`**** saveCurrent - options: ${JSON.stringify(this.SAVOptions)}`);
    this.saveOptionCount = this.OptionCount;
    //trace(`==> OPTIONS Saved in saveCurrent - Count: ${this.saveOptionCount}`);
    this.SAVExistQty = this.ExistQty;
    this.SAVAllOptionsDone = this.AllOptionsDone;
    this.SAVLoadFull = this.LoadFull;
    this.SAVdetailHeaderHeight = this.detailHeaderHeight;
    trace(`saveCurrentOptions - detailHeaderHeight: ${this.detailHeaderHeight}, SAVdetailHeaderHeight: ${this.SAVdetailHeaderHeight}, `);
    this.SAVdescAdjust = this.descAdjust;
    this.SAVlistHeight = this.listHeight;
    this.SAVpopupHeight = this.popupHeight;
    if (this.hideItemImage === true)
      this.stopScroll = true;
    this.SAVhideItemImage = this.hideItemImage;
    trace(`*** save options - LoadFull: ${this.LoadFull}, detailHeaderHeight: ${this.detailHeaderHeight}, listHeight: ${this.listHeight}, popupHeight: ${this.popupHeight}`);
  }
  restoreOptions = async (ix) => {
    // state restore
    trace(`*** restore options - ix: ${ix}`);
    this.setState({ Quantity: this.SAVQuantity[ix] });
    this.setState({ showInfo: this.SAVshowInfo[ix] });
    this.showInfo = this.SAVshowInfo[ix];
    this.setState({ showInfoChange: this.SAVshowInfoChange[ix] });
    this.setState({ showOption: this.SAVshowOption[ix] });
    this.setState({ showOptionGrid: this.SAVshowOptionGrid[ix] });
    this.setState({ optionChoice: this.SAVoptionChoice[ix] });
    this.setState({ optionChoiceCnt: this.SAVoptionChoiceCnt[ix] });
    let RelatedItems = this.SAVRelatedItems[ix].slice();
    //SessionInfo.saveRelatedItems = this.SAVRelatedItems[ix].slice();
    if (SessionInfo.SelectedItems) {
      //trace(`Selected Items: ${JSON.stringify(SessionInfo.SelectedItems)}`);
      SessionInfo.SelectedItems.forEach(item => {
        let ix = RelatedItems.findIndex(relItem => relItem.StoreItemID === item.ItemID);
        //trace(`SelectedItem: ${JSON.stringify(item)}, ix: ${ix}`)
        if (ix >= 0) {
          RelatedItems[ix].selected = true;
          RelatedItems[ix].ItemTotal = item.Total;
        }
      });
    }
    this.setState({ RelatedItems });
    //
    this.setState({ ProductItemPhotoURL: this.SAVProductItemPhotoURL[ix] });
    this.setState({ SpecialInstruction: this.SAVSpecialInstruction[ix] });
    this.setState({ OptionsPrice: this.SAVOptionsPrice[ix] });
    this.setState({ PromotionPrice: this.SAVPromotionPrice[ix] });
    this.setState({ isItemChange: this.SAVisItemChange[ix] });
    this.setState({ OptionStatus: this.SAVStatus[ix] });
    this.setState({ TotalPrice: this.SAVTotalPrice[ix] });
    this.setState({ TotalItemPrice: this.SAVTotalItemPrice[ix] });
    this.setState({ ItemDescription: this.SAVItemDescription[ix] });
    this.setState({ DescHeight: this.SAVdescAdjust });
    //this.setState({ RelatedItems: this.SAVRelatedItems[ix] });
    //this.setState({ x: this.SAVx[ix] });
    await this.setState({ optionTotal: this.SAVoptionTotal[ix] });
    this.OptionCount = 0;
    //-------------------------------------------------------------------------
    // Restore Non state      
    this.optionKeys = this.saveoptionKeys;
    this.optionNames = this.SAVoptionNames.slice();
    this.optionGroupID = this.SAVoptionGroupID.slice();
    this.optionStates = this.SAVoptionStates.slice();
    this.Options = this.SAVOptions.slice();
    this.OptionCount = this.saveOptionCount;
    this.ExistQty = this.SAVExistQty;
    this.AllOptionsDone = this.SAVAllOptionsDone;
    this.LoadFull = this.SAVLoadFull;
    this.detailHeaderHeight = this.SAVdetailHeaderHeight;
    trace(`restoreCurrentOptions - detailHeaderHeight: ${this.detailHeaderHeight}, SAVdetailHeaderHeight: ${this.SAVdetailHeaderHeight}, `);
    this.descAdjust = this.SAVdescAdjust;
    this.listHeight = this.SAVlistHeight;
    this.popupHeight = this.SAVpopupHeight;
    this.hideItemImage = this.SAVhideItemImage;
    // Set Option State Values
    //trace(`opt Names: ${JSON.stringify(this.optionNames)}, save: ${this.SAVoptionNames}`);
    this.setState({ optionNames: this.optionNames });
    this.setState({ optionStates: this.optionStates });
    //trace(`options: ${JSON.stringify(this.Options)}`);
    this.setState({ Options: this.Options }); // Save the collection of actual Options
    document.documentElement.style.setProperty('--options-image-height',`${this.imageHeight}px`); // Image Height  
    document.documentElement.style.setProperty('--options-header-height',`${this.detailHeaderHeight}px`); // header Height - Image Height     
    if (this.hideItemImage === true) { // This is restored control                               
      await this.setState({ hideOptionImage: true });
      document.documentElement.style.setProperty('--options-image-height','0px'); // Hide Image
    }
    //this.hideImage();  
    //  trace(`*** restore options - LoadFull: ${this.LoadFull}, detailHeaderHeight: ${this.detailHeaderHeight}, listHeight: ${this.listHeight}, popupHeight: ${this.popupHeight}, hideItemImage: ${this.hideItemImage}`);
    //  trace(`DISPLAY restore headerHT: ${this.detailHeaderHeight}, descAdjust: ${this.descAdjust}, imageHT: ${this.imageHeight}, listHT: ${this.listHeight}, popupHT: ${this.popupHeight}`);
  }
  //---------------- Promotions ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  dbAddPromotionItemToOrder = async (item) => {
    trace(`db Add Item to Order - StoreItem: ${SessionInfo.PromoStoreItemID}`);
    this.StoreItemID = SessionInfo.PromoStoreItemID;
    try {
      let currentND = -1;
      await this.addUpdateOrderItem(); // Add the OrderItem to the Order
      this.setState({ showPromo: false });
      this.fetchTableInfo(); // Setup Initial Table Info
    }
    catch (error) {
      trace(`Failure in dbAddPromotionItemToOrder - msg: ${error}`);
    }
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  RelatedHeader = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewHeader className='listRelatedHeader'>
        <span>&nbsp;&nbsp;&nbsp;Related Items</span>
      </ListViewHeader>
    );
  }
  RelatedItemFormat = props => {
    let rowIdx = props.index;
    let item = props.dataItem; // Note - this is JUST the StoreItem - not OrderItem - so no Total or Quantity Info
    //trace(`RelatedItem row: ${rowIdx}, item: ${item.ItemDescription}, selected: ${item.selected}`);
    if (!item.imageVal) {
      if (item.Image) {
        let value = item["Image"];
        //trace("ImageCell value: " + value);
        const byteCharacters = atob(value);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let image = new Blob([byteArray],{ type: 'image/jpeg' });
        //trace("image: " + JSON.stringify(image));
        item.imageVal = URL.createObjectURL(image);
      }
    }
    return (
      <div className="listRelatedRow">
        <div className="listRelatedCol1">
          <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >{item.ItemName}</span>
          <br />
          <span style={{ fontSize: 13,color: "black" }} >{item.ItemDescription}</span>
        </div>
        <div className="listRelatedColR">
          <div className="listRelatedCol2">
            <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
            {item.selected === true ?
              <span className="listRelatedColRTot" >{moneyFormat(item.ItemTotal)} &nbsp;</span> : null}
            <div className="listRelatedIconLine">
              {item.selected === true ?
                <div>
                  {/*<CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listOMCartML1" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />*/}
                  <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="functionImage" onClick={(e) => this.addRelatedItemToOrder(item)} />
                </div>
                :
                <CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="functionImage" onClick={(e) => this.addRelatedItemToOrder(item)} />}
              {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listRelatedColPromo" onClick={(e) => this.addShowPromotion(item,rowIdx)} /> : null}
            </div>
          </div>
          <div className="listRelatedCol4">
            <Avatar rounded='large' size='large' type='image' style={{ height: '76px',width: '76px',}}>
              <img src={item.imageVal} style={{ height: '76px',width: '76px',}} title={`${item.ItemName}`} onClick={(e) => this.addRelatedItemToOrder(item)} />
            </Avatar>
          </div>
        </div>
      </div>
    );
  }
  RelatedFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listRelatedFooter'>
        {/*  <span >&nbsp;&nbsp;&nbsp;Related Items </span>*/}
      </ListViewFooter>
    );
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // OrderItem Detail - Related Items
  addRelatedItemToOrder = async (item) => {
    trace(`Show Related Item: ${item.StoreItemID}, Order: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID}, Current Item: ${this.StoreItemID}, update: ${this.compUpdate}, detailHeaderHeight: ${this.detailHeaderHeight}`);
    this.StoreItemID = item.StoreItemID;
    //this.OffsetToUse = this.addItemDetailPopupOffset.top; // Use Existing Detail Popup Top
    this.backMenuPrompt = '< Back to Previous';
    await this.pushCurrentOptionState(item,0);
    ItemDetailSecondLevel = true;
  }
  choiceForRelatedItem = async (item) => {
    this.cancelAddClick = true;
  }
  pushCurrentOptionState = async (item,rowIdx) => {
    // Push to Second Level
    this.compUpdate = false; // Stop Updates
    trace(`pushCurrent - ItemDetailSecondLevel: ${ItemDetailSecondLevel}`);
    if (ItemDetailSecondLevel === false) { // Go down a level - push the current state
      //SessionInfo.OrderItemPage = this.state; // Save current State
      ItemDetailSecondLevel = true;
      //trace(`save State: ${JSON.stringify(this.state)}`);
      this.saveCurrentItemInfo();
      this.saveCurrentOptions();
      this.resetOptions(); // This is done in displayAddFullItemToOrder
      this.SAVdisplayItemDetail = this.state.displayItemDetail;
      this.setState({ displayItemDetail: false });
      this.SAVitemChanged = this.state.itemChanged;
      this.setState({ itemChanged: false });
      await this.displayAddItemToOrder(item,rowIdx,false);
      trace(`after loadStoreItem in pushCurrentOptionState - ItemPrice: ${this.state.ItemPrice}, PromoPrice: ${this.state.PromotionPrice}, ItemDetailSecondLevel: ${ItemDetailSecondLevel}`);
    }
    this.compUpdate = true;
    this.setNotifyMessage(false);
  }
  popCurrentOptionState = async (item,rowIdx) => {
    // Pop from Second Level
    this.compUpdate = false; // Stop Updates         
    trace(`popCurrent - ItemDetailSecondLevel: ${ItemDetailSecondLevel}`);
    if (ItemDetailSecondLevel === true) {
      trace(`pop Options - return from Second Level - Name: ${this.state.ItemName}, Desc: ${this.state.ItemDescription}`);
      await this.restoreCurrentItemInfo();
      trace(`after restore - Name: ${this.state.ItemName}, Desc: ${this.state.ItemDescription}, Session-Item: ${this.StoreItemID}`);
      //this.setState({ ItemName: "X" });
      //this.setState({ ItemDescription: "Y" });
      //trace(`restore State: ${JSON.stringify(this.state)}`);
      ItemDetailSecondLevel = false;
      trace(`---> OptionCount(2): ${this.OptionCount}`);
      this.setState({ displayItemDetail: this.SAVdisplayItemDetail });
      this.setState({ itemChanged: this.SAVitemChanged });
      SessionInfo.PauseOPMonitor = false;
      this.fetchTableInfo(); // Setup Initial Table Info
    } else {
      this.OptionCount = 0;
    }
    this.compUpdate = true;
    this.setNotifyMessage(false);
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  BoolOpt0Cell = (props) => {
    //trace("checkbox:  inEdit: " + JSON.stringify(props.dataItem));
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      e.stopPropagation();
      //trace("--> checkbox: " + value + " e.target.val: " + e.target.value + " props: " + JSON.stringify(props.dataItem));
      this.Option0Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option0Click = async (props) => {
    //trace("Options1: " + JSON.stringify(this.state.Options1));
    //trace("dataItem: " + JSON.stringify(event.dataItem));
    let current = this.state.Options[0].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op0bgc: { backgroundColor: SessionInfo.barBack } });
    //trace("current: " + JSON.stringify(current));
    let newState = !this.state.Options[0][current].Select;
    //this.state.Options[0][current].Select = newState;
    this.OnOptionItemSelected(0,this.state.Options[0][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
  }
  Open0Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[0] = true;
    this.setState({ showOptionGrid });
  }
  //------- 1 -------
  BoolOpt1Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option1Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option1Click = async (props) => {
    let current = this.state.Options[1].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op1bgc: { backgroundColor: SessionInfo.barBack } });
    //let newState = !this.state.Options[1][current].Select;
    //this.state.Options[1][current].Select = newState;
    this.OnOptionItemSelected(1,this.state.Options[1][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[0] === false || (this.state.optionChoiceCnt[0] > 0 && this.state.optionChoiceCnt[0] >= this.state.optionMultiCnt[0])) {
      //this.optionNC(0);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[0] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open1Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[1] = true;
    this.setState({ showOptionGrid });
  }
  //------- 2 -------
  BoolOpt2Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option2Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option2Click = async (props) => {
    let current = this.state.Options[2].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op2bgc: { backgroundColor: SessionInfo.barBack } });
    this.OnOptionItemSelected(2,this.state.Options[2][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[1] === false || (this.state.optionChoiceCnt[1] > 0 && this.state.optionChoiceCnt[1] >= this.state.optionMultiCnt[1])) {
      //this.optionNC(1);
      //  let showOptionGrid = this.state.showOptionGrid.slice();
      //  showOptionGrid[1] = false;
      //  this.setState({ showOptionGrid });
    }
  }
  Open2Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[2] = true;
    this.setState({ showOptionGrid });
  }
  //------- 3 -------
  BoolOpt3Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option3Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option3Click = async (props) => {
    let current = this.state.Options[3].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op3bgc: { backgroundColor: SessionInfo.barBack } });
    this.OnOptionItemSelected(3,this.state.Options[3][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[2] === false || (this.state.optionChoiceCnt[2] > 0 && this.state.optionChoiceCnt[2] >= this.state.optionMultiCnt[2])) {
      //this.optionNC(2);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[2] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open3Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[3] = true;
    this.setState({ showOptionGrid });
  }
  //------- 4 -------
  BoolOpt4Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option4Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option4Click = async (props) => {
    let current = this.state.Options[4].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op4bgc: { backgroundColor: SessionInfo.barBack } });
    trace(`OnOptionItemSelected - optionID: ${4}, Total: ${this.state.optionTotal[4]}, multi: ${this.state.optionMultiCnt[4]}, allow: ${this.state.allowMulti[4]}`);
    this.OnOptionItemSelected(4,this.state.Options[4][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[3] === false || (this.state.optionChoiceCnt[3] > 0 && this.state.optionChoiceCnt[3] >= this.state.optionMultiCnt[3])) {
      //this.optionNC(3);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[3] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open4Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[4] = true;
    this.setState({ showOptionGrid });
  }
  //------- 5 -------
  BoolOpt5Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option5Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option5Click = async (props) => {
    let current = this.state.Options[5].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op5bgc: { backgroundColor: SessionInfo.barBack } });
    this.OnOptionItemSelected(5,this.state.Options[5][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[4] === false || (this.state.optionChoiceCnt[4] > 0 && this.state.optionChoiceCnt[4] >= this.state.optionMultiCnt[4])) {
      //this.optionNC(4);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[4] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open5Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[5] = true;
    this.setState({ showOptionGrid });
  }
  //------- 6 -------
  BoolOpt6Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option6Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option6Click = async (props) => {
    let current = this.state.Options[6].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op6bgc: { backgroundColor: SessionInfo.barBack } });
    this.OnOptionItemSelected(6,this.state.Options[6][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[5] === false || (this.state.optionChoiceCnt[5] > 0 && this.state.optionChoiceCnt[5] >= this.state.optionMultiCnt[5])) {
      //this.optionNC(5);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[5] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open6Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[6] = true;
    this.setState({ showOptionGrid });
  }
  //------- 7 -------
  BoolOpt7Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option7Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>);
  }
  Option7Click = async (props) => {
    let current = this.state.Options[7].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op7bgc: { backgroundColor: SessionInfo.barBack } });
    this.OnOptionItemSelected(7,this.state.Options[7][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[6] === false || (this.state.optionChoiceCnt[6] > 0 && this.state.optionChoiceCnt[6] >= this.state.optionMultiCnt[6])) {
      //this.optionNC(6);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[6] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open7Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[7] = true;
    this.setState({ showOptionGrid });
  }
  //------- 8 -------
  BoolOpt8Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option8Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>)
  }
  Option8Click = async (props) => {
    let current = this.state.Options[8].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op8bgc: { backgroundColor: SessionInfo.barBack } });
    this.OnOptionItemSelected(8,this.state.Options[8][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[7] === false || (this.state.optionChoiceCnt[7] > 0 && this.state.optionChoiceCnt[7] >= this.state.optionMultiCnt[7])) {
      //this.optionNC(7);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[7] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open8Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[8] = true;
    this.setState({ showOptionGrid });
  }
  //------- 9 -------
  BoolOpt9Cell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      this.Option9Click(props);
    }
    return (<td><input type="checkbox" checked={value} className="optionCheckbox" onChange={handleChange} /></td>)
  }
  Option9Click = async (props) => {
    let current = this.state.Options[9].findIndex(dataItem => dataItem === props.dataItem);
    this.setState({ op9bgc: { backgroundColor: SessionInfo.barBack } });
    this.OnOptionItemSelected(9,this.state.Options[9][current],false);
    this.setState({ Options: this.state.Options.slice() });
    this.setState({ optionStates: this.state.optionStates.slice() });
    this.setState({ itemChanged: true });
    if (this.state.choiceRequired[8] === false || (this.state.optionChoiceCnt[8] > 0 && this.state.optionChoiceCnt[8] >= this.state.optionMultiCnt[8])) {
      //this.optionNC(8);
      //let showOptionGrid = this.state.showOptionGrid.slice();
      //showOptionGrid[8] = false;
      //this.setState({ showOptionGrid });
    }
  }
  Open9Click = (event) => {
    let showOptionGrid = this.state.showOptionGrid.slice();
    showOptionGrid[9] = true;
    this.setState({ showOptionGrid });
  }
  //--------------------------------------------------------------------------------------------------
  OnOptionItemSelected = async (optionID,OI,isChange) => { // Note - This is called per click 
    trace(`ItemSelected - optionID: ${optionID}, Total: ${this.state.optionTotal[optionID]}, multi: ${this.state.optionMultiCnt[optionID]}, allow: ${this.state.allowMulti[optionID]}`);
    //debugger;
    //trace("item: " + JSON.stringify(OI));
    let OptionsPrice = 0;
    if (isChange === false)
      OptionsPrice = this.state.OptionsPrice - this.state.optionTotal[optionID];
    trace(`OptionsPrice: ${OptionsPrice}, OptionsPrice: ${this.state.OptionsPrice}, optionID: ${optionID}, Total: ${this.state.optionTotal[optionID]}, OptionCount: ${this.OptionCount}`);
    let optionStates = this.state.optionStates.slice();
    trace(`optionStates: ${JSON.stringify(optionStates)}`);
    try {
      let addItem = false;
      if (OI.Select === false)
        addItem = true;
      trace(`ItemSelected - optionID: ${optionID}, addItem: ${addItem}`);
      try {
        trace(`AddItem - optionID: ${optionID}, multi: ${this.state.optionMultiCnt[optionID]}, allowMulti: ${this.state.allowMulti[optionID]}`);
        if (this.state.allowMulti[optionID] === false) { // Deal with single choice Groups
          this.state.Options[optionID].forEach((elem) => { // Look for the Currently Selected OptionItem and turn off 
            if (elem.Select === true) { // Clicking on an ON option - turn it off
              { // Remove OptionItem
                trace(`Remove Item - option: ${elem.OptionName}`);
                elem.Select = false;
                this.state.optionChoice[optionID] = 0;
                this.state.optionChoiceCnt[optionID] = 0;
                //if (elem.Price > 0) {
                this.state.optionTotal[optionID] = 0;
                //let OptionsPrice = 0;
                //for (let ix = 0; ix < this.TotalOptions; ix++)
                //  OptionsPrice += this.state.optionTotal[ix];
                //this.setState({ OptionsPrice });
                //OI.OG.ParentOGM.COI.TotalPrice = (OI.OG.ParentOGM.COI.Price * OGM.COI.WeightMultiplier + OI.OG.ParentOGM.OptionTotal) * OGM.COI.Quantity;
                //}
              }
            }
          });
        }
        trace(`------ ItemSelect: ${OI.Select}, addItem: ${addItem} OI.OptionName: ${OI.OptionName}, Count: ${this.state.optionChoiceCnt[optionID]}`);
        if (addItem === true) { // NOTE: Not Currently Selected - Add OptionItem
          if (this.state.allowMulti[optionID] === false) { // Only One Selection Allowed
            this.state.optionChoice[optionID] = OI.ProductItemOptionID;
            this.state.optionChoiceCnt[optionID] = 1; // Note that if Remove comes after this will be decremented then
            optionStates[optionID] = OI.OptionName; // Set the Option choice for all SubOptions
            //dataView.CollapseGroup(OI.OG); // Note - need to save listview group header in the OG
          }
          else { // Multiple Items Allowed
            this.state.optionChoiceCnt[optionID] += 1;
            if (this.state.allowMulti[optionID] === true) {
              if (this.state.optionChoiceCnt[optionID] === 1)
                optionStates[optionID] = `1 Item of ${this.state.optionMultiCnt[optionID]} Selected`;
              else if (this.state.optionChoiceCnt[optionID] === this.state.optionMultiCnt[optionID])
                optionStates[optionID] = `Max of ${this.state.optionMultiCnt[optionID]} Items`;
              else if (this.state.optionChoiceCnt[optionID] > this.state.optionMultiCnt[optionID]) { // Atempt to go over count
                addItem = false;
                this.state.optionChoiceCnt[optionID] -= 1;
                if (this.state.optionChoiceCnt[optionID] < 0)
                  this.state.optionChoiceCnt[optionID] = 0; // Should Never Happen
                optionStates[optionID] = `Max Items (${this.state.optionChoiceCnt[optionID]})`;
              }
              else
                optionStates[optionID] = `${this.state.optionChoiceCnt[optionID]} Items of ${this.state.optionMultiCnt[optionID]} Selected`;
            }
            else if (this.state.optionChoiceCnt[optionID] === 1)
              optionStates[optionID] = `1 Item Selected`;
            else
              optionStates[optionID] = `${this.state.optionChoiceCnt[optionID]} Items Selected`;
          }
          // For either process - price add
          if (addItem === true) {
            OI.Select = true;
            //this.state.optionChoiceCnt[optionID]++; // Note - the ParentOGM is Parent OptionGroupModel - it is pointed to by the Prime OptionGroup for the OptionSubGroup (Hiercharchy that is flat for Telerik)
            trace(`Set: ${OI.OptionName} to true, Choice Cnt: ${this.state.optionChoiceCnt[optionID]}`);
            if (OI.Price > 0) {
              this.state.optionTotal[optionID] += OI.Price;
              //OGM.COI.OptionsPrice = OI.OG.ParentOGM.OptionTotal;
              //OI.OG.ParentOGM.COI.TotalPrice = (OI.OG.ParentOGM.COI.Price * OGM.COI.WeightMultiplier + OI.OG.ParentOGM.OptionTotal) * OGM.COI.Quantity;
            }
          }
          //trace(`option Count: ${this.state.optionChoiceCnt[optionID]}, total: ${this.state.optionTotal[optionID]}`);
        }
        else { // The Option is Currently Selected - and this is to remove the Option
          OI.Select = false;
          trace(`------ Remove: OI.OptionName: ${OI.OptionName}, choiceCnt: ${this.state.optionChoiceCnt[optionID]}, multiCnt: ${this.state.optionMultiCnt[optionID]}`);
          if (this.state.allowMulti[optionID] === true) { // Click on an ON option - turn it off
            this.state.optionChoiceCnt[optionID] -= 1;
            if (this.state.optionChoiceCnt[optionID] < 0)
              this.state.optionChoiceCnt[optionID] = 0;
            if (this.state.optionChoiceCnt[optionID] === 0) {
              if (this.state.choiceRequired[optionID] === false) {
                if (this.state.optionMultiCnt[optionID] === 0)
                  optionStates[optionID] = `Select 0 or More`;
                else
                  optionStates[optionID] = `Choose 0 To ${this.state.optionMultiCnt[optionID]}`;
              }
              else { // Required
                if (this.state.optionMultiCnt[optionID] === 0)
                  optionStates[optionID] = `Select 1 or More`;
                else
                  optionStates[optionID] = `Choose 1 To ${this.state.optionMultiCnt[optionID]}`;
              }
            }
            else if (this.state.optionChoiceCnt[optionID] === 1)
              optionStates[optionID] = `1 Item Selected`;
            else
              optionStates[optionID] = `${this.state.optionChoiceCnt[optionID]} Items Selected`;
            if (OI.Price > 0) {
              this.state.optionTotal[optionID] -= OI.Price;
              if (this.state.optionTotal[optionID] < 0) {
                let optionTotal = this.state.optionTotal.slice();
                optionTotal[optionID] = 0;
                this.setState({ optionTotal });
              }
            }
          }
          else { // Single Select
            this.state.optionChoiceCnt[optionID] = 0;
            this.state.optionTotal[optionID] = 0;
            if (this.state.choiceRequired[optionID] === true)
              optionStates[optionID] = "Choice Required";
            else
              optionStates[optionID] = "Optional Choice";
          }
        }
        trace(`---> set option: ${optionID}, states: ${optionStates}`);
      }
      catch (Ex) {
        trace(`Fault in OnOptionSelected Inner ${Ex}`);
        await OMTrace(2,`Fault in OnOptionSelected Inner ${Ex}`);
      }
      //this.setState({ optionStates : optionStates }); // 26Apr22 - This does not work! - Confirmed 14AUG24 - still does not work?? - nor does: this.setState({ optionStates });
      this.state.optionStates = optionStates; // 26Apr22 - this works - and updates UI
      //this.forceUpdate();
      trace(`------ State: ${this.state.optionStates[optionID]},${optionStates[optionID]}, OI.OptionName: ${OI.OptionName}, choiceCnt: ${this.state.optionChoiceCnt[optionID]}, multiCnt: ${this.state.optionMultiCnt[optionID]}`);
      OptionsPrice += this.state.optionTotal[optionID];
      this.setState({ OptionsPrice });
      let TotalItemPrice = 0;
      if (this.state.PromotionPrice > 0)
        TotalItemPrice = (this.state.PromotionPrice + OptionsPrice) * this.state.Quantity;
      else
        TotalItemPrice = (this.state.ItemPrice + OptionsPrice) * this.state.Quantity;
      this.setState({ TotalItemPrice });
      this.setState({ OptionStatus: "" });
      // Check if all Required Options Done  
      this.checkOptionsDone();
      trace(`--->  states: ${this.state.optionStates}, count: ${this.OptionCount}`);
    } // End of AddItem
    catch (Ex) {
      await OMTrace(2,`Fault in OnOptionSelected Outer ${Ex}`);
    }
  }
  checkOptionsDone = () => {
    try {
      // Check if all Required Options Done  
      trace(`Check options done`);
      let allOptionsDone = true;
      let requiredOptions = false;
      let optionPriceShow = false;
      for (let ix = 0; ix < this.OptionCount; ix++) {
        if (this.state.choiceRequired[ix] === true) {
          requiredOptions = true;
          //if (this.state.optionMultiCnt[ix] > this.state.optionChoiceCnt[ix] || this.state.optionChoiceCnt[ix] === 0) { // This is wrong - it would insist on MuliCnt choices - ie 2 where we have 1 to 2 for instance
          if (this.state.optionTotal[ix] > 0)
            optionPriceShow = true;
          if (this.state.optionChoiceCnt[ix] === 0) {
            allOptionsDone = false;
            break;
          }
        }
      }
      if (allOptionsDone === true) {
        if (this.AllOptionsDone === false) {
          this.AllOptionsDone = allOptionsDone;
          this.detailHeaderHeight += 54;
          //if (this.state.OptionsPrice > 0)
          if (optionPriceShow === true)
            this.detailHeaderHeight += 24;
          trace(`OPTIONS DONE headerHeight: ${this.detailHeaderHeight}, imageHeight: ${this.imageHeight}`);
          document.documentElement.style.setProperty('--options-header-height',`${this.detailHeaderHeight}px`); // header Height - Image Height   
        }
        this.setState({ showInfo: true });
        this.showInfo = true;
        if (this.OptionCount === 0)
          this.setState({ OptionStatus: "No Options" });
        else {
          this.setState({ OptionStatus: "Options Complete" });
          if (requiredOptions === true) {
            if (this.showOptionsComplete === true) {
              //displayMessage("Options are complete");
              this.showOptionsComplete = false;
            }
          }
          if (this.optionCompleteScroll === false) {
            //window.scrollTo(0,this.OffsetToUse);
            this.optionCompleteScroll = true;
          }
        }
      } else {
        if (this.OptionCount > 0)
          this.setState({ OptionStatus: `Select Options - ${this.OptionCount} Required` });
        else
          this.setState({ OptionStatus: "" });
      }
    } // End of AddItem
    catch (Ex) {
      OMTrace(2,`Fault in checkOptionsDone  ${Ex}`);
    }
  }
  //==================================================================================================
  addDetailItemToOrder = async () => {
    trace(`Add AllOptionsDone: ${this.AllOptionsDone}, optionCount: ${this.OptionCount}, ${this.OptionCount}`);
    try {
      let currentND = -1;
      if (this.AllOptionsDone === false) { // All Options NOT done - check if options or if actually Done
        if (this.OptionCount === 0)
          this.AllOptionsDone = true;
        else {
          this.AllOptionsDone = true;
          for (let ix = 0; ix < this.OptionCount; ix++) {
            trace(` ix: ${ix}, req: ${this.state.choiceRequired[ix]}, MultiCount: ${this.state.optionMultiCnt[ix]}`);
            if (this.state.choiceRequired[ix] === true && (this.state.optionMultiCnt[ix] > this.state.optionChoiceCnt[ix] || this.state.optionChoiceCnt[ix] === 0)) {
              this.AllOptionsDone = false;
              currentND = ix;
              break;
            }
          }
        }
      }
      trace(`2-AllOptionsDone: ${this.AllOptionsDone}, StoreItem: ${this.StoreItemID}`);
      if (this.AllOptionsDone === true) { // All Options ARE DONE     
        await this.addUpdateOrderItem(); // Add the OrderItem to the Order - replaced addOrderItem - 2Aug23
        if (ItemDetailSecondLevel === false) {  //this.topLevelStoreItem === this.StoreItemID) {
          trace(`after addOrderItem - return to OrderPage - StoreItem: ${this.StoreItemID}`);
          this.setState({ displayItemDetail: false });
          //window.scrollTo(0,this.OffsetToReturnTo);
          SessionInfo.PauseOPMonitor = false;
          this.fetchTableInfo(); // Setup Initial Table Info
        } else { // A Promo or Related Item - added - pop back to previous
          trace(`after addOrderItem - return to TopLevel StoreItem: ${this.topLevelStoreItem}`);
          this.StoreItemID = this.topLevelStoreItem;
          this.popCurrentOptionState();
        }
        ItemDetailSecondLevel = false;
      }
    }
    catch (error) {
      trace(`Failure in addDetailItemToOrder - msg: ${error}`);
    }
  }
  addNewItemToOrder = async () => {
    trace(`Add New Item - OptionCount: ${this.OptionCount}`);
    try {
      this.setState({ Quantity: 1 });
      this.setState({ TotalItemPrice: this.state.ItemPrice });
      this.setState({ isItemChange: false });
      this.clearOptions();
      this.setState({ showChangeItems: false });
    }
    catch (error) {
      trace(`Failure in addDetailItemToOrder - msg: ${error}`);
    }
  }
  clearOptions = () => { // Clear the current option selections - Options stay the same
    for (let ix = 0; ix < this.OptionCount; ix++) {
      //trace(`Options Lth: ${this.state.Options[ix].length}`);  
      let Options = this.state.Options.slice();
      for (let ox = 0; ox < Options[ix].length; ox++) {
        //trace(`option - ix:${ix}, ox:${ox}, key:${this.optionKeys[ix]} option: ${JSON.stringify(this.state.Options[ix][ox])}`);
        if (Options[ix][ox].Select === true) {
          Options[ix][ox].Select = false;
        }
      }
      this.setState({ Options });
      this.setState({ OptionsPrice: 0 });
    }
  }
  changeItemOnOrder = async () => {
    trace(`Change - AllOptionsDone: ${this.AllOptionsDone}, optionCount: ${this.OptionCount}, itemCount: ${this.state.Quantity}`);
    if (this.state.Quantity <= 0) {
      await this.deleteOrderItem();
      this.setState({ displayItemDetail: false });
      this.fetchTableInfo(); // Setup Initial Table Info
    } else {
      if (this.OptionCount === 0)
        this.AllOptionsDone = true;
      let currentND = -1;
      if (this.AllOptionsDone === false && this.state.Quantity > 0) {
        if (this.OptionCount === 0)
          this.state.AllOptionsDone = true;
        else {
          let AllOptionsDone = true;
          for (let ix = 0; ix < this.OptionCount; ix++) {
            trace(` ix: ${ix}, req: ${this.state.choiceRequired[ix]}, MultiCount: ${this.state.optionMultiCnt[ix]}`);
            if (this.state.choiceRequired[ix] === true && (this.state.optionMultiCnt[ix] > this.state.optionChoiceCnt[ix] || this.state.optionChoiceCnt[ix] === 0)) {
              AllOptionsDone = false;
              currentND = ix;
              break;
            }
          }
          this.AllOptionsDone = AllOptionsDone;
        }
      }
      trace(`3-AllOptionsDone: ${this.AllOptionsDone}`);
      if (this.AllOptionsDone === true || this.state.Quantity === 0) {
        await this.changeOrderItem();
        this.setState({ displayItemDetail: false });
        this.fetchTableInfo(); // Setup Initial Table Info
      }
      //  else {
      //    this.optionNC(currentND,true);
      //  }
    }
  }
  optionNC = (currentND,hiLite) => { // Options Not Complete
    //window.scrollTo(0, 0);
    if (!hiLite)
      hiLite = false;
    trace(`optionNC currentND: ${currentND}`);
    if (hiLite === true)
      displayMessage("Options are NOT complete");
    if (currentND === 0) {
      this.op0.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op0bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 1) {
      this.op1.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op1bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 2) {
      this.op2.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op2bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 3) {
      this.op3.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op3bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 4) {
      this.op4.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op4bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 5) {
      this.op5.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op5bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 6) {
      this.op6.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op6bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 7) {
      this.op7.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op7bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 8) {
      this.op8.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op8bgc: { backgroundColor: SessionInfo.barHilight } });
    }
    else if (currentND === 0) {
      this.op9.current.scrollIntoView({ behavior: 'smooth',block: 'start' });
      if (hiLite) this.setState({ op9bgc: { backgroundColor: SessionInfo.barHilight } });
    }
  }
  cancelDetailAdd = () => { // Note 6Jun23 - Need to hide popup
    this.CustomOrderItemID = -1;
    if (ItemDetailSecondLevel === false) { //this.topLevelStoreItem === this.StoreItemID) {
      this.setState({ displayItemDetail: false });
      //window.scrollTo(0,this.OffsetToReturnTo);
    } else { // A Promo or Related Item - added - pop back to previous
      this.StoreItemID = this.topLevelStoreItem;
      trace(`Cancel Detail Add - topLevel SI: ${this.topLevelStoreItem}, SI: ${this.StoreItemID}`);
      this.popCurrentOptionState();
    }
    this.backMenuPrompt = '< Back to Menu';
    ItemDetailSecondLevel = false;
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  moneyFormat = (value) => new Intl.NumberFormat('en-US',{ style: 'currency',currency: 'USD' }).format(value);

  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  loadOrderItem = async (currentItem,isChange) => {
    try {
      trace(`*** loadOrderItem - CustomOrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID}`);
      if (currentItem) {
        //trace(`*** currentItem: ${JSON.stringify(currentItem)} - StoreItemID: ${currentItem.StoreItemID}`);
        this.StoreItemID = currentItem.StoreItemID;
        trace(`Location: ${this.state.StoreLocationID}, Item: ${this.StoreItemID}`);
        let CD = await CallOM("GetOrderItemForItem",SessionInfo.CustomOrderID,this.StoreItemID,0,undefined,undefined,this.CustomOrderItemID); // CustomOrderItemID = _OMO.ActiveParm2
        trace("after GetOrderItemForItem: " + JSON.stringify(CD.d));
        var row = CD.d;
        if (row) {
          CustomOrderItemsO.forEach((elem) => {
            if (elem.n in row) {
              //trace(`Set ${elem.n}: ${row[elem.n]}`);
              let sobj = {};
              try {
                if (elem.t === 34 || elem.t === 35) // Date, DateTime
                  sobj[elem.n] = new Date(row[elem.n]);
                else if (elem.t === 28) {
                  sobj[elem.n] = row[elem.n];
                  let sobjS = {};
                  sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
                  //trace(`Set Money Field: ${elem.n + 'S'} Value: ${sobjS[elem.n + 'S']}`);
                  this.setState(sobjS);
                }
                else
                  sobj[elem.n] = row[elem.n];
                //trace(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${COIV[elem.n]}`);
                this.setState(sobj);
                COIV[elem.n] = row[elem.n];
                // Add item specific code here
                //if (elem.n === "ImageID")
                //  ImageID = row[elem.n];
              } catch (error) {
                trace(`Set StoreItemsO Field: ${elem.n} Error: ${error.message}`);
              }
            }
          });
        }
        this.ExistQty = this.state.Quantity;
        let CustomOrderItemID = row["ID"];
        if (this.state.showChangeItems === false) {
          trace(`*** loadItem Options - StoreItemID: ${currentItem.StoreItemID}, CustomOrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID}`);
          CD = await CallOM("GetOrderItemOptionsList",0,CustomOrderItemID,0);
          trace(`Options: ${JSON.stringify(CD.d)}, OptionsPrice: ${this.state.OptionsPrice}, ${COIV.OptionsPrice}`);
          let rows = CD.d.rows;
          for (let rx = 0; rx < rows.length; rx++) {
            //trace(`Options  GrpID: ${rows[rx].GrpName}, OptID: ${rows[rx].POName}`);
            for (let ix = 0; ix < this.state.Options.length; ix++) {
              //trace(`Options Lth: ${this.state.Options[ix].length}, Key: ${this.optionKeys[ix]}, multi: ${this.state.optionMultiCnt[ix]}`);
              if (this.optionKeys[ix] === rows[rx].GrpName) {
                for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
                  //trace(`option - ix:${ix}, ox:${ox}, key:${this.optionKeys[ix]} option: ${JSON.stringify(this.state.Options[ix][ox])}`);
                  if (this.state.Options[ix][ox].ID === rows[rx].POName) {
                    //this.state.Options[ix][ox].Select = true;
                    this.OnOptionItemSelected(ix,this.state.Options[ix][ox],isChange);
                    this.setState({ Options: this.state.Options.slice() });
                    //this.setState({ optionStates: this.state.optionStates.slice() });
                    break;
                  }
                }
              }
            }
          }
        }
      }
    }
    catch (Ex) {
      trace(`Error in loadOrderItem: ${Ex}`);
    }
  }
  loadRelatedItems = async (search) => {
    trace(`Load Related Items for this item: ${this.StoreItemID}, HasRelated: ${this.state.HasRelated}, StoreLocationID: ${SessionInfo.StoreLocationID}, ItemDetailSecondLevel: ${ItemDetailSecondLevel}`);
    if (this.state.HasRelated === true) {
      try {
        let CD = await CallOM("GetRelatedItemsForItem",SessionInfo.StoreLocationID,this.StoreItemID,0); // Related Items for the current StoreItem
        this.setState({ ItemSelect: "" });
        if (CD.x.o === 0)
          await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
        else if (CD.x.o < 9500) {
          try {
            if (CD.d) {
              //trace("Selected Items: " + JSON.stringify(SessionInfo.SelectedItems)); // Current List of Selected (To Purchase) Items
              let RelatedItems = CD.d.rows.map(dataItem => Object.assign({ selected: false,ItemTotal: 0.0 },dataItem));
              this.RelatedItemCount = RelatedItems.length;
              //trace(`Related Items: ${JSON.stringify(RelatedItems)}`);
              ////SessionInfo.saveRelatedItems = RelatedItems.slice();
              //if (SessionInfo.SelectedItems) {
              //  SessionInfo.SelectedItems.forEach(item => { // Scan for Related Items which are in the Selected List
              //    let ix = RelatedItems.findIndex(relItem => relItem.StoreItemID === item.ItemID);
              //    trace(`related storeItemID: ${item.ItemID} ix: ${ix}`)
              //    if (ix >= 0) {
              //      RelatedItems[ix].selected = true;
              //    }
              //  });
              //}
              trace(`load - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
              if (this.state.selectedItems) { // Look in current items to see if match
                this.state.selectedItems.forEach(item => {
                  let ix = RelatedItems.findIndex(relItem => relItem.StoreItemID === item.ItemID);
                  //trace(`related storeItemID: ${item.ItemID} ix: ${ix}`)
                  if (ix >= 0) {
                    RelatedItems[ix].selected = true;
                    RelatedItems[ix].ItemTotal = item.Total;
                  }
                });
              }
              await this.setState({ RelatedItems });
              trace(`setState RelatedItems Lth: ${RelatedItems.length}`);
            } else {
              await this.setState({ RelatedItems: [] });
              //SessionInfo.saveRelatedItems = [];
            }
          } catch (error) {
            await OMTrace(2,`Failure in load RelatedItems - Error: ${error}`);
          }
        }
      } catch (error) {
        await OMTrace(2,`Failure (2) in RelatedItems - Error: ${error}`);
      }
    }
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  GetProductItemImage = async (imageID) => {
    trace(`GetProductCategoryImage ID: ${imageID}`);
    let imageURL = await getImageFileFromServer(imageID);
    this.setState({ ProductItemPhotoURL: imageURL });
  }
  //------------------------- End Edit StoreItem Grid ------------------------------------------------------------------
  //-------------------------- Load Options -----------------------------------------------------------------------------------------
  LoadGroupData = async (storeItemID) => { // Load the Option Groups and Option Items for a StoreItem - loadoptions
    // Note 27Sep24 - Need to optimize option loading - only required fields and no images (unless added later)
    trace(`Load Option Group Data - StoreItem: ${storeItemID}, HasOptions: ${this.state.HasOptions}, OptionCount: ${this.OptionCount}`);
    let cnt = 0;
    this.setState({ showInfoChange: false });
    //if (this.state.HasOptions === true) {
    //OptionGroups.Clear();
    let OptionCount = 0;
    this.OptionElementCount = 0;
    try {
      let CDI = await CallOM("FetchGroupData",0,storeItemID,6,true); // Required
      let optionGroups;
      let OptionType = '';
      if (CDI != null) {
        optionGroups = CDI.d.rows;
        ////------- Load Required Options First -----------------------
        if (optionGroups.length > 0) {
          await asyncForEach(optionGroups,async (elem) => {
            //trace(`showOptions`);
            let showOption = this.state.showOption.slice();
            showOption[OptionCount] = true;
            this.setState({ showOption });
            //trace(`optionKeys`);
            this.optionKeys[OptionCount] = elem.ProductOptionsGroupID;
            ///trace(`optionNames`);
            this.optionNames[OptionCount] = elem.ProductOptionsGroupName;
            //trace(`choiceRequired`);
            let choiceRequired = this.state.choiceRequired.slice();
            choiceRequired[OptionCount] = elem.IsRequired;
            this.setState({ choiceRequired });
            //trace(`allowMulti`);
            let allowMulti = this.state.allowMulti.slice();
            allowMulti[OptionCount] = elem.AllowMultiple;
            this.setState({ allowMulti });
            //trace(`optionMultiCnt`);
            let optionMultiCnt = this.state.optionMultiCnt.slice();
            //if (Number.isInteger(elem.MultipleCount) === false) {
            //  trace(`***> optionGroup elem: ${JSON.stringify(elem)} MultipleCount not Int`);
            //  elem.MultipleCount = 1;
            //}
            optionMultiCnt[OptionCount] = elem.MultipleCount;
            //trace(`---> Required OptionCount: ${OptionCount}, MultiCnt: ${JSON.stringify(optionMultiCnt)}`);
            this.setState({ optionMultiCnt });
            if (elem.IsRequired === true) {
              if (elem.AllowMultiple === true) {
                if (elem.MultipleCount === 0)
                  OptionType = "Choose 1 or More";
                else
                  OptionType = `Choose 1 To ${elem.MultipleCount}`;
              }
              else
                OptionType = "Choice Required";
            }
            else {
              if (elem.AllowMultiple === true) {
                if (elem.MultipleCount === 0)
                  OptionType = "Select 0 or More";
                else
                  OptionType = `Select Up To ${elem.MultipleCount}`;
              }
              else
                OptionType = "Optional Choice";
            }
            this.optionStates[OptionCount] = OptionType;
            await this.LoadOptionGroupData(OptionCount,elem.ProductOptionsGroupID); // Load the actual Options
            OptionCount++;
          });
        }
      }
      if (OptionCount === 0) { // No Required Options
        this.setState({ showInfo: true });
        this.showInfo = true;
        this.AllOptionsDone = true;
      }
      else
        this.AllOptionsDone = false;
      //------- Load Optional Options Second -----------------------------
      //SearchCond = "*StoreItemID=" + storeItemID + " and IsRequired=false"; // Now Fetch Optional Groups
      //CDI = await AccessOM.GetTableSearch(546454,SearchCond); // Get Optional ProductOGLinks 
      CDI = await CallOM("FetchGroupData",0,storeItemID,6,false); // Optional
      if (CDI != null) {
        optionGroups = CDI.d.rows;
        if (optionGroups.length > 0) {
          //trace("optional optionGroups: " + JSON.stringify(optionGroups));
          await asyncForEach(optionGroups,async (elem) => {
            this.state.showOption[OptionCount] = true;
            this.optionKeys[OptionCount] = elem.ProductOptionsGroupID;
            this.optionNames[OptionCount] = elem.ProductOptionsGroupName;
            let choiceRequired = this.state.choiceRequired.slice();
            choiceRequired[OptionCount] = elem.IsRequired;
            this.setState({ choiceRequired });
            let allowMulti = this.state.allowMulti.slice();
            allowMulti[OptionCount] = elem.AllowMultiple;
            this.setState({ allowMulti });
            //this.state.allowMulti[OptionCount] = elem.AllowMultiple; 
            let optionMultiCnt = this.state.optionMultiCnt.slice();
            //if (Number.isInteger(elem.MultipleCount) === false) {
            //  trace(`***> 2 optionGroup elem: ${JSON.stringify(elem)} MultipleCount not Int`);
            //  elem.MultipleCount = 1;
            //}
            optionMultiCnt[OptionCount] = elem.MultipleCount;
            //trace(`---> Optional OptionCount: ${OptionCount}, MultiCnt: ${JSON.stringify(optionMultiCnt)}`);
            this.setState({ optionMultiCnt });
            //this.state.optionMultiCnt[OptionCount] = elem.MultipleCount;
            if (elem.IsRequired === true) {
              if (elem.AllowMultiple === true) {
                if (elem.MultipleCount === 0)
                  OptionType = "Choose 1 or More";
                else
                  OptionType = `Choose 1 To ${elem.MultipleCount}`;
              }
              else
                OptionType = "Choice Required";
            }
            else {
              if (elem.AllowMultiple === true) {
                if (elem.MultipleCount === 0)
                  OptionType = "Select 0 or More";
                else
                  OptionType = `Select Up To ${elem.MultipleCount}`;
              }
              else
                OptionType = "Optional Choice";
            }
            this.optionStates[OptionCount] = OptionType;
            await this.LoadOptionGroupData(OptionCount,elem.ProductOptionsGroupID); // Load the actual Options
            OptionCount++;
          });
        }
      }
      //------------------------------------
      trace(`Option Load Complete - OptionCount: ${OptionCount}, Total Option Elements: ${this.OptionElementCount}`);
      this.OptionCount = OptionCount;
      //trace("---------- Load Options Complete ----------");
      this.setState({ optionNames: this.optionNames });
      this.setState({ optionStates: this.optionStates });
      this.setState({ Options: this.Options }); // Save the collection of actual Options
      this.checkOptionsDone();
    }
    catch (Ex) {
      trace(`Failure in OptionGroup Load - Error: ${Ex}`);
      await OMTrace(2,`Failure in OptionGroup Load - Error: ${Ex}`);
    }
    //} else {
    //  this.AllOptionsDone = true;
    //  this.setState({ OptionStatus: "" });
    //}
    trace(`---> Option Count: ${this.OptionCount}`);
    return cnt;
  }
  //-------------------------------------------------------------------------------   
  LoadOptionGroupData = async (optionCnt,OptionsGroupID) => {  // Load the Attached ProductItemOptions for a ProductOptionGroup
    let cnt = 0;
    try {
      //trace(`LoadOptionGroupData: ${optionCnt}`);
      //let SearchCond = "*ProductOptionsGroupID=" + OptionsGroupID;
      // 11Sep24 - This NEEDS to be replaced with a custom call                
      //CDI = await GetTableSearch(545039,SearchCond,0x0221); // Get OptionItems - No Translate - Get Small Image);
      let CDI = await CallOM("FetchOptionsForGroup",0,OptionsGroupID); // Optional
      if (!(CDI.d === undefined || CDI.d.rows === undefined)) {
        let Rws = CDI.d.rows;
        if (Rws.length === 0) {
          await OMTrace(2,`OptionItem Load for OGM has NO Options for OptionGroupID: ${OptionsGroupID}`);
        }
        else {
          trace(`ProductOptionRows Count: ${Rws.length}`);
          this.OptionElementCount += Rws.length;
          let OptStr = "[";
          //trace("ProductOptionGroups: " + JSON.stringify(Rws));
          let optCnt = 0;
          let comma = '';
          Rws.forEach((elem) => {
            OptStr += `${comma}{"Select" : false, "OptionName": "${elem.ProductOptionName}", "Image" : null, "Price" : ${elem.Price}, "ID" : ${elem.ProductItemOptionID} }`;
            //trace(`option rw: ${JSON.stringify(elem)}`);
            comma = ',';
          });
          OptStr += "]";
          //trace("OptStr: " + OptStr); 
          this.Options[optionCnt] = JSON.parse(OptStr);
          //trace("Options: " + JSON.stringify(this.Options[optionCnt]));
        }
      }
      else
        await OMTrace(2,`OptionItem Load for OGM OptionsGroupID: ${OptionsGroupID} has NO Options`);
    }
    catch (Ex) {
      trace(`Failure in OptionItem Load - Error: ${Ex}`);
      await OMTrace(2,`Failure in OptionItem Load - Error: ${Ex}`);
    }
    return cnt;
  }
  GetProductOptionImage = async (event) => {
    let ProductOptionImageID = 2; // Note - Blank
    let imageURL = await getImageFileFromServer(ProductOptionImageID);
    this.setState({ ProductOptionPhotoURL: imageURL });
  }
  ProductOptionsGroupsPageChange = (event) => {
    this.setState({ ProductOptionsGroupsSkip: event.page.skip,ProductOptionsGroupsTake: event.page.take });
  }
  handleSubmit = (event) => {
    event.preventDefault();
  }
  chgFldVal = (event) => { // This is NOT setting state
    //event.stopPropagation();
    //this.state[event.target.name] = event.target.value;                                                                                                          
    this.setState({ [event.target.name]: event.target.value });
    //this.setState({ [event.target.name]: event.target.value },() => { trace("name:" + event.target.name + "  stateCopy: " + this.state[event.target.name]); });
    this.setState({ stateHasChanged: true });
  }
  chgTAInfoFldVal = (event) => {
    //trace(`Rate Value: ${event.value}, Name: ${event.target.name}`);
    this.setState({ [event.target.name]: event.value });
    this.setState({ stateHasChanged: true });
    this.setState({ itemChanged: true });
    //  this.setState({ [event.target.name]: event.target.value }, () => { trace("name:" + event.target.name + "  stateCopy: " + this.state[event.target.name]); });
    //  this.setState({ stateHasChanged: true });
  }
  chgMoneyFldVal = (event) => {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    //stateCopy = newVal;
    this.setState({ [event.target.name]: newVal });
  }
  chgCheckboxVal = (event) => {
    var stateCopy = this.state[event.target.name];
    stateCopy = !stateCopy;
    this.setState({ [event.target.name]: stateCopy });
    //trace("after - target: " + event.target.name + " value: " + this.state[event.target.name] + " SelectProductItemCategories: " + this.state.SelectProductItemCategories);
  }
  signIn = async () => {
    if (SessionInfo.appEntityLogonType === 1) {
      SessionInfo.isPhoneLogin = false;
    } else if (SessionInfo.appEntityLogonType === 8) {
      SessionInfo.isPhoneLogin = true;
      SessionInfo.hasPhoneLogin = true;
    }
    trace(`signin - current OrderID: ${SessionInfo.CustomOrderID}`);
    SessionInfo.logonReturn = 2;
    SessionInfo.PersonInfo.FirstName = undefined;
    this.props.navigate(`/Login`);
  }
  scrollOptions = (event) => { // scroll the options when too tall to fit in popup
    // console.log(event.currentTarget.scrollTop); - scroll position
    //trace(`Scroll Options - hideImage: ${this.hideItemImage}, stopScroll: ${this.stopScroll}`);
    if (this.hideItemImage === false && this.stopScroll === false) {
      //if (this.scrollPopup === true)
      this.hideImage();
    } // Note 27Sep24 - there is a problem if the options almost fit - so you scroll and it removes the image - which puts the scrollTop back to 0 which shows the image and then it doesn't fit
    this.stopScroll = false;
    //  else if (event.currentTarget.scrollTop === 0) {
    //    this.showImage();
    //  }
  }
  hideImage = async () => {
    this.hideItemImage = true;
    await this.setState({ hideOptionImage: true });
    document.documentElement.style.setProperty('--options-image-height','0px'); // Hide Image
    this.detailHeaderHeight -= this.imageHeight;
    document.documentElement.style.setProperty('--options-header-height',`${this.detailHeaderHeight}px`); // header Height - Image Height 
    trace(`HIDEIMAGE headerHeight: ${this.detailHeaderHeight}, imageHeight: ${this.imageHeight}`);
  }
  showImage = async () => {
    this.hideItemImage = false;
    await this.setState({ hideOptionImage: false });
    document.documentElement.style.setProperty('--options-image-height',`${this.imageHeight}px`); // Show Image
    this.detailHeaderHeight += this.imageHeight;
    trace(`SCROLL headerHeight: ${this.detailHeaderHeight}, imageHeight: ${this.imageHeight}`);
    document.documentElement.style.setProperty('--options-header-height',`${this.detailHeaderHeight}px`); // header Height - Image Height
  }
  //------------------------- Field Edit ------------------------------------------------------------------
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  //------------------------- Main Render ------------------------------------------------------------------
  render = () => {
    return (
      <div id="OrderPage" className="pageMain">
        {/* Header for Order Page - Changed 23Jul24 */}
        <div id="hdr" className="headerOrder" onClick={(e) => this.closePopups(10)} >
          <div className="headerTop">
            <div className="headerLeft">
              <div onClick={this.gotoLanding}>&nbsp; {this.backPrompt}</div>
              {/*<Button id="orderTypeButton" onClick={this.Test1Click} >Test 1</Button>*/}
            </div>
            {/*<div className="headerLogoLeft">
              {SessionInfo.HasLandingPage ?
                <a id="headerLogo" style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})`,backgroundPosition: 'left top',backgroundRepeat: 'no-repeat',backgroundSize: 'cover' }} onClick={(e) => this.gotoLanding()} />
                :
                <a id="headerLogo" style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})`,backgroundPosition: 'left top',backgroundRepeat: 'no-repeat',backgroundSize: 'cover' }} href={SessionInfo.RestaurantURL} target="_blank" rel="noopener noreferrer" />}
            </div>*/}
            <div className="headerOrderTopRight"> {/* onClick={(e) => this.closePopups(6)}>*/}
              <div className="headerCenterR2">
                <ShoppingCart stroke={SessionInfo.ECV.BrandColor} count={this.state.ItemCount} />
              </div>
              {/*<CartDisplay alt="" stroke={SessionInfo.headingTextColor} id="MenuBtn" title={`View Menu`} className="functionImageL" onClick={(e) => this.openMenu(e)} ref={this.menuAnchor} />*/}
              <div className="headerCenterMenu">
                {SessionInfo.loggedOn === true && SessionInfo.accountLogon == true ?
                  <MenuBar alt="" fill={SessionInfo.ECV.BrandColor} id="MenuBtn" title={`View Menu`} className="functionImageL" onClick={(e) => this.openMenu(e)} ref={this.menuAnchor} /> :
                  <span className="signin" onClick={(e) => this.signIn()}>Sign In</span>}
              </div>
              {/*{this.state.ItemCount > 0 || this.state.SeatCount > 1 ?
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >Cart ({this.state.ItemCount})</span> : <span> &nbsp; &nbsp; </span>}
              <span style={{ fontSize: 14,color: "black" }} >&nbsp;&nbsp;&nbsp;</span>
              {SessionInfo.CustomOrderID > 0 ?
                <span style={{ fontSize: 16,color: SessionInfo.ECV.InputBorderColor,fontWeight: "bold" }} >#{SessionInfo.CustomOrderID}</span> : <span> &nbsp; &nbsp; </span>} */}

              {/* <div className="headerMiddleTop">*/}
              {SessionInfo.AppCfg.HasDelivery === true ?
                <div className="headerOrderTopRightTop">
                  <div className="orderDiv">
                    <Button id="orderTypeButton" onClick={this.orderTypeClick} >Order Type</Button>
                  </div>
                  <div className="orderTypeDiv">
                    <span className='landingHeadText' >{this.state.currentOrderTypeName}</span>
                  </div>
                </div> :
                <>
                  {this.state.SeatCount <= 1 && SessionInfo.AC.HasGuest === true ?
                    <div>
                      <span className='landingHeadTextReg'>&nbsp; &nbsp; &nbsp; Guest:</span>
                      <span className='landingHeadText' >&nbsp;{SessionInfo.logonName}</span>
                    </div> : null}
                </>}
            </div>

            <div className="headerOrderTopCenter">
              {this.state.OrderType === 4 ?
                <>
                  {this.state.TableID > 0 && SessionInfo.AC.HasTable === true ?
                    <span className='landingHeadText'>{this.state.TableName}</span> : null}
                  {this.state.SeatCount > 1 && SessionInfo.AC.HasViewSeats === true ?
                    <span>
                      <span className='landingHeadTextReg'>&nbsp; Seat:</span>
                      <span className='landingHeadText'>&nbsp;{this.state.SeatName}</span>
                      <span className='landingHeadText'>&nbsp;-&nbsp;</span>
                      <span className='landingHeadText' >{this.state.SeatCount}</span>
                      <span className='landingHeadTextReg'>&nbsp;seats</span>
                    </span> : null}
                  {this.state.SeatCount <= 1 && SessionInfo.AC.HasGuest === true && SessionInfo.AppCfg.HasDelivery === true ?
                    <span>
                      <span className='landingHeadTextReg'>&nbsp; &nbsp; &nbsp; Guest:</span>
                      <span className='landingHeadText' >&nbsp;{SessionInfo.logonName}</span>
                    </span> : null}
                  <br />
                </> :
                <>
                  <span className='landingHeadText' style={{ color: 'black' }}>{this.state.StoreName}</span>
                  {SessionInfo.debug && 1 === 0 ?
                    <span className='landingHeadTextSmall'>&nbsp;&nbsp;Ver: {SessionInfo.appVersion}-{SessionInfo.Platform}</span> : null}
                </>}
            </div>
          </div>
          <div className="headerMiddle" ref={(div) => { this.detailOptionAnchor = div; }}>
            <div className="headerSpecial">
            </div>
            <div className="headerStoreInfo">
              {this.state.showStoreInfo ?
                <div className="headerLocation">
                  <div className="landingTextXXXL" >{SessionInfo.SLV.Description}</div>
                  <div className="landingTextXXL" >&nbsp; {this.state.HoursForToday}</div>
                </div> : null}
            </div>
            <div className="headerMessage">
              {this.state.showNotify ?
                <>
                  <div dangerouslySetInnerHTML={{ __html: this.state.notifyMessage }} onClick={(e) => { this.acknowledgeMessage(); }} />
                  {SessionInfo.acknowledge ?
                    <div className="bottomButton">
                      <Button icon="tell-a-friend" className="mediumButton" onClick={this.acknowledgeMessage}>Acknowledge</Button>
                    </div> : null}
                </> : null}
            </div>
          </div>

          <div className="headerBottom">
            <div className="headerOrderBotSearch">
              {SessionInfo.AC.HasViewSeats === true && (SessionInfo.OrderType == 4 || SessionInfo.OrderType == 5) ?
                <div className="seatsDiv">
                  <Button id="showSeatsButton" icon="myspace" onClick={this.showSeats} >&nbsp;View Seats &nbsp;</Button>
                </div> : null}
              <div id="headerSearch">
                <div id="searchBtnDiv">
                  <Tooltip position="top" anchorElement="pointer">
                    <ButtonSearch alt="" fill={SessionInfo.searchColor} title={`Search Menu`} className="functionImage" onClick={this.searchButton} />
                  </Tooltip>
                </div>
                <div id="searchBoxDiv">
                  {/*<span style={{ float: 'left',paddingTop: '7px',paddingLeft: '70px' }}>Search&nbsp;</span><br />*/}
                  <FloatingLabel label='Search Items' style={{ width: '300',color: 'darkblue' }} editorId={'search-id'} editorValue={this.state.searchValue}>
                    <Input value={this.state.searchValue} autoComplete="off" onChange={evt => this.updateSearchValue(evt)} className='searchInput' />
                  </FloatingLabel>
                </div>
                {this.state.searchValue.length > 0 ?
                  <div id="clearSearchBtnDiv">
                    <Tooltip position="top" anchorElement="pointer">
                      <ButtonClear alt="" fill={SessionInfo.searchColor} title={`Clear Search Box`} className="functionImage" onClick={this.clearSearch} />
                    </Tooltip>
                  </div> : null}
              </div>
            </div>

            <div id="categoriesSelect">
              {/*------ Horizontal Scroll ------*/}
              {/* see .menu-item in css for styling */}
              <ScrollMenu
                data={this.state.scrollCatMenuItems}
                itemStyle={{ color: 'green',fontSize: '24px' }}
                menuStyle={{ color: 'blue',fontSize: '24px' }}
                arrowLeft={ArrowLeft}
                arrowRight={ArrowRight}
                hideArrows={false}
                hideSingleArrow={false}
                transition={+0.4}
                onUpdate={this.onUpdateHS}
                onSelect={this.onCatSelect}
                scrollToSelected={true}
                selected={'none'}
                scrollBy={0}
                translate={undefined}
                alignCenter={false}
                dragging={true}
                clickWhenDrag={false}
                wheel={true}
                inertiaScrolling={true}
                inertiaScrollingSlowdown={0.25}
                className='categoriesScroll'
              />
            </div>
          </div>
          {/*-------------- Popups -----------------------------------------------------------------------------------------------------------------------------------------*/}
          {/* Show Seats Popup */}
          <Popup anchor={this.detailOptionAnchor} show={this.state.showSeatsPopup} popupClass={'popupStandard'} >
            <div id="seatBox">
              <br />
              <div id="seatsExitBtnDiv">
                <ButtonClear alt="" fill={SessionInfo.activeColor} title={`Exit Seats Popup`} className="functionImage" onClick={this.exitSeats} />
              </div>
              <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp;&nbsp; Seats for:&nbsp;</span><span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >{this.state.TableName}&nbsp;&nbsp;</span>
              <br />
              <br />
              <div id="div2" className="editFieldSpec">
                <span className="editFieldLabel">New Seat Name: &nbsp; </span>
                <input value={this.state.SetSeatName} name='SetSeatName' onChange={evt => this.chgFldVal(evt)} className='editInputSpec' />
              </div>
              {this.state.setName === true ?
                <Button id="setNameButton" icon="edit-tools" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '10px',height: '20px' }} onClick={this.setSeatName} >&nbsp;Set Name &nbsp;</Button>
                :
                <Button id="addSeatButton" icon="plus-outline" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '10px',height: '20px' }} onClick={this.addSeat} >&nbsp;Add New Seat &nbsp;</Button>
              }
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <Button id="doneButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '10px',height: '20px' }} onClick={this.doneSeats} >&nbsp;Done &nbsp;</Button>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              {this.state.setName === true && this.state.cancelAllowed === true ?
                <Button id="cancelButton" icon="cancel" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '10px',height: '20px' }} onClick={this.cancelOrder} > & nbsp;Cancel Order &nbsp;</Button> : null}
              <br />
              <br />
              <Grid name="SeatList" style={{ width: "100%",}} data={this.state.SeatOrders} onRowClick={this.SeatSelectClick} size={"small"} resizable={false} selectable={{ enabled: true,drag: false,cell: false,mode: "single",}} selectedField="Select">
                <GridColumn field="Select" cell={this.BoolSelectCell} width='35px' editable={false} />
                <GridColumn field="SeatName" width='120px' editable={false} cell={SeatCell} />
                <GridColumn field="Owing" cells={{ data: MoneyCell }} width='75px' filter='numeric' editable={false} />
                <GridColumn field="CustomOrderID" cell={OrderNumCell} width='60px' editable={false} />
              </Grid>
              <br />
            </div>
          </Popup>
          {/* Show OrderType Popup */}
          <Popup offset={this.showOrderTypeOffset} show={this.state.showOrderTypePopup} popupClass={'popupStandard'} >
            <div id="orderTypeBox">
              {this.state.orderTypeError === true ?
                <div className="errorBox">
                  {this.state.orderError}
                </div>
                :
                <h2>Select Order Type</h2>}
              <div id="seatsExitBtnDiv">
                <ButtonClear alt="" fill={SessionInfo.activeColor} title={`Exit Order Type Selection`} className="functionImage" onClick={this.quitOrderType} />
              </div>
              <div id='div2' className='ordertypeSettings'>
                <br />
                <div id="div2" className="editField">
                  <Switch checked={this.state.OrderAtTable} name="OrderAtTable" onChange={evt => this.chgOTCheckboxVal(evt)} />
                  <span className="editFieldLabel"> &nbsp; Order At Table</span>
                </div>
                <div id="div2" className="editField">
                  <Switch checked={this.state.DeliveryOrder} name="DeliveryOrder" onChange={evt => this.chgOTCheckboxVal(evt)} />
                  <span className="editFieldLabel"> &nbsp; Delivery Order</span>
                </div>
                <div id="div2" className="editField">
                  <Switch checked={this.state.OrderForPickup} name="OrderForPickup" onChange={evt => this.chgOTCheckboxVal(evt)} />
                  <span className="editFieldLabel"> &nbsp; Order For Pickup</span>
                </div>
                <div id="div2" className="editField">
                  <Switch checked={this.state.OrderAhead} name="OrderAhead" onChange={evt => this.chgOTCheckboxVal(evt)} />
                  <span className="editFieldLabel"> &nbsp; Order Ahead</span>
                </div>
                {/*<div className='editDDPosMiddle'>*/}
                {/*  <DropDownList data={this.state.CustomOrderTypes} textField='ddName' dataItemKey='ddID' value={this.state.CustomOrderTypes.find(c => c.ddID === this.state.CustomOrderType)} name='CustomOrderType' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />*/}
                {/*</div>*/}
              </div>
              <br />
              {/*<Button id="doneButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '25px' }} onClick={this.selectOrderType} >&nbsp;Select Order Type&nbsp;</Button>*/}
              <br />
              <div className='ordertypeDetails'>
                {this.state.OrderType == 1 ?
                  <div>
                    <br />
                    <span style={{ fontSize: 17,color: "blue",fontWeight: "bold" }} >&nbsp;&nbsp;DELIVERY ORDER</span>
                    <br />
                    <br />
                    <h4>Requested Delivery Date and Time</h4>
                    <br />
                    <br />
                    <DateTimePicker name="RequestDateTime" value={this.state.RequestDateTime} onChange={evt => this.chgOTDTPickerVal(evt)} className="editDateInput" autocomplete="off" />
                    <br />
                    <br />
                    <div>
                      <FloatingLabel label="Special Instructions" style={{ width: '200px',color: 'darkblue',marginTop: '5px' }} editorId={'orderInstructions'} editorValue={this.state.orderInstructions}>
                        <Input id={'orderInstructions'} value={this.state.OrderNotes} style={{ width: '340px',height: '40px',border: 'solid 2px blue' }} onChange={evt => this.chgOTInstructions(evt)} />
                      </FloatingLabel>
                    </div>
                    <br />
                    <div id="div2" className="editField">
                      <span className="editFieldLabel">Address</span>
                      <input value={this.state.Address} name="Address" onChange={evt => this.chgFldValOT(evt)} className="editInputL" />
                    </div>
                    <div id="div2" className="editField">
                      <span className="editFieldLabel">City</span>
                      <input value={this.state.City} name="City" onChange={evt => this.chgFldValOT(evt)} className="editInputM" />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>State/Province</span>
                      <div className='editDDPos'>
                        <DropDownList data={this.state.ProvinceStateCodesDict} textField='ddName' dataItemKey='ddID' value={this.state.ProvinceStateCodesDict.find(c => c.ddID === this.state.ProvinceStateID)} name='ProvinceStateID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                      </div>
                      {/*  <input value={this.state.ProvinceStateID} name='ProvinceStateID' onChange={evt => this.chgFldVal(evt)} className='editInputM' />*/}
                    </div>
                    <div id="div2" className="editField">
                      <span className="editFieldLabel">Postal Code</span>
                      <input value={this.state.PostalCode} name="PostalCode" onChange={evt => this.chgFldValOT(evt)} className="editInputS" />
                    </div>
                    <div id="div2" className="editField">
                      <span className="editFieldLabel">Phone Number</span>
                      <MaskedTextBox value={MaskString(this.state.PhoneNumber,"(###) ###-####")} name='PhoneNumber' onChange={evt => this.chgFldValMask(evt,"(###) ###-####")} mask="(999) 000-0000" className='editPhoneInput' />
                      {/*<input value={this.state.PhoneNumber} name="PhoneNumber" onChange={evt => this.chgFldValOT(evt)} className="editInputS" />*/}
                    </div>
                    <br />
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Saved Addresses</span>
                      <div className='editDDPos'>
                        <DropDownList data={this.state.SavedAddressDict} textField='Address' dataItemKey='AddressID' value={this.state.SavedAddressDict.find(c => c.AddressID === this.state.SavedAddressID)} name='SavedAddressID' onChange={evt => this.chgAddressOTDDFldVal(evt)} className='editInputDD' />
                      </div>
                      {/*  <input value={this.state.ProvinceStateID} name='ProvinceStateID' onChange={evt => this.chgFldVal(evt)} className='editInputM' />*/}
                    </div>
                  </div> : null}
                {this.state.OrderType == 2 ?
                  <div>
                    <br />
                    <span style={{ fontSize: 17,color: "blue",fontWeight: "bold" }} >&nbsp;&nbsp;PICKUP ORDER</span>
                    <br />
                    <br />
                    <h4>Requested Pickup Date and Time</h4>
                    <br />
                    <DateTimePicker name="RequestDateTime" value={this.state.RequestDateTime} onChange={evt => this.chgOTDTPickerVal(evt)} className="editDateInput" />
                    <br />
                    <br />
                    <div>
                      <FloatingLabel label="Special Instructions" style={{ width: '200px',color: 'darkblue',marginTop: '5px' }} editorId={'orderInstructions'} editorValue={this.state.orderInstructions}>
                        <Input id={'orderInstructions'} value={this.state.OrderNotes} style={{ width: '340px',height: '40px',border: 'solid 2px blue' }} onChange={evt => this.chgOTInstructions(evt)} />
                      </FloatingLabel>
                    </div>
                    <br />
                    <br />
                  </div> : null}
                {this.state.OrderType == 4 ?
                  <div>
                    <br />
                    <span style={{ fontSize: 17,color: "blue",fontWeight: "bold" }} >&nbsp;&nbsp;ORDER AT TABLE</span>
                    <br />
                    <br />
                    {this.state.TableID > 0 ?
                      <div>
                        <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp;&nbsp;Table: </span>
                        <span style={{ fontSize: 17,color: "black",fontWeight: "bold",color: SessionInfo.ECV.InputBorderColor }} >{this.state.TableName}&nbsp;&nbsp;</span>
                        <Button id="changeButton" icon="checkbox-checked" className="mediumButton" style={{ left: '0px',height: '26px',top: '30px' }} onClick={this.changeTable} >&nbsp;Change Table</Button>
                      </div>
                      :
                      <div className="getQR">
                        <div className="barcodeScannerBox">
                          <video id="scannerVideo" name="videoScan" width="300px" height="300px" margin='1' padding='1' style={{ border: '1px solid gray',}} />
                        </div>
                        <div className="scanTitleDiv">
                          <span style={{ fontSize: 19,color: 'blue',fontWeight: "bolder" }} >{this.state.ScanTitle}</span>
                        </div>
                        <Button className="mediumButton" style={{ left: '100px',right: '100px',top: '6px' }} onClick={this.cancelTableQR}>Cancel QR Scan</Button>
                      </div>}
                  </div> : null}
                {this.state.OrderType == 5 ?
                  <div>
                    <br />
                    <span style={{ fontSize: 17,color: "blue",fontWeight: "bold" }} >&nbsp;&nbsp;ORDER AHEAD</span>
                    <br />
                    <br />
                    <h4>Expected Arrival Date and Time</h4>
                    <br />
                    <DateTimePicker name="RequestDateTime" value={this.state.RequestDateTime} onChange={evt => this.chgOTDTPickerVal(evt)} className="editDateInput" />
                    <br />
                    <br />
                    <div>
                      <FloatingLabel label="Special Instructions" style={{ width: '200px',color: 'darkblue',marginTop: '5px' }} editorId={'orderInstructions'} editorValue={this.state.orderInstructions}>
                        <Input id={'orderInstructions'} value={this.state.OrderNotes} style={{ width: '340px',height: '40px',border: 'solid 2px blue' }} onChange={evt => this.chgOTInstructions(evt)} />
                      </FloatingLabel>
                    </div>
                    <br />
                  </div> : null}
              </div>
              <br />
              <br />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span> 
              <Button id="doneButton" icon="checkbox-checked" className="mediumButton" style={{ left: '95px',height: '26px',top: '580px' }} onClick={this.doneOrderType} >&nbsp;Done &nbsp;</Button>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              {this.state.setName === true && this.state.cancelAllowed === true ?
                <Button id="cancelButton" icon="cancel" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '10px',height: '20px' }} onClick={this.cancelOrder} >&nbsp;Cancel Order&nbsp;</Button> : null}
              <br />
              <br />
            </div>
          </Popup>
          {/* Verify Cancel Popup */}
          <Popup offset={this.addPopupOffset} show={this.state.showVerifyCancel} popupClass={'popupStandard'} >
            <div id="seatBox">
              <br />
              <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp;&nbsp; Cancel Order:&nbsp;</span><span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >#{SessionInfo.CustomOrderID}&nbsp;&nbsp;</span>
              <span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >{this.state.SeatName}&nbsp;&nbsp;</span> 
              <br />
              <br />
              <span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >&nbsp; &nbsp; At {this.state.TableName}&nbsp;&nbsp;</span>
              <br />
              <br />
              <Button id="verifyButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={this.verifiedCancelOrder} >&nbsp;Yes - Cancel &nbsp;</Button>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <Button id="cancelButton" icon="cancel" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={this.skipCancel} >&nbsp;No&nbsp;</Button>
              <br />
              <br />
              <br />
            </div>
          </Popup>
          {/* Bill Review and Rating Popup */}
          <Popup offset={this.billPopupOffset} show={this.state.showBillSummary} popupClass={'popupStandard'} >  {/**/}
            <div id="seatBox">
              <br />
              <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp;Bill Paid for Table:&nbsp;</span><span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >{this.state.TableName}&nbsp;&nbsp;</span>
              <br />
              <br />
              <br />
              {this.state.TotalBill > 0 ?
                <div id="div2" className="editField">
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>Total Bill: &nbsp;&nbsp;&nbsp;</span>
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{moneyFormat(this.state.TotalBill)}</span>
                </div> :
                <div id="div2" className="editField">
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>Your Bill Has Been Paid</span>
                </div>}
              {this.state.TotalTip > 0 ?
                <div id="div2" className="editField">
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>Total Tip: &nbsp;&nbsp;&nbsp;</span>
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{moneyFormat(this.state.TotalTip)}</span>
                </div> : null}
              {this.state.BillCount > 1 ?
                <div id="div2" className="editField">
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}># of Bills Paid: {this.state.PaidBills}&nbsp;of&nbsp;{this.state.BillCount}&nbsp;</span>
                </div> : null}
              <div style={{ height: "50px",paddingLeft: '6px' }}>
                <span className="editFieldLabel" style={{ fontSize: '16px' }}>Rate your experience</span>
                <br />
                <Rating value={this.state.RatingValue} name="RatingValue" selection={"continues"} className='ratingStars' defaultValue={0} max={5} onChange={evt => this.chgRateVal(evt)} />
              </div>
              <div className="editTAField">
                {/*  <FloatingLabel label="Comment on your Rating" style={{ width: '300',color: 'darkblue' }} editorId={"ServiceDescription"} editorValue={this.state.ServiceDescription} >*/}
                {/*    <TextArea id={"ServiceDescription"} name={"ServiceDescription"} value={this.state.SpecialInstruction} ariaLabelledBy={"labelID"} autoComplete="off" style={{ marginLeft: '5px', width: '95%',marginTop: '3px',resize: 'none' }} maxLength={140} onChange={evt => this.chgFldVal(evt)} className="editTAInputFull" />*/}
                {/*  </FloatingLabel>*/}
                <span className="editFieldLabel">Comment on your Rating</span>
                <br />
                <textarea value={this.state.ServiceDescription} name="ServiceDescription" autoComplete="off" style={{ marginLeft: '5px',marginTop: '3px',resize: 'none' }} onChange={evt => this.chgRateFldVal(evt)} className="editTAInputFull" />
              </div>
              <br />
              <br />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <Button id="doneButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '25px' }} onClick={this.doneComment} >&nbsp;OK&nbsp;</Button>
              <br />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
          </Popup>
          {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
          {/* Promotion Popup */}
          <Popup anchor={this.detailOptionAnchor} show={this.state.showPromo} popupClass={'popupStandard'} >
            <div id="seatBox">
              <img src={this.state.PromotionPhotoURL} width={354} height={150} style={{ marginLeft: "-3px",marginTop: "-3px" }} />
              <br />
              <div id="div2" style={{ fontSize: 20,color: "darkblue",fontWeight: "bold",paddingLeft: "20px",paddingTop: "3px" }}>
                <span >{this.state.StorePromotionName}</span>
              </div>
              <br />
              <div id="div2" style={{ fontSize: 14,color: "black",workWrap: "break-word",paddingLeft: "10px",paddingTop: "1px",paddingRight: "6px" }}>
                <span >{this.state.PromotionDescription}&nbsp;</span>
              </div>
              <br />
              <div id="div2" className="displayField">
                <span style={{ fontSize: 14,color: "black" }}>&nbsp;&nbsp;Promotion Type: </span>
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{this.state.PromotionType}</span>
              </div>
              {this.state.ItemPrice > 0 ?
                <div id="div2" className="displayField">
                  <span style={{ fontSize: 14,color: "black" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Regular Price: &nbsp;&nbsp;&nbsp;</span>
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{moneyFormat(this.state.ItemPrice)}</span>
                </div> : null}
              {this.state.DiscountAmount > 0 ?
                <div id="div2" className="displayField">
                  <span style={{ fontSize: 14,color: "black" }}>Discount Amount: &nbsp;&nbsp;&nbsp;</span>
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{moneyFormat(this.state.DiscountAmount)}</span>
                </div> : null}
              {this.state.PromotionPrice > 0 ?
                <div id="div2" className="displayField">
                  <span style={{ fontSize: 14,color: "black" }}>&nbsp;&nbsp;Promotion Price: &nbsp;&nbsp;&nbsp;</span>
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{moneyFormat(this.state.PromotionPrice)}</span>
                </div> : null}
              {this.state.MaxUseCount > 0 ?
                <div id="div2" className="displayField">
                  <span style={{ fontSize: 14,color: "black",fontWeight: "bold" }}>Maximum Use Count: {this.state.MaxUseCount}&nbsp;&nbsp;</span>
                  <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>Current Use Count: {this.state.UsedCount}&nbsp;&nbsp;</span>
                </div> : null}

              <div id="div2" className="displayField">
                <span style={{ fontSize: 14,color: "black" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Available Until: &nbsp;</span>
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{this.state.EndDateTime}</span>
              </div>

              {this.state.ComboItems.length > 0 ?
                <div className="relatedList">
                  <ListView data={this.state.ComboItems} item={this.ComboItemFormat} header={this.ComboHeader} footer={this.ComboFooter} style={{ width: "100%",backgroundColor: 'rgba(240, 240, 240, 0.75)' }} />
                </div> : null}
              <br />
              <div style={{ height: 39,width: '100%',marginTop: 5 }}>
                <span>&nbsp;&nbsp;&nbsp;</span>
                <Button id="addButton" icon="checkbox-checked" className="smallButton" onClick={(e) => { this.dbAddPromotionItemToOrder(SessionInfo.CurrentItem); }} >&nbsp;Add To Order&nbsp;</Button>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <Button id="doneButton" icon="close-outline" className="smallButton" onClick={this.donePromotion}>Back</Button>
                <span>&nbsp;&nbsp;&nbsp;</span>
              </div>
              <br />
            </div>
          </Popup>
          {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
          {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
          {/*--------------<Popup anchor={this.detailOptionAnchor} show={this.state.displayItemDetail} popupClass={'popupItemDetail'}  offset={this.popupOffset}>--------------------------------------------------*/}
          {/* Item Detail Description with Options Popup */}
          <Popup show={this.state.displayItemDetail} popupClass={'popupItemDetail'} collision={{ horizontal: "fit",vertical: "fit" }} appendTo={document.body}>
            <div className="itemSelection" onScroll={evt => this.scrollOptions(evt)}>   {/* Scrolling Div */}
              <div className="itemDetailHeader">
                <div className="optionTopInfo">
                  <div className="optionTop">
                    <div className="optionLeft">
                      <div onClick={this.cancelDetailAdd}>&nbsp; {this.backMenuPrompt}</div>
                    </div>
                    <div className="optionOrderRight">
                      <div className="optionCenterR2">
                        <ShoppingCart stroke={SessionInfo.ECV.BrandColor} count={this.state.ItemCount} />
                      </div>
                    </div>
                  </div>
                  <div className="optionTopImage">
                    {this.state.hideOptionImage == false ?
                      <div className="optionFlexPic">
                        <Avatar rounded='large' size='large' type='image' className='optionFramePic'>
                          <img src={this.state.ProductItemPhotoURL} style={{ objectFit: 'fill',}} />
                        </Avatar>
                      </div> : null}
                  </div>
                  {/*----- Header Item Description, Price, Quantity and Instructions   */}
                  <div id="div2" className="optionHeaderDesc">
                    <div className="infoDescName" >{this.state.ItemName}</div>
                    <div className="infoDescription" style={{ height: this.state.DescHeight }}>
                      <span >{this.state.ItemDescription}</span> <br />
                    </div>
                    <div style={{ height: 40,width: '100%',marginTop: 14, }}>
                      <span style={{ fontSize: 18,color: "black",marginLeft: -13,}} > &nbsp; &nbsp; Price: </span>
                      <span style={{ fontSize: 20,color: "black",fontWeight: "bold",}} > {moneyFormat(this.state.ItemPrice)}</span>
                      <NumericTextBox name="Quantity" className="NumQuantity" value={this.state.Quantity} spinners={true} step={1} title="Qty" min={0} max={20} onChange={this.changeQuantity} width="75px" style={{ marginLeft: '16px' }} />
                      {this.state.isItemChange === false ?
                        <>
                          {this.AllOptionsDone === true ?
                            <Button className="smallButton" style={{ fontSize: 16,paddingTop: 6,paddingBottom: 6,marginLeft: '16px' }} icon="edit" onClick={this.addDetailItemToOrder}>Add &nbsp;</Button> : null}
                        </>
                        :
                        <>
                          {this.state.itemChanged === true ?
                            <Button className="smallButton" style={{ fontSize: 16,paddingTop: 6,paddingBottom: 6,marginLeft: '16px' }} icon="edit" readOnly={!this.state.showInfoChange} onClick={this.changeItemOnOrder}>Save</Button> : null}
                        </>}
                    </div>
                    {this.state.OptionsPrice > 0 ?
                      <div className='optionOptionPrice'>
                        <span style={{ fontSize: 18,color: "black" }} >Options:&nbsp;</span>
                        <span style={{ fontSize: 20,color: "black",fontWeight: "bold" }} > &nbsp;{moneyFormat(this.state.OptionsPrice)}</span>
                      </div> : null}
                    <div className='optionTotalPrice'>
                      <span style={{ fontSize: 18,color: "black",marginLeft: 15,}} >Total: </span>
                      <span style={{ fontSize: 20,color: "black",fontWeight: "bold" }} >&nbsp; {moneyFormat(this.state.TotalItemPrice)}</span>
                      {this.state.PromotionPrice > 0 && this.state.PromotionPrice < this.state.ItemPrice ?
                        <span style={{ fontSize: 16,color: "blue",fontWeight: "bold" }} >&nbsp; &nbsp; &nbsp; &nbsp; Promo Price:&nbsp;{moneyFormat(this.state.PromotionPrice)}</span> : null}
                    </div>
                    <div className='optionSelect'>
                      <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp;&nbsp;&nbsp;{this.state.OptionStatus}</span>
                    </div>
                    {this.state.showInfo === true ?
                      <div className="optionInst">
                        <FloatingLabel label="Special Instructions" style={{ width: '300',color: 'darkblue' }} editorId={"SpecInstruction"} editorValue={this.state.SpecialInstruction} >
                          <TextArea id={"SpecInstruction"} name={"SpecialInstruction"} value={this.state.SpecialInstruction} ariaLabelledBy={"labelID"} autoComplete="off" style={{ width: '340px',resize: 'none' }} maxLength={140} onChange={evt => this.chgTAInfoFldVal(evt)} autoSize={true} rows={2} ariaDescribedBy={"hintID"} />
                        </FloatingLabel>
                      </div> : <br />}
                  </div>
                </div>
              </div>
              {/*----- List Section - List of OrderItems or List of Options & Related */}
              {/* Check if more than one current CustomOrderItem for this StoreItem - if true - show select-list */}
              {this.state.showChangeItems ?
                <div className="detailItemInfo">
                  <ListView data={this.state.ItemsList} item={this.ItemListFormat} style={{ width: "100%" }} header={this.ItemListHeader} footer={this.ItemListFooter} />
                  <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                  <Button className="smallButton" icon="checkmark" readOnly={!this.state.showInfo} onClick={this.addNewItemToOrder}>Add New Item</Button>
                  {/*<CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add New Item to the Order`} className="listCartAdd" onClick={(e) => this.addNewItemToOrder()} />*/}
                  <br /><div className="infoItemListAfter">&nbsp; &nbsp;</div>
                </div>
                :
                <div className="detailItemInfo">  {/* Options and Related Div - scrolling */}
                  {/*-------------------------------------------------------------------------------------------------*/}
                  {this.state.showOption[0] === true ?
                    <div ref={node => this.op0.current = node} className="optionPane" style={this.state.op0bgc}>
                      <div className="optionGroupHeader" style={this.state.op0bgc}>
                        <span className="optionGroupTitleL" > &nbsp;{this.state.optionNames[0]}</span>
                        {this.state.showOptionGrid[0] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open0Click} /></span> : null}
                        <span className="optionGroupTitleR" >{this.state.optionStates[0]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} ---  selectable={{ enabled: true, drag: false, cell: false, mode: "multiple", }}  onRowClick={this.Option0Click} */}
                      {this.state.showOptionGrid[0] === true ?
                        <Grid style={{ overflowY: "hidden" }} data={this.state.Options[0]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt0Cell }} width='30px' />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : <div name="op0" className="optionPane" />}
                    </div> : null}
                  {this.state.showOption[1] === true ?
                    <div ref={node => this.op1.current = node} className="optionPane" style={this.state.op1bgc}>
                      <div className="optionGroupHeader" style={this.state.op1bgc}>
                        <span className="optionGroupTitleL" > &nbsp;{this.state.optionNames[1]}</span>
                        {this.state.showOptionGrid[1] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open1Click} /></span> : null}
                        <span className="optionGroupTitleR" >{this.state.optionStates[1]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[1] === true ?
                        <Grid style={{}} data={this.state.Options[1]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt1Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[2] === true ?
                    <div id="op2" ref={node => this.op2.current = node} className="optionPane" style={this.state.op2bgc}>
                      <div className="optionGroupHeader" style={this.state.op2bgc}>
                        <span className="optionGroupTitleL" > &nbsp;{this.state.optionNames[2]}</span>
                        {this.state.showOptionGrid[2] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open2Click} /></span> : null}
                        <span className="optionGroupTitleR" >{this.state.optionStates[2]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[2] === true ?
                        <Grid style={{}} data={this.state.Options[2]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt2Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[3] === true ?
                    <div id="op3" ref={node => this.op3.current = node} className="optionPane" style={this.state.op3bgc}>
                      <div className="optionGroupHeader" style={this.state.op3bgc}>
                        <span className="optionGroupTitleL"> &nbsp;{this.state.optionNames[3]}</span>
                        {this.state.showOptionGrid[3] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open3Click} /></span> : null}
                        <span className="optionGroupTitleR" >{this.state.optionStates[3]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[3] === true ?
                        <Grid style={{}} data={this.state.Options[3]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt3Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[4] === true ?
                    <div id="op4" ref={node => this.op4.current = node} className="optionPane" style={this.state.op4bgc}>
                      <div className="optionGroupHeader" style={this.state.op4bgc}>
                        <span className="optionGroupTitleL"> &nbsp;{this.state.optionNames[4]}</span>
                        {this.state.showOptionGrid[4] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open4Click} /></span> : null}
                        <span className="optionGroupTitleR">{this.state.optionStates[4]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[4] === true ?
                        <Grid style={{}} data={this.state.Options[4]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt4Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[5] === true ?
                    <div id="op5" ref={node => this.op5.current = node} className="optionPane" style={this.state.op5bgc}>
                      <div className="optionGroupHeader" style={this.state.op5bgc}>
                        <span className="optionGroupTitleL"> &nbsp;{this.state.optionNames[5]}</span>
                        {this.state.showOptionGrid[5] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open5Click} /></span> : null}
                        <span className="optionGroupTitleR">{this.state.optionStates[5]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[5] === true ?
                        <Grid style={{}} data={this.state.Options[5]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt5Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[6] === true ?
                    <div id="op6" ref={node => this.op6.current = node} className="optionPane" style={this.state.op6bgc}>
                      <div className="optionGroupHeader" style={this.state.op6bgc}>
                        <span className="optionGroupTitleL"> &nbsp;{this.state.optionNames[6]}</span>
                        {this.state.showOptionGrid[6] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open6Click} /></span> : null}
                        <span className="optionGroupTitleR">{this.state.optionStates[6]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[6] === true ?
                        <Grid style={{}} data={this.state.Options[6]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt6Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[7] === true ?
                    <div id="op7" ref={node => this.op7.current = node} className="optionPane" style={this.state.op7bgc}>
                      <div className="optionGroupHeader" style={this.state.op7bgc}>
                        <span className="optionGroupTitleL"> &nbsp;{this.state.optionNames[7]}</span>
                        {this.state.showOptionGrid[7] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open7Click} /></span> : null}
                        <span className="optionGroupTitleR">{this.state.optionStates[7]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[7] === true ?
                        <Grid style={{}} data={this.state.Options[7]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt7Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[8] === true ?
                    <div id="op8" ref={node => this.op8.current = node} className="optionPane" style={this.state.op8bgc}>
                      <div className="optionGroupHeader" style={this.state.op8bgc}>
                        <span className="optionGroupTitleL" > &nbsp;{this.state.optionNames[8]}</span>
                        {this.state.showOptionGrid[8] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open8Click} /></span> : null}
                        <span className="optionGroupTitleR">{this.state.optionStates[8]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[8] === true ?
                        <Grid style={{}} data={this.state.Options[8]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt8Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {this.state.showOption[9] === true ?
                    <div id="op9" ref={node => this.op9.current = node} className="optionPane" style={this.state.op9bgc}>
                      <div className="optionGroupHeader" style={this.state.op9bgc}>
                        <span className="optionGroupTitleL"> &nbsp;{this.state.optionNames[9]}</span>
                        {this.state.showOptionGrid[9] === false ? <span> &nbsp;&nbsp;<Button className="optionOpenButton" icon="download" color="primary" onClick={this.Open9Click} /></span> : null}
                        <span className="optionGroupTitleR">{this.state.optionStates[9]} &nbsp;&nbsp;</span>
                      </div>  {/* onItemChange={this.Option1Change} */}
                      {this.state.showOptionGrid[9] === true ?
                        <Grid style={{}} data={this.state.Options[9]} size={"small"} resizable={false} selectedField="Select" scrollable="none" rowHeight={this.rowHeight} rowRender={this.rowRender}>
                          <GridColumn field="Select" title="." cells={{ data: this.BoolOpt9Cell }} width='30px' editable={false} />
                          <GridColumn field="OptionName" title="Option" width='220px' editable={false} />
                          <GridColumn field="Image" title="." cells={{ data: ImageCell }} width='40px' editable={false} />
                          <GridColumn field="Price" cells={{ data: MoneyCell }} width='90px' filter='numeric' editable={false} />
                        </Grid> : null}
                    </div> : null}
                  {/*-------------------------------------------------------------------------------------------------*/}
                  {this.state.RelatedItems.length > 0 ?
                    <>
                      <ListView data={this.state.RelatedItems} item={this.RelatedItemFormat} style={{ width: "100%",backgroundColor: 'rgba(240, 240, 240, 0.75)',}} header={this.RelatedHeader} footer={this.RelatedFooter} />
                    </> : null}
                </div>}
            </div>
          </Popup>
          {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
          {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
          {/* Main Menu Popup */}
          <Popup anchor={this.menuAnchor.current} show={this.state.showMenu} popupClass={'popupMenuO'} >
            <div className="mainMenu">
              <a id="headerLogo" style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})`,backgroundPosition: 'left top',backgroundRepeat: 'no-repeat',backgroundSize: '100px 60px' }} href="http://www.omnovos.com" target="_blank" rel="noopener noreferrer" />
              <div className="menuTree">
                <TreeView
                  data={SessionInfo.MenuControlO}
                  size='large' draggable='false' selection='single'
                  onItemClick={this.onMenuItemClick}
                  className='menuTreeSub'
                  item={props => [<span key={props.item.key} className={props.item.className}>{props.item.icon}{props.item.space}{props.item.text}</span>]}
                />
              </div>
            </div>
          </Popup>
          {/* QR Code Popup */}
          <Popup offset={this.showQRPopupOffset} show={this.state.showQRCode} popupClass={'popupQRCode'}>
            <div className="wholeDiv">
              <div className="headerScan" >
                <span style={{ fontSize: 18,color: "black",fontWeight: "bold",left: "22px",position: "absolute" }} >GUEST SCAN</span>
                <br />
                <br />
                <div style={{ fontSize: 16,color: "black",position: "relative",height: "20px" }}>
                  <span >Location</span>
                </div>
                <span style={{ fontSize: 18,color: "black",fontWeight: "bold" }} >&nbsp;{this.state.StoreName}</span>
                <br />
                <br />
                <div style={{ fontSize: 16,color: "black",position: "relative",height: "20px" }}>
                  <span >Table</span>
                </div>
                <span style={{ fontSize: 18,color: "black",fontWeight: "bold",left: "10px" }} >&nbsp;{this.state.TableName}</span>
              </div>
              <div style={{ position: "absolute",top: "125px",left: "25px" }} onClick={(e) => this.closePopups(7)}>
                <QRCode
                  value={this.QRCodeLocation}
                  errorCorrection="M"
                />
              </div>
              <div id="editField" style={{ position: "absolute",top: "270px",left: "25px" }}>
                {this.state.QRSeatName.length > 0 ?
                  <div id="clearSeatNameBtnDiv">
                    <Tooltip position="top" anchorElement="pointer">
                      <ButtonClear alt="" fill={SessionInfo.activeColor} title={`Clear Search Box`} className="functionImage" onClick={this.clearSeatName} />
                    </Tooltip>
                  </div> : null}
                <span style={{ float: 'left',paddingTop: '9px',fontSize: '12px' }}>Seat Name&nbsp;</span><br />
                <Input name={'QRSeatName'} value={this.state.QRSeatName} autoComplete="off" onChange={evt => this.chgFldValQR(evt)} className='searchInput' />
              </div>
              <div style={{ position: "absolute",top: "330px",left: "45px" }}>
                <Button id="QRDoneButton" icon="cancel" look="outline" className="mediumButton" onClick={(e) => this.closePopups(7)} >&nbsp;Done &nbsp;</Button>
              </div>
            </div>
          </Popup>
        </div>
        {/* Has BACKGROUND MENU IMAGE */}
        {SessionInfo.HasMenuImage === true ?
          <div className="orderListBG" style={{ backgroundImage: `url(${SessionInfo.BackgroundImageURL})` }} >
            {this.state.useMenuLayout1 === true ?
              <ListView data={this.state.StoreItems} item={this.StoreItemFormat1} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
              :
              <>
                {this.state.useMenuLayout2 === true ?
                  <ListView data={this.state.StoreItems} item={this.StoreItemFormat2} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                  :
                  <>
                    {this.state.useMenuLayout3 === true ?
                      <ListView data={this.state.StoreItems} item={this.StoreItemFormat3} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                      :
                      <>
                        {this.state.useMenuLayout4 === true ?
                          <ListView data={this.state.StoreItems} item={this.StoreItemFormat4} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                          :
                          <>
                            {this.state.useMenuLayout5 === true ?
                              <ListView data={this.state.StoreItems} item={this.StoreItemFormat5} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                              :
                              <>
                                {this.state.useMenuLayout6 === true ?
                                  <ListView data={this.state.StoreItems} item={this.StoreItemFormat6} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                                  :
                                  <>
                                    {this.state.useMenuLayout7 === true ?
                                      <ListView data={this.state.StoreItems} item={this.StoreItemFormat7} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                                      :
                                      <>
                                        {this.state.useMenuLayout8 === true ?
                                          <ListView data={this.state.StoreItems} item={this.StoreItemFormat8} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                                          : null}
                                      </>}
                                  </>}
                              </>}
                          </>}
                      </>}
                  </>}
              </>}
          </div>
          :
          <div className="orderListBG">
            {this.state.useMenuLayout1 === true ?
              <ListView data={this.state.StoreItems} item={this.StoreItemFormat1} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
              :
              <>
                {this.state.useMenuLayout2 === true ?
                  <ListView data={this.state.StoreItems} item={this.StoreItemFormat2} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                  :
                  <>
                    {this.state.useMenuLayout3 === true ?
                      <ListView data={this.state.StoreItems} item={this.StoreItemFormat3} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                      :
                      <>
                        {this.state.useMenuLayout4 === true ?
                          <ListView data={this.state.StoreItems} item={this.StoreItemFormat4} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                          :
                          <>
                            {this.state.useMenuLayout5 === true ?
                              <ListView data={this.state.StoreItems} item={this.StoreItemFormat5} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                              :
                              <>
                                {this.state.useMenuLayout6 === true ?
                                  <ListView data={this.state.StoreItems} item={this.StoreItemFormat6} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                                  :
                                  <>
                                    {this.state.useMenuLayout7 === true ?
                                      <ListView data={this.state.StoreItems} item={this.StoreItemFormat7} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                                      :
                                      <>
                                        {this.state.useMenuLayout8 === true ?
                                          <ListView data={this.state.StoreItems} item={this.StoreItemFormat8} footer={this.StoreItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                                          : null}
                                      </>}
                                  </>}
                              </>}
                          </>}
                      </>}
                  </>}
              </>}
          </div>}
        <div id="hdr" className="footerOrder" >
          <div className='orderFooterLeftTop'>
            <div className="orderMsg">{this.state.orderMessage}</div>
          </div>
          <div className='orderFooterLeftBot'>
            {SessionInfo.AC.HasTotals === true ?
              <>
                <span className='listName'>Cart Subtotal </span>
                <span className='listMoneyTot'>{moneyFormat(this.state.SubTotalPrice)}</span>
                {/*<br />
                <span className='listName'>Tax </span>
                <span className='listMoneyTot'>{moneyFormat(this.state.TotalTaxAmount)}</span>
                <br />
                <span className='listName'>TOTAL </span>
                <span className='listMoneyTot'>{moneyFormat(this.state.TotalPrice)}</span>*/}
              </> : null}
          </div>
          <div className='orderFooterRight'>
            {SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?
              <div className="footerCenterR2">
                <ShoppingCart stroke={SessionInfo.headingTextColor} count={this.state.ItemCount} />
              </div> : null}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(OrderPage);